// ReSharper disable InconsistentNaming
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-useless-escape */
/* eslint-disable quotes */
/* eslint-disable indent */
/* eslint-disable no-tabs */
/* eslint-disable camelcase */
export class Translations_en_US {
	static RiskTemplateNotAnyAllowedForUser = 'No any risk templates are allowed for the user!';
	static RiskAssessmentApprovalWasSuccessful = 'Assessment \'{0}\' approved successfully!';
	static FurtherEducationsMustBeDefinedBeforeAddingRecordUsers = 'Educations must be defined before adding user records!';
	static EventParameterUnitChangedFromParameterToParameter = 'Incident \'{0}\' unit changed from \'{1}\' to \'{2}\'.';
	static DataTransferError = 'Data transfer error!';
	static DeletingOpportunityParameterWasSuccessful = 'Opportunity \'{0}\' removed successfully!';
	static SavingRecordUserQualificationParameterWasNotSuccessfulConcurrencyError = 'Failed to save qualification \'{0}\', because data in the qualification has been modified concurrently by another user!';
	static EventTypeCostsReportName = 'Incidents - Costs';
	static DoYouReallyWantToRemoveSelectedKeywords = 'Do you really want to remove selected keywords?';
	static DoYouReallyWantToRemoveEventHandlerParameter = 'Do you really want to remove handler \'{0}\'?';
	static EventReceiverIsPartnerCompany = 'Incident receiver is partner company';
	static BirthDate = 'Date of Birth';
	static DraftVersion = 'Draft Version';
	static LockedRiskParameterCannotBeRestored = 'Locked risk \'{0}\' cannot be restored!';
	static ParameterIsNotValidBankBICCode = '\'{0}\' is not valid bank BIC code!';
	static DeletingMessageTypeParameterWasNotSuccessfulErrorParameter = 'Failed to remove message type \'{0}\'! Error: \'{1}\'';
	static PrintTextPublished = 'Published';
	static Saved = 'Saved By';
	static DefaultEventSettings = 'Default Incident Settings';
	static MessageTypeCodeMustBeDefined = 'Message type code must be defined!';
	static SavingRiskAssessmentParameterWasNotSuccessfulConcurrencyError = 'Failed to save assessment \'{0}\', because the data has been modified concurrently by another user!';
	static SendingNotificationsWasNotSuccessfulErrorParameter = 'Failed to send notifications! Error: \'{0}\'';
	static ForwardMessage = 'Forward';
	static RiskAssessmentPersonsInChargeMustBeDefined = 'Treatments\' person in charge must be defined!';
	static FormPlaceholder = 'Placeholder Text';
	static FormDropdownOptionsDialog = 'Dropdown Options';
	static ValidPasswordMustBeDefined = 'Valid password must be defined!';
	static AccessRightRead_EventDescription_AC = '* Can create incidents\n* Can view all incidents of the unit\n* Can be selected as incident handler\n* Can be selected as default handler and person to be notified';
	static Starts = 'Starts';
	static Reject = 'Reject';
	static ReadingFileParameterWasNotSuccessfulFileNotFound = 'Failed to read file \'{0}\' in filesystem! File not found!';
	static RiskTreatmentState = 'Treatment State';
	static PrintFirstRows = 'Print First Rows';
	static AddCompanyGroups = 'Add Company Groups';
	static CalendarTaskCategory = 'Category';
	static EventTypesReportPieChartName = 'Pie Chart';
	static EditDefaultEventHandlersAndNotifiedPersons = 'Edit Default Incident Handlers and Notified Persons';
	static CheckingExistanceOfFileParameterWasNotSuccessfulErrorParameter = 'Failed to check existance of file \'{0}\' in filesystem! Error: \'{1}\'';
	static AddBasicEducation = 'Add Basic Education';
	static DeletingEventTypeCParameterWasNotSuccessfulConcurrencyError = 'Failed to remove category 3 \'{0}\', because data in the category 3 has been modified concurrently by another user!';
	static DeletingDocumentTemplatesParameterWasNotSuccessfulErrorParameter = 'Failed to remove document templates \'{0}\'! Error: \'{1}\'';
	static DeletingDocumentTemplatesParameterWasSuccessful = 'Document templates \'{0}\' removed successfully!';
	static FormEventReferenceWarning = 'Set incident reference required data ({0}) in Properties panel!';
	static ChangingPasswordWasNotSuccessfulErrorParameter = 'Failed to change password! Error: \'{0}\'';
	static AddWhistleBlowChannelAdminsParameterWasNotSuccessfulErrorParameter = 'Failed to add administrators \'{0}\'! Error: \'{1}\'';
	static SavingRecordFamiliarizationParameterWasNotSuccessfulErrorParameter = 'Failed to save familiarization \'{0}\'! Error: \'{1}\'';
	static Success = 'Success!';
	static DriversLicenseType = 'Drivers License Type';
	static CurrentAndPreviousCalendarHalfYear = 'Current and Previous Calendar Year Half';
	static AddComment = 'Add Comment';
	static Link = 'Link';
	static RiskLevelLow = 'Low';
	static PieChart = 'Pie Chart';
	static RemoveLogisticTransportCompany = 'Remove Transport Company';
	static DefineRecordUserFurtherEducation = 'Define Education';
	static Employments = 'Employments';
	static FileNameMustBeDefined = 'File name must be defined!';
	static TaskDataRowParameterNotFound = 'Form row \'{0}\' not found!';
	static DoYouReallyWantToUnlockRiskAssessment = 'Do you really want to unlock assessment \'{0}\'?';
	static NewRecordUserMustBeSavedBeforeQualificationsCanBeAdded = 'New user record must be saved before qualifications can be added!';
	static Assessor = 'Assessor';
	static RecordUserFamiliarizationParameterNotFound = 'Familiarization \'{0}\' not found!';
	static SavingInstantMessageChannelUserWasNotSuccessfulConcurrencyError = 'Failed to save participant, because data in the participant has been modified concurrently by another user!';
	static GroupByQuarter = 'Group by Quarter';
	static DoYouReallyWantToRestoreRecordUserParameterFromArchive = 'Do you really want to restore user record \'{0}\' from archive?';
	static DeletingRiskProcessesParameterWasNotSuccessfulConcurrencyError = 'Failed to remove my classifications \'{0}\', because the data has been modified concurrently by another user!';
	static WhistleBlowEventTypeModified = 'Modified';
	static UserCodeParameterMustBeValid = 'Username must be 8-50 characters long and it cannot contain whitespaces (\'{0}\').';
	static NoEmailsToSend = 'No emails to be sent!';
	static PrivacyPolicyUrlMustBeDefined = 'Privacy policy web address must be defined!';
	static Hour = 'Hour';
	static JobTitle = 'Job Title';
	static UseObserverAction = 'Show Observer Action Field';
	static RiskApprovalListNotApproved = 'Risk Not Approved';
	static RecordUserTrangerredPropertyParameterNotFound = 'Transferred property \'{0}\' not found!';
	static Severity = 'Severity';
	static SavingTaskDataRowWasNotSuccessfulConcurrencyError = 'Failed to save the form row, because form row has been modified concurrently by another user!';
	static DeletingUserParameterWasSuccessful = 'User account \'{0}\' removed successfully!';
	static DeletingTaskTypeParameterWasNotSuccessfulErrorParameter = 'Failed to remove form template \'{0}\'! Error: \'{1}\'';
	static AccessRightRead_InstantMessage = 'Internal chats';
	static SavingEventMessageWasNotSuccessfulConcurrencyError = 'Failed to save comment, because data in the comment has been modified concurrently by another user!';
	static ArchivingRecordUserFurtherEducationsWasSuccessful = 'Educations archived successfully!';
	static AddReportTemplateFromTemplate = 'Add Report Template from Template';
	static AddPhoto = 'Add Photo';
	static ExternalSystemUserCodeMustBeDefined = 'User code in external system must be defined!';
	static Portrait = 'Portrait';
	static CopyingFolderDirectoryItemParameterToFolderParameterWasSuccessful = 'Folder \'{0}\' copied into folder \'{1}\' successfully!';
	static AddWhistleBlowCategory = 'Add Whistle Blow Category';
	static DocumentContentsSearch = 'Search Document Contents';
	static RiskLevelHigh = 'High';
	static DecreasingVersionHistorySizeRemovesCurrentlySavedVersionHistoryRecords = 'Note! Decreasing version history size removes previously saved versions from version history.';
	static ArchivingTaskParameterWasSuccessful = 'Form \'{0}\' archived successfully!';
	static AddingRecordUserFamiliarizationsWasNotSuccessfulErrorParameter = 'Failed to add familiarizations! Error: \'{0}\'';
	static SavingReadReceiptWasNotSuccessfulErrorParameter = 'Failed to save read receipt! Error: \'{0}\'';
	static AddFamiliarizations = 'Add Familiarizations';
	static OpportunityRegisterDetails = 'Opportunity Register Details';
	static ThisMessageWasDeleted = 'This message was deleted';
	static NewFurtherEducationMustBeSavedBeforeAttachmentsCanBeAdded = 'New education must be saved before attachments can be added!';
	static CompanyName = 'Company Name';
	static ExcelTemplate = 'Excel Template';
	static UserRecordStatisticsExpiringInSixMonthsQualifications = 'Qualifications Expiring in Six Months';
	static UpdateUserGroupParameterExternalSystemsWasNotSuccessfulConcurrencyError = 'Failed to link user group \'{0}\' to external systems, because the data has been modified concurrently by another user!';
	static Preview = 'Preview';
	static SendingPushNotificationsToParameter = 'Sending push notifications to user \'{0}\'...';
	static AddEventTypeC = 'Add Category 3';
	static AddEventTypeB = 'Add Category 2';
	static FormPages = 'Pages';
	static WhistleBlowEventTypeDescriptionModifiedDescription = 'Incident description modified';
	static TaskChartGroupingFieldDynamicValueFieldTypeYearly = 'User yearly value fields';
	static TimeSpanQuarter = 'Quarter';
	static DeletingTaskPrioritiesParameterWasNotSuccessfulConcurrencyError = 'Failed to remove form priorities \'{0}\', because data in form priorities has been modified concurrently by another user!';
	static WhistleBlowInformantHint = 'Please provide a thorough description of the issue so that we can investigate it further.';
	static Entrepreneur = 'Entrepreneur';
	static AccessRightWrite_TaskDescription_C = '* Can create and edit forms\n* Can fill in forms and view and edit all rows\n* Can limit form visibility\n* Can set persons in charge for forms\n* Can manage forms settings';
	static Visibility = 'Visibility';
	static RiskCategoryParameterNotFound = 'Category \'{0}\' not found!';
	static RemovingTaskTypeUnitsWasNotSuccessfulErrorParameter = 'Failed to remove units! Error: \'{0}\'';
	static RecordUserLogEntryTypeCreate = 'Create';
	static RestoringRiskParameterFromTrashBinWasSuccessful = 'Risk \'{0}\' has been restored from trash bin!';
	static Source = 'Source';
	static RemoveEventUrgencyClass = 'Remove Urgency Class';
	static RecordFurtherEducationParameterIsInUseInParameterRecordUsersQualificationsAndCannotBeDeleted = 'Education \'{0}\' is used as qualification in {1} user records and cannot be removed!';
	static AppReportTemplateModuleInfoCompanyReportTemplates = 'Company report templates. You can create new report template by clicking + button.';
	static JobLineParameterNotFound = 'Job line \'{0}\' not found!';
	static DeletingRiskAssesmentParameterWasNotSuccessfulErrorParameter = 'Failed to remove assessment \'{0}\'! Error: \'{1}\'';
	static FollowUp = 'Follow-up';
	static AccessRightWrite_InstantMessageDescription_A = '* Can start chats and group chats with users in own and linked companies\n* Can manage permissions';
	static DeletingRiskTemplateParameterWasNotSuccessfulErrorParameter = 'Failed to remove risk template \'{0}\'! Error: \'{1}\'';
	static SearchProperties = 'Advanced Search';
	static AddCompanyGroupsParameterWasNotSuccessfulErrorParameter = 'Failed to add company groups \'{0}\'! Error: \'{1}\'';
	static CopyOrMoveFolder = 'Copy or Move Folder';
	static EventPartners = 'Incident Partners';
	static Private = 'Private';
	static RestoringRiskParameterFromTrashBinWasNotSuccessfulConcurrencyError = 'Failed to restore risk \'{0}\' from trash bin, because the data has been modified concurrently by another user!';
	static AllUserGroups = 'All User Groups';
	static FormOptions = 'Options';
	static Years = 'Years';
	static Menu = 'Menu';
	static PreviewMobile = 'Preview (Mobile)';
	static AddTransferredPropertyToMultipleUserRecords = 'Add Transferred Property to Multiple User Records';
	static TypeMustBeDefined = 'Type must be defined!';
	static RemoveTaskPermanently = 'Remove Form Permanenty';
	static Archive = 'Archive';
	static RiskOwner = 'Owner';
	static NotRepeated = 'Not Repeated';
	static ExternalSystemUserTokenParameterIsAlreadyInUse = 'User token \'{0}\' is already in use!';
	static PreviewRowPrint = 'Preview (Row Print)';
	static MicrosoftLogIn = 'Sign in with Microsoft';
	static DocumentModuleInfoAutoSaveVersionHistorySize = 'Amount of previously saved versions that are retained when document is saved.';
	static RecordFurtherEducationParameterNotFound = 'Education \'{0}\' not found!';
	static SavingEventPartnerParameterWasSuccessful = 'Incident partner \'{0}\' saved successfully!';
	static FormTextAlignmentCenter = 'Align Text Center';
	static AddTarget = 'Add Target';
	static NewTransferredPropertyMustBeSavedBeforeAttachmentsCanBeAdded = 'New transferred property must be saved before attachments can be added!';
	static DaysAgo30 = '30 Days Ago';
	static AccessRightWrite_InstantMessage = 'Internal / External chats';
	static TaskStateLocked = 'Locked';
	static CalendarTaskRepetitionRepeatIntervalMonthlySuffix = 'months(s) on';
	static AddLogisticVoucherPaymentSetting = 'Add Payment Setting';
	static Color = 'Color';
	static ScopeCanBeChanged = 'Scope can be changed';
	static NewInstantMessageChannelGroup = 'New Group';
	static ImmediatelyAfterExpiration = 'Immediately after expiration';
	static DeletingCalendarTaskParameterWasNotSuccessfulConcurrencyError = 'Failed to remove event \'{0}\', because data in the event has been modified concurrently by another user!';
	static RiskRegisterDetails = 'Risk Register Details';
	static ArchivingRecordUserFurtherEducationsWasNotSuccessfulConcurrencyError = 'Failed to archive educations, because data in educations has been modified concurrently by another user!';
	static RootCause = 'Root Cause';
	static BrowseFiles = 'Browse Files';
	static AddDefaultFurtherEducation = 'Add Default Education';
	static DoYouReallyWantToRemoveSelectedRecordFurtherEducations = 'Do you really want to remove selected educations?';
	static EditMode = 'Edit';
	static EditLogisticVoucherPaymentSetting = 'Edit Payment Setting';
	static DeletingPartnerParameterWasSuccessful = 'Partner \'{0}\' removed successfully!';
	static DownloadPdf = 'Download Pdf';
	static SentEmails = 'Sent Emails';
	static WhistleBlowSourceUnspecified = 'Unspecified';
	static FormCalculatedIntegerNumber = 'Calculated Integer';
	static DeletingWhistleBlowChannelAdminParameterWasNotSuccessfulErrorParameter = 'Failed to remove administrator \'{0}\'! Error: \'{1}\'';
	static AddingAttachmentsParameterWasNotSuccessfulErrorParameter = 'Failed to add attachments \'{0}\'! Error: \'{1}\'';
	static PanelSize = 'Panel Size';
	static AddEditableDocument = 'Add Document';
	static AddingAddRecordUserQualificationsWasNotSuccessfulErrorParameter = 'Failed to add qualifications! Error: \'{0}\'';
	static AddingCalendarTaskHandlerWasNotSuccessfulErrorParameter = 'Failed to add handlers! Error: \'{0}\'';
	static SenderOrReceiver = 'Sender or Receiver';
	static RecordUserFamiliarizationApprovalWasNotSuccessfulConcurrencyError = 'Failed to approve user record familiarization, because the approver has been modified concurrently by another user!';
	static Category = 'Category';
	static UserIsWhistleBlowChannelAdminAndCannotBeDeleted = 'User is whistle blow channel administrator and cannot be deleted!';
	static DeletingTaskStateParameterWasNotSuccessfulErrorParameter = 'Failed to remove form state \'{0}\'! Error: \'{1}\'';
	static CreatingUserTokenWasNotSuccessfulErrorParameter = 'Failed to password change token! Error: \'{0}\'';
	static FormSizeMedium = 'Medium';
	static OldPasswordIsIncorrect = 'Old password is incorrect!';
	static TaskRepetitionType = 'Form Repetition';
	static PasteGroupPermissions = 'Paste Group Permissions from Memory';
	static DeletingRiskAssesmentsParameterWasNotSuccessfulErrorParameter = 'Failed to remove assessments \'{0}\'! Error: \'{1}\'';
	static DocumentModulePropertiesSaveWasSuccessful = 'Document settings saved successfully!';
	static Last5Years = 'Last 5 Years';
	static NoAddedEventTypeCs = 'No added categories!';
	static NoAddedEventTypeBs = 'No added categories!';
	static OtherRiskTemplates = 'Other Risk Templates';
	static LoginTitle = 'Log in to PKY-LAATU Intra';
	static Modification = 'Modification';
	static EditCompanyGroup = 'Edit Company Group';
	static AddingReportTemplateUnitsWasSuccessful = 'Units added successfully!';
	static PrintTextPrinted = 'Printed';
	static InstantMessageChannelGroupInternal = 'Group (company internal)';
	static Continue = 'Continue';
	static DirectCosts = 'Direct Costs';
	static Draft = 'Draft';
	static ReportParameterNotFound = 'Report \'{0}\' not found!';
	static DocumentIsEmpty = 'The document is empty!';
	static AccessRightRead_CalendarTask = 'Limited edit access';
	static TrendingFlat = 'Trending Flat';
	static EventMessageConfirmation = 'Do you want to save new comment?';
	static SavingEditableDocumentParameterWasSuccessful = 'Document \'{0}\' saved successfully!';
	static SavingReportTemplateParameterWasSuccessful = 'Report template \'{0}\' saved successfully!';
	static EventHandlerParameterNotFound = 'Handler \'{0}\' not found!';
	static FolderMustBeEmptyBeforeItCanBeRemoved = 'Folder must be empty before it can be removed!';
	static WhistleBlowChannel = 'Whistle Blow Channel';
	static DoYouReallyWantToRemoveSelectedRecordBasicEducations = 'Do you really want to remove selected basic educations?';
	static EditDefaultTaskPriority = 'Edit Default Form Priority';
	static Days = 'days';
	static DeletingOpportunityParameterWasNotSuccessfulErrorParameter = 'Failed to remove opportunity \'{0}\'! Error: \'{1}\'';
	static FormPageBreak = 'Page Break';
	static AccessRightRead_Event = 'Create and view own';
	static RemoveMessage = 'Remove Message';
	static SendTime = 'Send Time';
	static SavingReportParameterWasNotSuccessfulErrorParameter = 'Failed to save report \'{0}\'! Error: \'{1}\'';
	static CopyActiveUserRightsToAllSameLevelFolders = 'Copy Active Permissions to All Same Level Folders';
	static RemoveUserGroup = 'Remove User Group';
	static Courses = 'Courses';
	static DoYouReallyWantToRemoveSelectedTaskPriorities = 'Do you really want to remove selected form priorities?';
	static EmailAddressDoesNotExist = 'Email address does not exist!';
	static SaveEvent = 'Save Incident';
	static NextAssessmentDate = 'Next Assessment Date';
	static FormAddOption = 'Add Option';
	static SavingDocumentTemplateParameterWasNotSuccessfulErrorParameter = 'Failed to save document template \'{0}\'! Error: \'{1}\'';
	static DocumentApproval = 'Document Approval';
	static DeletingRecordUserPartnerParameterWasSuccessful = 'Resource partner \'{0}\' removed successfully!';
	static ApproveEvent = 'Approve Event';
	static FileFilter = 'File Filter';
	static RemoveMessageType = 'Remove Message Type';
	static ArchivingOpportunityParameterWasNotSuccessfulConcurrencyError = 'Failed to archive opportunity \'{0}\', because the data has been modified concurrently by another user!';
	static DeletingDirectoryItemDocumentParameterWasNotSuccessfulConcurrencyError = 'Failed to remove file \'{0}\',  because data in the file has been modified concurrently by another user!';
	static TimeSpanHalfYear = 'Half Year';
	static ZipFileParameterNotFound = 'Zip file \'{0}\' not found!';
	static SavingReportWasNotSuccessfulConcurrencyError = 'Failed to save report, because data in the report has been modified concurrently by another user!';
	static PublishingReportParameterWasSuccessful = 'Report \'{0}\' published successfully!';
	static WhistleBlowInformant = 'Informant';
	static SaveAndPublish = 'Save and Publish';
	static AutomaticLogoutDone = 'Automatic logout done due to expired user session!';
	static DeletingCompanyGroupsParameterWasNotSuccessfulConcurrencyError = 'Failed to remove company groups \'{0}\', because the data has been modified concurrently by another user!';
	static ClearSubUnitPermissions = 'Clear Subunit Permissions';
	static DefaultFurtherEducationGroup = 'Default Education Group';
	static AddPartnersParameterWasSuccessful = 'Partners \'{0}\' added successfully!';
	static UserAccountNotConnected = 'User Account Not Connected';
	static MovingReportParameterToTrashBinWasSuccessful = 'Report \'{0}\' has been moved to trash bin!';
	static SelectEventInListToSeeThePreview = 'Select incident in list to see the preview';
	static DeletingReportTemplateParameterWasNotSuccessfulErrorParameter = 'Failed to remove report template \'{0}\'! Error: \'{1}\'';
	static SharedBy = 'Shared by';
	static Publish = 'Publish';
	static LoginCompany = 'Login Company';
	static IpAddress = 'IP Address';
	static Characters = 'Characters';
	static RecurringCalendarTaskMustHaveAtLeastOneOccurence = 'Recurring event must have at least one occurence!';
	static EventTypesReportBarChartByTimeName = 'Bar Chart - By Time';
	static DoYouReallyWantToRemoveRemainderParameter = 'Do you really want to remove remainder \'{0}\'?';
	static Week = 'Week';
	static ImportUserDialogInstruction = 'Upload excel file to import user accounts or download excel template where you can fill user account information.';
	static CopyPermissionToAllSameLevelFolders = 'Copy Permission to All Same Level Folders';
	static QrCodeAuthenticationTimeoutDay = '24 hours';
	static AddUserGroupsParameterWasNotSuccessfulConcurrencyError = 'Failed to add user groups \'{0}\', because the data has been modified concurrently by another user!';
	static RiskCategoriesMustBeDefinedBeforeAddingRisks = 'Categories must be defined before adding risks!';
	static SavingReportTemplateParameterWasNotSuccessfulConcurrencyError = 'Failed to save report template \'{0}\', because data in the report template has been modified concurrently by another user!';
	static FormColumnWidthMobile = 'Column Width in Mobile App';
	static Image = 'Image';
	static AddDefaultFurtherEducationGroup = 'Add Default Education Group';
	static AddUserGroupParameterWasNotSuccessfulErrorParameter = 'Failed to add user group \'{0}\'! Error: \'{1}\'';
	static SavingFileFilterParameterWasSuccessful = 'File filter \'{0}\' saved successfully!';
	static LoggedInCompanyCannotBeDeleted = 'Company cannot remove itself!';
	static DeletingMessageTypeParameterWasSuccessful = 'Message type \'{0}\' removed successfully!';
	static TransferredProperties = 'Transferred Properties';
	static DoYouReallyWantToRemoveOpportunityParameterPermanently = 'Do you really want to permanently remove opportunity \'{0}\'? Removed opportunity cannot be restored.';
	static SavingUserParameterWasSuccessful = 'User \'{0}\' saved successfully!';
	static SelectCustomer = 'Select Customer';
	static AdministratorUserCodeMustBeDefined = 'Username of the administrator must be defined!';
	static UserEndDateMustBeDefined = 'Validity expires must be defined!';
	static JobDataIsEmpty = 'Job data is missing!';
	static ReadReceiptMessage = 'Message that requires read receipt';
	static EmptyForm = 'Empty Form';
	static AdvancePaymentReportPath = 'Advance Payment Report Path';
	static DirectoryItemDocumentParameterNotFound = 'File \'{0}\' not fond!';
	static PrintGenerationFailed = 'Failed to create print!';
	static EmptyingReportTrashBinWasSuccessful = 'Report trash bin is now empty!';
	static SavingFilterWasNotSuccessfulErrorParameter = 'Failed to save filter! Error: \'{1}\'';
	static EmailNotificationOfChangedPublishStatus = 'Notify When Published State Changes by Email';
	static EventUrgencyClass = 'Urgency Class';
	static Loading = 'Loading...';
	static DoYouReallyWantToRemoveReportParameterPermanently = 'Do you really want to permanently remove report \'{0}\'? Removed report cannot be restored.';
	static ArchivingReportParameterWasNotSuccessfulErrorParameter = 'Failed to archive report \'{0}\'! Error: \'{1}\'';
	static FolderParameterNotFound = 'Folder \'{0}\' not found!';
	static DoYouReallyWantToRemoveSharedPanelParameter = 'Do you really want to remove shared panel \'{0}\'?';
	static MessageTypeClass = 'Message Class';
	static DoYouReallyWantToRemoveSelectedTaskTypes = 'Do you really want to remove selected form templates?';
	static TaskChartGroupingFieldGroupingType = 'Grouping Basis';
	static SavingEventUrgencyClassParameterWasNotSuccessfulErrorParameter = 'Failed to save urgency class \'{0}\'! Error: \'{1}\'';
	static PermissionToCreateEvents = 'Permission to Create Incidents';
	static UnpublishingOpportunityParameterWasNotSuccessfulErrorParameter = 'Failed to unpublish opportunity \'{0}\'! Error: \'{1}\'';
	static OpenCalendarTask = 'Open Event';
	static RestoringInstantMessageWasNotSuccessfulErrorParameter = 'Failed to restore instant message! Error: \'{0}\'';
	static PermissionsForSection = 'Section Permissions';
	static DocumentModuleInfoFolderPermissions = 'Access rights to folders/documents. The parent folder must have at least read access for the subfolder to be visible to the user. Access can be granted to QR code users.';
	static SaveUserFurtherEducation = 'Save Education';
	static CostCentreName = 'Cost Centre Name';
	static WhistleBlowStatisticsNewRecords = 'New Reports';
	static RowInformation = 'Row Information';
	static RemovePrint = 'Remove Print';
	static AddUserParameterWasNotSuccessfulErrorParameter = 'Failed to add user account \'{0}\'! Error: \'{1}\'';
	static AddingAttachmentsParameterWasSuccessful = 'Attachments \'{0}\' added successfully!';
	static FormulaAbs = 'Absolute value';
	static RemoveRiskProcess = 'Remove My Classification';
	static LockedTaskParameterCannotBeRestored = 'Locked form \'{0}\' cannot be restored!';
	static BasicEducation = 'Basic Education';
	static NewRecordUserMustBeSavedBeforeFamiliarizationsCanBeAdded = 'New user record must be saved before familiarizations can be added!';
	static DoYouReallyWantToRemoveSelectedEventUrgencyClasses = 'Do you really want to remove selected urgency classes?';
	static CurrentCalendarWeek = 'Current Calendar Week';
	static ChangingPasswordWasNotSuccessfulConcurrencyError = 'Failed to change password, because user data has been modified concurrently by another user!';
	static AddRiskCategory = 'Add Category';
	static EventTypeCostsReportBarChartIndirectCostsByCategoryName = 'Bar Chart - Indirect Costs - By Category';
	static RemoveFamiliarization = 'Remove Familiarizations';
	static Total = 'Total';
	static AppReportDashboard = 'Reports';
	static UnitMustBeSelected = 'Unit must be selected!';
	static Impact = 'Impact';
	static CreatingCompressedFileWasNotSuccessfulErrorParameter = 'File compression failed! Error: \'{0}\'';
	static WhistleBlowAnonymousReport = 'Report anonymously';
	static DeletingPartnerParameterWasNotSuccessfulErrorParameter = 'Failed to remove partner \'{0}\'! Error: \'{1}\'';
	static DeletingInstantMessageUsersParameterWasNotSuccessfulErrorParameter = 'Failed to remove participants \'{0}\'! Error: \'{1}\'';
	static DeletingRiskProcessParameterWasNotSuccessfulConcurrencyError = 'Failed to remove my classification \'{0}\', because the data has been modified concurrently by another user!';
	static ArchivingRecordUserFamiliarizationsWasNotSuccessfulConcurrencyError = 'Failed to archive further familiarizations, because data in familiarizations has been modified concurrently by another user!';
	static DeletingTaskTypesParameterWasNotSuccessfulConcurrencyError = 'Failed to remove form templates \'{0}\', because data in form templates has been modified concurrently by another user!';
	static AddRiskProcess = 'Add My Classification';
	static CalendarTaskHandlers = 'Visibility';
	static DateField = 'Date Field';
	static TargetCompany = 'Target Company';
	static SelectInstantMessageChannelUsers = 'Select Participants';
	static DoYouReallyWantToRemoveKeywordParameterItIsUsedByParameterDocuments = 'Do you really want to remove keyword \'{0}\'? Keyword used in {1} files/documents.';
	static ApproveEventHandlerConfirmation = 'Remedial actions have not been defined. Do you really want to approve the incident?';
	static TimeMustBeDefined = 'Time must be defined!';
	static AddRiskStakeholder = 'Add Stakeholder';
	static WhistleBlowSeverityCritical = 'Critical';
	static Language = 'Language';
	static AddUser = 'Add User Account';
	static DeletingMetadataFromFileParameterFailed = 'Failed to remove metadata from file \'{0}\'!';
	static RiskControlsPlaceholder = 'Describe the current means of preventing, reducing or limiting the risk.';
	static AppReportModuleInfoPermissions = 'Visibility and access rights for reports. Access can be granted to QR code users.';
	static AccessRightRead_Task_BC = 'Fill access (all)';
	static CalendarTaskStartDateMustBeDefined = 'Event start time must be defined!';
	static Sender = 'Sender';
	static CalendarTaskStateFinished = 'Finished';
	static RemoveReportPermanently = 'Remove Report Permanently';
	static ChartOrTableType = 'Chart/Table Type';
	static DeletingRecordFamiliarizationsParameterWasNotSuccessfulConcurrencyError = 'Failed to remove familiarizations \'{0}\',  because data in familiarizations has been modified concurrently by another user!';
	static DeletingUserGroupParameterWasNotSuccessfulConcurrencyError = 'Failed to remove user group \'{0}\', because data in the user group has been modified concurrently by another user!';
	static UpdateCompanyExternalSystemsWasNotSuccessfulConcurrencyError = 'Failed to link company to external systems, because the data has been modified concurrently by another user!';
	static EditRecordUser = 'Edit User Record';
	static DeletingCalendarTaskCategoriesParameterWasNotSuccessfulErrorParameter = 'Failed to remove categories \'{0}\'! Error: \'{1}\'';
	static RemovingRiskAssessmentHandlersWasSuccessful = 'Persons removed successfully!';
	static PicturesAreVisibleForAllCompanyUsers = 'Pictures are visible for all company users';
	static ArchivingWhistleBlowsParameterWasSuccessful = 'Whistle blow reports \'{0}\' archived successfully!';
	static FileSynchronizationToDatabaseFinishedInParameterSeconds = 'Filesystem synchronization with database completed (duration: {0:N0}s, errors: {1}, folders: {2}, folders without errors: {3})';
	static RecordUserLogEntryTypeOpen = 'Reading';
	static ReminderHourBefore = 'hour before';
	static SelectTaskPriority = 'Select Form Priority';
	static NewVersionAvailable = 'New application version available! Application cannot be used before it is updated.';
	static UpdateUserParameterExternalSystemsWasNotSuccessfulConcurrencyError = 'Failed to link user \'{0}\' to external systems, because the data has been modified concurrently by another user!';
	static TaskStateParameterIsInUseInParameterTasksAndCannotBeDeleted = 'Form state \'{0}\' is used in {1} forms and cannot be removed!';
	static EventsToApprove = 'Events to approve';
	static OptionCodeIsAlreadyInUse = 'System option code \'{0}\' is already in use!';
	static EditQrCodeUser = 'Edit QR Code User Account';
	static AppReportModuleInfoUnits = 'By creating units, you can set the visibility and access rights of reports on a unit-by-unit basis.';
	static AccessRightWrite_RecordDescription = 'Can read and edit all records in the unit';
	static FormulaRemainder = 'Remainder';
	static UserParameterCodeIsAlreadyInUse = 'User parameters code is already in use!';
	static AddInstantMessageUserParameterWasNotSuccessfulErrorParameter = 'Failed to add participant \'{0}\'! Error: \'{1}\'';
	static WhistleBlowNewReport = 'New Report';
	static SavingRecordBasicEducationParameterWasSuccessful = 'Basic education \'{0}\' saved successfully!';
	static WorkTimeType = 'Work Time Type';
	static FormulaTan = 'Tangent';
	static DeletingEventTypeCParameterWasNotSuccessfulErrorParameter = 'Failed to remove category 3 \'{0}\'! Error: \'{1}\'';
	static SavingTaskParameterWasNotSuccessfulConcurrencyError = 'Failed to save form \'{0}\', because form has been modified concurrently by another user!';
	static FormRemoveColumnFromRowConfirmation = 'Do you really want to remove column from row?';
	static FormDocumentReferenceIsNotSet = 'Document reference is not set!';
	static ClosedPlural = 'Closed';
	static Print = 'Print';
	static UserFilterInActive = 'Not in use';
	static ChangingPasswordWasSuccessful = 'Password changed successfully!';
	static SavingMessageTypeParameterWasNotSuccessfulConcurrencyError = 'Failed to save message type \'{0}\', because data in the message type has been modified concurrently by another user!';
	static AddUnit = 'Add Unit';
	static UserUnapprovedFamiliarization = 'I Have Not Approved Familiarization';
	static DeletingRecordQualificationsParameterWasNotSuccessfulErrorParameter = 'Failed to remove qualifications \'{0}\'! Error: \'{1}\'';
	static DeletingRiskCategoriesParameterWasNotSuccessfulConcurrencyError = 'Failed to remove risk categories \'{0}\', because the data has been modified concurrently by another user!';
	static UnpublishingRiskParameterWasNotSuccessfulConcurrencyError = 'Failed to unpublish risk \'{0}\', because the data has been modified concurrently by another user!';
	static ClassParameterHasNotBeenInitialized = 'Class \'{0}\' has not bee initialized!';
	static UserIsActiveInWeb = 'User account is active in web application.';
	static Unread = 'Unread';
	static CompanyThatIsInUseCannotBeDeleted = 'Company that is in the state \'In use\', cannot be removed!';
	static RecordFurtherEducationCodeMustBeDefined = 'Education name must be defined!';
	static RenewPersonalization = 'Personalization';
	static Documents = 'Documents';
	static RecordUserSettings = 'Archiving';
	static NewCompanyMustBeSavedBeforePartnersCanBeAdded = 'New company must be saved before partners can be added!';
	static RecordFamiliarizationParameterIsInUseInParameterRecordUsersAndCannotBeDeleted = 'Familiarization \'{0}\' is used in {1} user records and cannot be removed!';
	static WhistleBlowInformantMessages = 'Informant Messages';
	static ChangeSystemLanguageToFinnish = 'Change Language to Finnish';
	static NameIsAlreadyInUse = 'Name is already in use!';
	static Filter = 'Filter';
	static RiskCategoryCodeIsAlreadyInUse = 'Category name is already in use!';
	static NotAssigned = 'Not Assigned';
	static SelectSharedPanel = 'Select Shared Panel';
	static TaskChartValueFieldCalculationTypeMax = 'Maximum';
	static SavingRiskCategoryParameterWasNotSuccessfulErrorParameter = 'Failed to save risk category \'{0}\'! Error: \'{1}\'';
	static AccessRightNone = 'No access';
	static RiskStakeholders = 'Stakeholders';
	static AddDefaultTaskPriority = 'Add Default Form Priority';
	static DeletingInstantMessageChannelParameterWasNotSuccessfulConcurrencyError = 'Failed to remove chat \'{0}\', because data in the instant message channel has been modified concurrently by another user!';
	static EInvoiceOperator = 'E-invoice Operator';
	static RemoveTarget = 'Remove Target';
	static DeletingInstantMessageWasNotSuccessfulErrorParameter = 'Failed to remove instant message! Error: \'{0}\'';
	static NotifiedPersonsShort = 'Notifications';
	static WriteMessage = 'Write Message';
	static AddFile = 'Add File';
	static UserApproved = 'I Have Approved';
	static WhistleBlowStatisticsUnreadMessages = 'Unread Messages';
	static DisableExternalIntraSystemConfirmation = 'Do you really want to disable company from the system? Company will be removed from the system when the company is saved.';
	static LogisticVoucherCustomers = 'Customers';
	static ValidityDate = 'Validity Date';
	static SavingChartWasNotSuccessfulConcurrencyError = 'Failed to save chart, because data in the chart has been modified concurrently by another user!';
	static UserGroupAll = '\'All Users\'';
	static AddRecordUser = 'Add User Record';
	static TaskDataRows = 'Rows';
	static RemoveTaskPriority = 'Remove Form Priority';
	static LoggedInUserCannotBeDeleted = 'User cannot remove himself/herself!';
	static RemovingRiskTemplateUnitsWasSuccessful = 'Units removed successfully!';
	static LockedTaskDataRowCannotBeDeleted = 'Locked form row cannot be removed!';
	static LockedOpportunityParameterCannotBeDeleted = 'Locked opportunity \'{0}\' cannot be removed!';
	static RiskTemplateCodeIsAlreadyInUse = 'Risk template name is already in use!';
	static DeletingWhistleBlowCategoryParameterWasNotSuccessfulErrorParameter = 'Failed to remove whistle blow category \'{0}\'! Error: \'{1}\'';
	static Instructions = 'Instructions';
	static Document = 'Document';
	static DeletingRecordFurtherEducationsParameterWasNotSuccessfulErrorParameter = 'Failed to remove educations \'{0}\'! Error: \'{1}\'';
	static DefaultDeductionWithoutTax = 'Default Deduction (VAT 0%)';
	static EditWhistleBlow = 'Edit Whistle Blow Report';
	static DaysAgo90 = '90 Days Ago';
	static SavingCalendarTaskCategoryParameterWasSuccessful = 'Category \'{0}\' saved successfully!';
	static WhistleBlowFrontPage = 'Front Page';
	static SavingDirectoryItemPermissionsNotSuccessfulErrorParameter = 'Failed to save folder permissions! Error: \'{0}\'';
	static SharedDocumentTemplate = 'Shared Document Template';
	static RecordUserModuleInfoPermissions = 'Access rights are set per unit. Access to user records can be denied, limited to the user’s own card, or extended to all records within the unit. Access cannot be granted to QR code users.';
	static SavingUserParameterWasNotSuccessfulConcurrencyError = 'Failed to save user \'{0}\', because user data has been modified concurrently by another user!';
	static WhistleBlowDescriptionEditReasonMustBeDefined = 'Edit reason must be defined!';
	static SelectVisibility = 'Select Visibility';
	static InstantMessageUserInvitationAcceptTypeCanInvite = 'I can be invited to join chat';
	static TheUserDoesNotHavePermissionsForThisSystem = 'User does not have permission to use this system!';
	static AddCalendarTaskCategory = 'Add Category';
	static MiddleName = 'Middle Name';
	static ForLastParameterDays = 'for last {0} days';
	static SavingReportWasSuccessful = 'Report saved successfully!';
	static RemoveDefaultHandler = 'Remove Default Handler';
	static Open = 'Open';
	static TaskChartGroupingFieldGroupingTypeDayOfWeek = 'Day of the fWeek';
	static CalendarTaskStateStarted = 'Started';
	static SelectCompany = 'Select Company';
	static UnitChangedFromParameterToParameter = 'Unit changed from \'{0}\' to \'{1}\'.';
	static TransportCompanies = 'Transport Companies';
	static ReportTemplates = 'Report Templates';
	static Drafts = 'Drafts';
	static DeletingReportParameterWasNotSuccessfulErrorParameter = 'Failed to remove report \'{0}\'! Error: \'{1}\'';
	static CalendarTaskParameterNotFound = 'Event \'{0}\' not found!';
	static CompanyToken = 'Company Token';
	static Education = 'Education';
	static SavingWhistleBlowCategoryParameterWasNotSuccessfulErrorParameter = 'Failed to save whistle blow category \'{0}\'! Error: \'{1}\'';
	static SavingCalendarTaskParameterWasNotSuccessfulErrorParameter = 'Failed to save event \'{0}\'! Error: \'{1}\'';
	static WhistleBlowActiveReports = 'Active Reports';
	static AddDefaultBasicEducation = 'Add Default Basic Education';
	static TaxNumber = 'Tax Number';
	static LanguageFinnish = 'Finnish';
	static UserReports = 'User record reports';
	static DeletingPartnerParameterWasNotSuccessfulConcurrencyError = 'Failed to remove partner \'{0}\', because the data has been modified concurrently by another user!';
	static DoYouReallyWantToRemoveFormParameter = 'Do you really want to remove form \'{0}\'?';
	static FormDocumentReferenceIsIsInvalid = 'Document reference is invalid!';
	static DeletingEventTypeParameterWasSuccessful = 'Category 1 \'{0}\' removed successfully!';
	static Traceability = 'Traceability';
	static AccessRightRead_InstantMessageDescription_A = '* Can start chats and group chats with own company users\n* Can manage permissions';
	static EditEvent = 'Edit Incident';
	static LockedOpportunityParameterCannotBeArchived = 'Locked opportunity \'{0}\' cannot be archived!';
	static EventHandlersExcelTitle = 'Handlers (x = approved)';
	static IndirectCosts = 'Indirect Costs';
	static MaximumSizeOfAttachmentThatCanBeAddedInBatchIsParameterMB = 'Maximum total size of attachments that can be added in batch is {0} MB!';
	static NotificationSettings = 'Notification Settings';
	static EventTypeParameterIsInUseInParameterEventsAndCannotBeDeleted = 'Category 1 \'{0}\' is used in {1} incidents and cannot be removed!';
	static AtLeastOneFormOptionMustBeDefined = 'At least one option must be defined!';
	static Paste = 'Paste';
	static FormComponents = 'Components';
	static FormDate = 'Date';
	static TaskChartGroupingFieldGroupingTypeYear = 'Year';
	static SavingCompanyParameterWasNotSuccessfulConcurrencyError = 'Failed to save company \'{0}\', because data in the company has been modified concurrently by another user!';
	static RequireReadReceipt = 'Requires Read Receipt';
	static FirstName = 'First Name';
	static Layout = 'Layout';
	static PermissionDeniedForOperation = 'Permission denied for operation!';
	static CurrentCalendarHalfYear = 'Current Calendar Year Half';
	static EmptyRiskManagementTrashBinConfirmation = 'Do you really want to permanently remove all risks and opportunities from trash bin? Removed risks and opportunities cannot be restored.';
	static TaskDataRowTotalTypeLineCount = 'Row count';
	static SelectInstantMessageChannelType = 'Select Chat Type';
	static NewRow = 'New Row';
	static CustomStyleClass = 'Custom Style Class Name';
	static Relation = 'Relation';
	static DeletingFolderParameterWasNotSuccessfulErrorParameter = 'Failed to remove folder \'{0}\' in filesystem! Error: \'{1}\'';
	static AddTransferredProperty = 'Add Transferred Property';
	static OK = 'Ok';
	static FolderName = 'Folder Name';
	static EventApprovalWasNotSuccessfulConcurrencyError = 'Failed to approve incident, because the handler has been modified concurrently by another user!';
	static FileUploadWasSuccessful = 'Files uploaded successfully!';
	static FileNameConstainsIllegalCharacters = 'File name contains forbidden characters (<, >, :, ", /, \, |, ? or *) or ends with forbidden character (., \' \')!';
	static TimeSpanTwoYears = 'Two Years';
	static UserEndDateMustBeLessOrEqualToParameter = 'Validity expires must be less or equal to \'{0}\'!';
	static SavingEventParameterWasSuccessful = 'Incident \'{0}\' saved successfully!';
	static OpenCalendarTasks = 'Open events';
	static RiskTraceabilityHigh = 'Requires Action';
	static MaximumSizeOfInstantMessageAttachmentIsParameterMB = 'Maximum size of instant message attachment is  {0} MB!';
	static EventTypesReportName = 'Incidents - Category 1';
	static RemoveFurtherEducation = 'Remove Education';
	static Camera = 'Camera';
	static Order = 'Order';
	static TaskDataRowFieldParameterNotFoundInDataSchema = 'Form row field \'{0}\' not found in data schema!';
	static RiskMatrix = 'Risk Matrix';
	static Folders = 'Folders';
	static ACopy = 'Copy';
	static SSRSRefreshStarted = 'SSRS refresh started';
	static FormWidthMobile = 'Width in Mobile App';
	static SelectReceiver = 'Select Receiver';
	static DoYouReallyWantToRemoveCompanyGroupParameter = 'Do you really want to remove company group \'{0}\'?';
	static SSRSParameterReportsFetched = '{0} reports fetched from SSRS';
	static DeletingMessageParameterWasSuccessful = 'Message \'{0}\' removed successfully!';
	static EditableDocumentPublishUnapprovedConfirmation = 'Do you want to publish unapproved document to file?';
	static RecordUserHasBeenArchived = 'User record has been archived';
	static DeletingRiskAssesmentsParameterWasNotSuccessfulConcurrencyError = 'Failed to remove assessments \'{0}\', because the data has been modified concurrently by another user!';
	static DeletingRecordFurtherEducationParameterWasSuccessful = 'Education \'{0}\' removed successfully!';
	static RemoveFileFilter = 'Remove File Filters';
	static DeletingDirectoryItemDocumentParameterWasNotSuccessfulErrorParameter = 'Failed to remove file \'{0}\'! Error: \'{1}\'';
	static ImportingUsersParameterWasNotSuccessfulErrorParameter = 'Failed to import user accounts \'{0}\'! Error: \'{1}\'';
	static DoYouWantToAddThisApplicationToHomeScreen = 'Do you want to add this application to home screen?';
	static RemoveKeyword = 'Remove Keyword';
	static SavingReportParameterWasNotSuccessfulConcurrencyError = 'Failed to save report \'{0}\', because data in the report has been modified concurrently by another user!';
	static QrCodeAuthenticationTimeout = 'User Session Lifetime';
	static WhistleBlowResolutionTypeMustBeDefined = 'Resolution must be defined! You can also set resolution description.';
	static SavingTaskPriorityParameterWasNotSuccessfulConcurrencyError = 'Failed to save form priority \'{0}\', because data in the form priority has been modified concurrently by another user!';
	static RemoveEventHandler = 'Remove Handler';
	static SavingRiskStakeholderParameterWasNotSuccessfulErrorParameter = 'Failed to save stakeholder \'{0}\'! Error: \'{1}\'';
	static RecordParameterUnlockingFailedRecordIsWriteLockedToUserParameter = 'Failed to unlock record \'{0}\'! The record is write locked to user \'{0}\'!';
	static EnableExternalIntraSystemConfirmation = 'Do you really want to enable company in the system? Company data will be saved to the system when the company is saved.';
	static UnkownErrorHasBeenOccured = 'Uknown error has been occured in the system!';
	static RiskImpact4 = 'Major';
	static FieldParameterContainsInvalidCompanyCodeCharacters = 'Value of the field \'{0}\' contains characters that are illegal in company code (., &, :, \' \', ö, ä, à, å, Ö, Ä, À tai Å)!';
	static OtherSettings = 'Other Properties';
	static EventSettingsParameterNotFound = 'Incident settings \'{0}\' not found!';
	static Competency = 'Competency';
	static NewRecordUserMustBeSavedBeforeFurtherEducationsCanBeAdded = 'New user record must be saved before educations can be added!';
	static SharedTaskTypes = 'Shared Form Templates';
	static WhistleBlowSeverityVeryLow = 'Very Low';
	static LanguageNonLocalSwedish = 'Svenska';
	static Admin = 'Administrator';
	static TaskPriorityCodeIsAlreadyInUse = 'Form priority name is already in use!';
	static AddCompanyParameterWasSuccessful = 'Company \'{0}\' added successfully!';
	static Continuous = 'Continuous';
	static TrainingEndDateCannotPrecedeTrainingStartDate = 'End date cannot precede start date!';
	static DoYouReallyWantToRemoveTaskDataRow = 'Do you really want to remove row?';
	static FormDefaultValue = 'Default Value';
	static DeletingRecordFamiliarizationsParameterWasNotSuccessfulErrorParameter = 'Failed to remove familiarizations \'{0}\'! Error: \'{1}\'';
	static DoYouReallyWantToRemoveSelectedRiskCategories = 'Do you really want to remove selected risk categories?';
	static ActiveState = 'State';
	static ArchivingReportParameterWasSuccessful = 'Report \'{0}\' archived successfully!';
	static CkickToChangeThePicture = 'Click to change the picture';
	static SelectTaskDataRowTotalType = 'Select summary row value';
	static Comments = 'Comments';
	static DeletingUserGroupUsersOfCompanyParameterWasNotSuccessfulConcurrencyError = 'Failed to remove user group connections related to company \'{0}\', because data in those user group connections has been modified concurrently by another user!';
	static RowForm = 'Row Form';
	static FormShowCreateUser = 'Show Create User';
	static LockedReportParameterCannotBeMovedToTrashBin = 'Locked report \'{0}\' cannot be moved to trash bin!';
	static NoAddedEventTypes = 'No added categories!';
	static FormCalculatedField = 'Calculated';
	static RiskStandardsInUse = 'Standards are in use';
	static DoYouReallyWantToRemoveRecordFamiliarizationParameter = 'Do you really want to remove familiarization \'{0}\'?';
	static FormSizeExtraLarge = 'Extra Large';
	static InstantMessageAttachmentFolderIsNotSpecified = 'Application instant message attachment folder is not specified!';
	static SavingTaskDataRowWasSuccessful = 'The form row saved successfully!';
	static DocumentsSelected = 'documents selected';
	static VersionParameterPublishedAsPdfFile = 'Version {0} is published to pdf file';
	static PaymentSetting = 'Payment Setting';
	static AccessRightWrite_Message_A = 'Extended edit access';
	static PageBreakBetweenGroups = 'Add page break between groups';
	static EditUserGroup = 'Edit User Group';
	static WhistleBlowResolutionRejected = 'Rejected';
	static Archived = 'Archived';
	static DeletingMessageTypesParameterWasNotSuccessfulConcurrencyError = 'Failed to remove message types \'{0}\', because data in message types has been modified concurrently by another user!';
	static Settings = 'Settings';
	static Months = 'Months';
	static FormDocumentReference = 'Documents';
	static FormEventReference = 'Incidents';
	static NewRiskMustBeSavedBeforeRiskAssessmentsCanBeAdded = 'New risk must be saved before assessments can be added!';
	static InstantMessageModuleInfoPermissions = 'Visibility and access rights of the HoxUp discussion channel. Access cannot be granted to QR code users.';
	static LockedRiskAssessmentParameterCannotBeSaved = 'The assessment \'{0}\' has been locked to another user and it cannot be saved!';
	static SavingChartWasSuccessful = 'Chart saved successfully!';
	static AccessRightRead_InstantMessageDescription = 'Can start chats and group chats with own company users';
	static WhistleBlowEventTypeRead = 'Read';
	static DeletingRecordUserParameterWasNotSuccessfulConcurrencyError = 'Failed to remove user record \'{0}\', because data in the user record has been modified concurrently by another user!';
	static FormulaDivision = 'Division';
	static SelectArchivingMethod = 'Select Archiving Method';
	static ExitingInstantMessageChannelWasSuccessful = 'Chat exited successfully!';
	static DoYouReallyWantToRemoveDocumentParameter = 'Do you really want to remove file/document \'{0}\'?';
	static PrintRow = 'Print Row';
	static MessageParameterNotFound = 'Message \'{0}\' not found!';
	static Likelihood = 'Likelihood';
	static DoYouReallyWantToEmailMessageParameter = 'Do you really want to send message \'{0}\' by email? Message can be sent by email only once.';
	static FormNormalText = 'Text';
	static PublishVoucherInOutReportToFileSystem = 'Publish Voucher Summary Print to File System';
	static VoucherSavePath = 'Voucher Save Path';
	static DeletingWhistleBlowCategoryParameterWasSuccessful = 'Whistle blow category \'{0}\' removed successfully!';
	static RemoveParameterDocuments = 'Remove {0} Files/Documents';
	static DeletingWhistleBlowParameterWasNotSuccessfulErrorParameter = 'Failed to remove whistle blow report \'{0}\'! Error: \'{1}\'';
	static InstantMessageChannelArchivingType = 'Handling of Archived Chat';
	static ParameterMonthsAfterExpiration = '{0} months after expiration';
	static EventModuleProperties = 'Incidents Properties';
	static DoYouWantToReplaceExistingSharedPanelParameter = 'Do you want to replace existing shared panel \'{0}\'?';
	static DefaultEventTypes = 'Default Categories 1';
	static DoYouReallyWantToUnlockMessage = 'Do you really want to unlock message \'{0}\'?';
	static DeletingEventPartnerParameterWasNotSuccessfulErrorParameter = 'Failed to remove incident partner \'{0}\'! Error: \'{1}\'';
	static PrintRecordUser = 'Print User Record';
	static SavingDirectoryItemDocumentParameterWasNotSuccessfulErrorParameter = 'Failed to save file \'{0}\'! Error: \'{1}\'';
	static DeletingOneTimePasswordWasSuccessful = 'One time password removed successfully!';
	static UserRecordWillBeSharedWithCompanyParameter = 'If user account is connected to user record, the user record will be shared with company \'{0}\'.';
	static DeletingRiskStakeholdersParameterWasNotSuccessfulConcurrencyError = 'Failed to remove stakeholders \'{0}\', because the data has been modified concurrently by another user!';
	static AssessorMustBeDefined = 'Assessor must be defined!';
	static ErrorUserGroupChangeWouldLeadToInvalidDefaultEventHandlers = 'User group changes will lead to situation where some default incident handlers or notified persons do not have permissions to handle incidents of units. Changes that have affect for default incident handlers or notified persons can be made only in \'Incidents Properties\' dialog!';
	static AddCompaniesParameterWasNotSuccessfulErrorParameter = 'Failed to add companies \'{0}\'! Error: \'{1}\'';
	static NewPanel = 'New Panel';
	static SavingRecordUserTransferredPropertyParameterWasSuccessful = 'Transferred property \'{0}\' saved successfully!';
	static SearchCondition = 'search criteria';
	static AddQrCodeUser = 'Add QR Code User Account';
	static CopyOrMoveFilesDocuments = 'Copy or Move Selected Files/Documents';
	static RestoringRiskParameterFromArchiveWasNotSuccessfulErrorParameter = 'Failed to restore risk \'{0}\' from archive! Error: \'{1}\'';
	static MessageVisibilityPeriodNotActive = 'Message visibility period not active!';
	static EditPayerSettings = 'Edit Payer Settings';
	static WeekAbbr = 'wk';
	static RemoveUserGroupExternalSystemsWasNotSuccessfulErrorParameter = 'Failed to remove user group links from external systems! Error: \'{0}\'';
	static SavingEventTypesWasNotSuccessfulErrorParameter = 'Failed to save category 1! Error: \'{0}\'';
	static WhistleBlowCategoryParameterNotFound = 'Whistle blow category \'{0}\' not found!';
	static AddPartnerCompanies = 'Add partners that content can be shared to';
	static ReminderWeeksBefore = 'weeks before';
	static RemoveRowConfirmation = 'Do you really want to remove row {0}?';
	static AddFurtherEducation = 'Add Education';
	static OldestModification = 'Oldest Modification';
	static DeletingRiskStandardsParameterWasNotSuccessfulConcurrencyError = 'Failed to remove standards \'{0}\', because the data has been modified concurrently by another user!';
	static FormDecimals = 'Decimals';
	static KeywordParameterNotFound = 'Keyword \'{0}\' not found!';
	static FormSizeDefault = 'Default';
	static RiskDescriptionPlaceholder = 'Describe the risk, its implementation status, and possible impacts or consequences.';
	static ReadError = 'Read error!';
	static Search = 'Search';
	static SavingUserGroupParameterWasSuccessful = 'User group \'{0}\' saved successfully!';
	static InvalidValueParameter = 'Invalid value \'{0}\'!';
	static DocumentCreated = 'Created By';
	static PanelSize5 = '3 x 1';
	static AddToHomeScreen = 'Add to Home Screen';
	static Rows = 'rows';
	static DocumentNameConstainsIllegalCharacters = 'Document name contains forbidden characters (<, >, :, ", /, \, |, ? or *) or ends with forbidden character (., \' \')!';
	static TaskChartValueFieldCalculationTypeSum = 'Sum';
	static AddingCalendarTaskHandlersWasSuccessful = 'Handlers added successfully!';
	static HasAttachments = 'Has Attachments';
	static ExternalSystemCodeClaimNotFound = 'User claim \'externalSystemCode\' not found!';
	static DeletingRecordBasicEducationsParameterWasNotSuccessfulErrorParameter = 'Failed to remove basic educations \'{0}\'! Error: \'{1}\'';
	static DocumentRootPath = 'Document Root Path';
	static SelectRecordUsers = 'Select User Records';
	static DeletingEventParameterWasNotSuccessfulErrorParameter = 'Failed to remove incident \'{0}\'! Error: \'{1}\'';
	static Month = 'Month';
	static DeletingTaskTypesParameterWasSuccessful = 'Form templates \'{0}\' removed successfully!';
	static AttachmentParameterNotFound = 'Attachment \'{0}\' not found!';
	static CalendarTaskChangeSelectedDateToSeeTheTasks = 'Change selected date or state filter to see the events';
	static WhistleBlowChannelWasNotFoundExplanation = 'Check the internet address that was entered in the address bar of the browser.';
	static AccessRightWrite_Risk_A = 'Edit and settings access';
	static UserPasswordMustBeDefined = 'User password must be defined!';
	static FamiliarizationIsApprovedByUser = 'User has approved the familiarization';
	static CalendarTaskHandlerFilter = 'Handler';
	static LanguageSwedish = 'Swedish';
	static ValueAddedTaxPercent = 'Value Added Tax %';
	static EmptyReportTrashBin = 'Empty Report Trash Bin';
	static DeletingRecordBasicEducationParameterWasSuccessful = 'Basic education \'{0}\' removed successfully!';
	static MovingFolderDirectoryItemParameterToFolderParameterWasSuccessful = 'Folder \'{0}\' moved into folder \'{1}\' successfully!';
	static SelectUnit = 'Select Unit';
	static AddChildEventTypeC = 'Add Subcategory 3';
	static EditableDocumentParameterNotFound = 'Document \'{0}\' not found!';
	static StandardFiltersAndReports = 'Standard Filters and Reports';
	static GroupByUnit = 'Group by Unit';
	static DoYouReallyWantToRemoveTaskParameterPermanenty = 'Do you really want to permanently remove form \'{0}\'? Removed form cannot be restored?';
	static AddingWhistleBlowHandlersWasSuccessful = 'Handlers added successfully!';
	static Weekly = 'Weekly';
	static AddRiskTemplate = 'Add Risk Template';
	static ReadingFolderParameter = 'Reading folder \'{0}\'...';
	static DoYouReallyWantToPublishAppReportParameter = 'Do you really want to publish report \'{0}\'?';
	static CompanyCodeContainsIllegalCharacters = 'Company code contains characters that are illegal (., &, :, \' \', ö, ä, à, å, Ö, Ä, À tai Å)!';
	static TrainingStartDateStart = 'Start Date - Start';
	static Published = 'Published';
	static WhistleBlowStatisticsResolvedRecords = 'Resolved Reports';
	static RemoveTask = 'Remove Form';
	static AddPayer = 'Add Payer';
	static AccessRightNone_UserGroupDescription = 'No access to user groups';
	static Publisher = 'Published By';
	static TheUserNameOrPasswordIsIncorrect = 'Invalid username or password!';
	static DoYouReallyWantToRemoveInstantMessageChannelParameter = 'Do you really want to remove chat \'{0}\'?';
	static AddUserParameterWasSuccessful = 'User account \'{0}\' added successfully!';
	static TrainingStartDateEnd = 'Start Date - End';
	static StateOpen = 'Open';
	static FurtherEducationGroupParameterNotFound = 'Education group \'{0}\' not found!';
	static Effectiveness = 'Effectiveness';
	static FormDataReference = 'References to eSalkku Data';
	static FormulaFloor = 'Rounded to down';
	static Closed = 'Closed';
	static Keywords = 'Keywords';
	static DoYouReallyWantToRemoveSelectedRiskProcesses = 'Do you really want to remove selected my classifications?';
	static FieldParameterValueMustBeDefined = 'Value of the field \'{0}\' must be defined!';
	static AddWhistleBlowChannelAdminParameterWasSuccessful = 'Administrator \'{0}\' added successfully!';
	static SavingUnitsWasSuccessful = 'Units saved successfully!';
	static AddInstantMessageUsersParameterWasSuccessful = 'Participants \'{0}\' added successfully!';
	static RestoringReportParameterFromArchiveWasSuccessful = 'Report \'{0}\' has been restored from archive!';
	static FormMaximumValue = 'Maximum Value';
	static OptionParameterNotFound = 'System option \'{0}\' not found!';
	static AdditionalPermissionBWhistleBlow = 'Permission management';
	static InstantMessageChannelInternal = 'Company Internal';
	static RemoveCompanyGroup = 'Remove Company Group';
	static DoYouReallyWantToRemoveRecordFurtherEducationParameter = 'Do you really want to remove education \'{0}\'?';
	static AddPartner = 'Add Partner';
	static DeletingRecordUserEmploymentParameterWasSuccessful = 'Employment \'{0}\' removed successfully!';
	static AddRows = 'Add Rows';
	static DeletingRiskStandardParameterWasNotSuccessfulConcurrencyError = 'Failed to remove standard \'{0}\', because the data has been modified concurrently by another user!';
	static SaveCalendarTaskConfirmation = 'Do you want to save the event?';
	static RiskTraceabilityLow = 'Acceptable';
	static DeletingKeywordParameterWasNotSuccessfulErrorParameter = 'Failed to remove keyword \'{0}\'! Error: \'{1}\'';
	static AccessRightRead_LogDescription = 'Can read the company’s log entries';
	static Operation = 'Operation';
	static Assessments = 'Assessments';
	static EditableDocument = 'Document';
	static UpdateCompanyExternalSystemsWasSuccessful = 'Company linked to external systems successfully!';
	static CompanyThatIsRelatedToExternalEventsCannotBeDeleted = 'Company that has sent or received incidents with another company, cannot be removed!';
	static PreviousCalendarYear = 'Previous Calendar Year';
	static LockedTaskDataRowCannotBeSaved = 'The form row has been locked to another user and it cannot be saved!';
	static ImportingTaskDataRowsWasSuccessful = 'Rows imported successfully!';
	static LockedOpportunityParameterCannotBeMovedToTrashBin = 'Locked opportunity \'{0}\' cannot be moved to trash bin!';
	static RiskProcessesMustBeDefinedBeforeAddingRisks = 'My classifications must be defined before adding risks!';
	static RecordFamiliarizationParameterNotFound = 'Familiarization \'{0}\' not found!';
	static ChartValueCalculation = 'Value Calculation in Group';
	static RemoveTaskHandler = 'Remove Person';
	static EditEventPartner = 'Edit Incident Partner';
	static Recurrence = 'Recurrence';
	static TreatmentTargetDate = 'Target Date';
	static Time = 'Time';
	static SavingEventTypeCParameterWasSuccessful = 'Category 3 \'{0}\' saved successfully!';
	static AddToFavorites = 'Add to Favorites';
	static UserRecordStatisticsExpiringInSixMonthsFamiliarizations = 'Familiarizations Expiring in Six Months';
	static CompanyGroupCodeMustBeDefined = 'Code of the company group must be defined!';
	static SendEmailInvitation = 'Send Invitation to System by Email ';
	static NewInstantMessageChannel = 'New Chat';
	static AccessRightRead_Event_A = 'Create, handle and view own';
	static SavingDirectoryItemPermissionsWasSuccessful = 'Folder permissions saved successfully!';
	static SelectTaskRepetitionType = 'Select Form Repetition';
	static SavingJobParameterWasNotSuccessfulErrorParameter = 'Failed to save job \'{0}\'! Error: \'{1}\'';
	static EventTypesReportTableByTimeName = 'Table - By Time';
	static MessageTypesMustBeDefinedBeforeAddingMessages = 'Message types must be defined before adding messages!';
	static SendingEmailToParameter = 'Sending email to user \'{0}\' to address \'{1}\'...';
	static SavingDirectoryItemFolderParameterWasNotSuccessfulErrorParameter = 'Failed to save folder \'{0}\'! Error: \'{1}\'';
	static WhistleBlowDoesNotContainAnyMessage = 'No any messages are written to whistle blow report.';
	static SavingRiskSettingWasNotSuccessfulConcurrencyError = 'Failed to save risk settings, because the data has been modified concurrently by another user!';
	static PermissionsForSections = 'Sections in Use';
	static Schema = 'Schema';
	static DefaultEventHandlersAndNotifiedPersons = 'Default Incident Handlers and Notfications';
	static CalendarTaskCategories = 'Categories';
	static FormulaHypot = 'Hypotenuse';
	static RiskModuleInfoRiskTemplates = 'Company risk templates. You can create new risk template by clicking + button.';
	static JobParameterNotFound = 'Job \'{0}\' not found!';
	static DeletingCompanyParameterWasNotSuccessfulErrorParameter = 'Failed to remove company \'{0}\'! Error: \'{1}\'';
	static Number = 'Number';
	static Opportunity = 'Opportunity';
	static NormalMessage = 'Normal message';
	static ByDate = 'By Date';
	static FormTitlePage = 'Title Page';
	static AddImage = 'Add Image';
	static UserRecords = 'User Records';
	static SavingPrintWasNotSuccessfulConcurrencyError = 'Failed to save print \'{0}\', because data in the print has been modified concurrently by another user!';
	static DeletingWhistleBlowChannelAdminParameterWasNotSuccessfulConcurrencyError = 'Failed to remove administrator \'{0}\', because the data has been modified concurrently by another user!';
	static EditableDocumentApproveConfirmation = 'Do want to approve the document?';
	static SavingRecordUserTransferredPropertyParameterWasNotSuccessfulErrorParameter = 'Failed to save transferred property \'{0}\'! Error: \'{1}\'';
	static SelectReportInListToSeeThePreview = 'Select raport in list to see the preview';
	static WhistleBlowSourceEmail = 'Email';
	static LockedReportParameterCannotBeArchived = 'Locked report \'{0}\' cannot be archived!';
	static ParameterPercentOfFileStorageQuotaUsed = '{0}% of file storage quota used';
	static DefaultFurtherEducation = 'Default Education';
	static AddCalendarTask = 'Add Event';
	static Approved = 'Approved';
	static AddChildRiskStakeholder = 'Add Substakeholder';
	static AddingRecordUserFamiliarizationHandlerWasNotSuccessfulErrorParameter = 'Failed to add approvers! Error: \'{0}\'';
	static WorksWell = 'Works Well';
	static AccessRightWrite_MessageDescription_A = 'Can create, edit and publish messages in the unit’s Current topics and read messages published by partners';
	static UserFirstNameMustBeDefined = 'User first name must be defined!';
	static SavingSharedPanelWasSuccessful = 'Shared panel saved successfully!';
	static EventTypeCCodeMustBeDefined = 'Category 3 name must be defined!';
	static EditEditableDocument = 'Edit Document';
	static ToggleArchivedFurtherEducations = 'Show/Hide Archived Educations';
	static PublicationOfEditableDocumentCannotBeRemoved = 'Publication of the document cannot be removed!';
	static Action = 'Action';
	static SelectDocument = 'Select Document';
	static MaximumSizeOfDocumentThatCanBeAddedInBatchIsParameterMB = 'Maximum total size of documents that can be added in batch is {0} MB!';
	static NoFavoritesToShow = 'No favorites to show!';
	static Max = 'Max';
	static TaskDataRow = 'Form Row';
	static Path = 'Path';
	static SendingPusNotificationsWasNotSuccessfulErrorParameter = 'Failed to send push notifications! Error: \'{0}\'';
	static EditWhistleBlowChannel = 'Edit Whistle Blow Channel';
	static UserSessionHasBeenExpired = 'User session has been expired!';
	static UserAccountMustBeSelected = 'User account must be selected!';
	static GeneralAttachments = 'General Attachments';
	static AdditionalPermissionAWhistleBlow = 'Can communicate with informant';
	static DeletingRiskProcessesParameterWasSuccessful = 'My classifications \'{0}\' removed successfully!';
	static SavingEventTypeParameterWasNotSuccessfulConcurrencyError = 'Failed to save category 1 \'{0}\', because data in the category 1 has been modified concurrently by another user!';
	static FormPrint = 'Print';
	static SharedReports = 'Shared Reports';
	static RiskProcess = 'My Classification';
	static InstantMessageChannelUser = 'Participant';
	static DeletingRecordUserParameterWasNotSuccessfulErrorParameter = 'Failed to remove user record \'{0}\'! Error: \'{1}\'';
	static EventTypeCParameterIsInUseInParameterEventsAndCannotBeDeleted = 'Category 3 \'{0}\' is used in {1} incidents and cannot be removed!';
	static UserGroupNameIsAlreadyInUse = 'User group name is already in use!';
	static ApplicationName = 'eSalkku';
	static AccessRightRead_MessageDescription = 'Can read published messages in the unit’s Current topics';
	static SelectDocumentTemplate = 'Select Document Template';
	static EditKeyword = 'Edit Keyword';
	static DeletingRecordUserTransferredPropertyParameterWasNotSuccessfulErrorParameter = 'Failed to remove transferred property \'{0}\'! Error: \'{1}\'';
	static ClosedEvent = 'Closed The Incident';
	static DoYouReallyWantToRemoveSelectedReportTemplates = 'Do you really want to remove selected report templates?';
	static EventUrgencyClassParameterNotFound = 'Urgency class \'{0}\' not found!';
	static MessageVisibilityPeriodNotStarted = 'Message visibility period not started!';
	static DeletingReportTemplatesParameterWasSuccessful = 'Report templates \'{0}\' removed successfully!';
	static ApproveEventResolution = 'Approve Incident Resolution';
	static CloseSystem = 'Close the System';
	static DoYouReallyWantToUnlockReport = 'Do you really want to unlock report \'{0}\'?';
	static WebPushError = 'Web Push Error';
	static UserModuleInfoQrCodeUserGroup = 'For QR user group access rights can be to Current Topics, Calendar, Documents, Incidents, Forms and Report sections.';
	static SendPasswordChangeEmailConfirmation = 'Do you really want to send password change link by email?';
	static AddNew = 'Add New';
	static UnitNameMustBeDefined = 'Unit name must be defined!';
	static DoYouReallyWantToRemoveFileParameter = 'Do you really want to remove file \'{0}\'?';
	static PersonalIdentityCode = 'Personal Identity Code';
	static MoveDown = 'Move Downwards';
	static IgnoreFolderPatterns = 'Ignore Folders Pattern';
	static RestoringOpportunityParameterFromArchiveWasNotSuccessfulConcurrencyError = 'Failed to restore opportunity \'{0}\' from trash bin, because the data has been modified concurrently by another user!';
	static FormRowColumn = 'Row Column';
	static LogOut = 'Log Out';
	static SavingUserParametersWasNotSuccessfulErrorParameter = 'Failed to save user options! Error: \'{0}\'';
	static SavingEventPartnerParameterWasNotSuccessfulConcurrencyError = 'Failed to save incident partner \'{0}\', because data in the incident partner has been modified concurrently by another user!';
	static FormDatesAndTimes = 'Dates and Times';
	static EventTypeBCodeIsAlreadyInUse = 'Category 2 name is already in use!';
	static DoYouReallyWantToUnlockRisk = 'Do you really want to unlock risk \'{0}\'?';
	static AccessRightRead_AppReportDescription = 'Can read published reports';
	static PreviousCalendarWeek = 'Previous Calendar Week';
	static Trigonometry = 'Trigonometry';
	static SavingRiskProcessParameterWasSuccessful = 'My classification \'{0}\' saved successfully!';
	static DeletingDefaultEventHandlerParameterWasSuccessful = 'Default incident handler \'{0}\' removed successfully!';
	static EmailNotificationInUse = 'I Want to Receive Email Notifications';
	static ChooseHowYouWantToReport = 'Choose how you want to report';
	static Favorites = 'Favorites';
	static WhistleBlowEventTypeAttachmentsAdded = 'Attachments added';
	static WhistleBlowState = 'Report State';
	static UpdateUserGroupParameterExternalSystemsWasSuccessful = 'User group \'{0}\' linked to external systems successfully!';
	static Download = 'Download';
	static TaskLockingType = 'Locking';
	static AddChildRiskCategory = 'Add Subcategory';
	static RecordUserExcelSalary = 'Salary';
	static Line = 'Line';
	static AddCompanyParameterWasNotSuccessfulErrorParameter = 'Failed to add company \'{0}\'! Error: \'{1}\'';
	static EditTaskState = 'Edit Form State';
	static UnitIsRelatedToEventPartner = 'Unit is related to incident partner';
	static DeletingRiskTemplatesParameterWasNotSuccessfulErrorParameter = 'Failed to remove risk templates \'{0}\'! Error: \'{1}\'';
	static IdCard = 'Identity Card';
	static DefaultCalendarTaskCategories = 'Default Categories';
	static SomeInstantMessageUsersHaveReadMessage = 'Some recipients have read your message';
	static SendEmailInvitationConfirmation = 'Do you really want to send invitation to system by email?';
	static FormCodeMustBeDefined = 'Form code must be defined!';
	static DefaultReportTemplates = 'Default Report Templates';
	static RecordUserActiveStateChangePermissionDeniedInUnitParameter = 'Archived state change is not allowed in unit \'{0}\'!';
	static RiskStakeholdersMustBeDefinedBeforeAddingRisks = 'Stakeholders must be defined before adding risks!';
	static RenamingFolderParameterWasNotSuccessfulErrorParameter = 'Failed to rename folder (\'{0}\' => \'{1}\') in filesystem! Error: \'{2}\'';
	static AddingTaskHandlerWasNotSuccessfulErrorParameter = 'Failed to add persons! Error: \'{0}\'';
	static MessageTypeCodeIsAlreadyInUse = 'Message type code is already in use!';
	static AddCompany = 'Add Company';
	static DoYouReallyWantToRemoveTaskHandlerParameter = 'Do you really want to remove handler \'{0}\'?';
	static FormExpressionFormatMinutesToHoursAndMinutes = 'From minutes to hours and minutes';
	static EventHandlers = 'Handlers';
	static TaskDefaultStatesInUse = 'Default states in use';
	static Entry = 'Entry';
	static AddLogisticVoucherCompanyPaymentSetting = 'Add Payment Setting';
	static TaskStateCodeIsAlreadyInUse = 'Form state name is already in use!';
	static AccessRightRead = 'Read access';
	static AddRiskStandard = 'Add Standard';
	static SelectCalendarTaskHandlers = 'Select handlers';
	static RiskStandardParameterHasChildNodesAndCannotBeDeleted = 'Standard \'{0}\' contains substandards and cannot be removed!';
	static WhistleBlowRecords = 'Records';
	static ArchivingTaskParameterWasNotSuccessfulErrorParameter = 'Failed to archive form \'{0}\'! Error: \'{1}\'';
	static InstantMessageChannelArchivingTypeKeepMessages = 'Preserve Archived Chat and Messages';
	static NameMustBeDefined = 'Name must be defined!';
	static AllDataValuesAreZeroOrUndefined = 'All data values are zero!';
	static ApprovalDate = 'Approval Date';
	static AddAtleastOneInstantMessageChannelUsersToInstantMessageChannel = 'Add at least one participant to the chat!';
	static NowRows = 'Now Rows';
	static AllUsersOfTheUnit = 'All users of the unit';
	static RemovingRiskTemplateUnitsWasNotSuccessfulErrorParameter = 'Failed to remove units! Error: \'{0}\'';
	static FormDateFieldIsNotSelected = 'Date field has not been selected!';
	static EventTypeCodeMustBeDefined = 'Category 1 name must be defined!';
	static DeletingDirectoryItemFolderParameterWasSuccessful = 'Folder \'{0}\' removed successfully!';
	static DeletingWhistleBlowChannelAdminsParameterWasSuccessful = 'Administrators \'{0}\' removed successfully!';
	static EmploymentEndDate = 'Employment End Date';
	static ComparingFileSystemToDatabase = 'Comparing file system with database...';
	static DeletingEventParameterWasNotSuccessfulConcurrencyError = 'Failed to remove incident \'{0}\', because data in the incident has been modified concurrently by another user!';
	static AddTaskHandler = 'Add Person';
	static AllCompanyGroups = 'All Company Groups';
	static RecordEmailNotificationTypeLine2 = 'The report contains data from all user records that ara visible for user';
	static DeletingRecordBasicEducationsParameterWasNotSuccessfulConcurrencyError = 'Failed to remove basic educations \'{0}\',  because data in basic educations has been modified concurrently by another user!';
	static EditMessageType = 'Edit Message Type';
	static DoYouReallyWantToRemoveRecordFurtherEducationGroupParameter = 'Do you really want to remove education group \'{0}\'?';
	static InternalAttachments = 'Internal Attachments';
	static SelectEventHandler = 'Select Handler';
	static LargeSize = 'Large Size';
	static ArchivingRiskParameterWasNotSuccessfulConcurrencyError = 'Failed to archive risk \'{0}\', because the data has been modified concurrently by another user!';
	static LockingEditableDocumentParameterWasNotSuccessful = 'Failed to lock document \'{0}\'!';
	static SavingRiskParameterWasNotSuccessfulConcurrencyError = 'Failed to save risk \'{0}\', because the data has been modified concurrently by another user!';
	static SaveAndEmail = 'Save and Email';
	static AType = 'Type';
	static AccessRightNone_CompanyDescription = 'o No access to company information or settings';
	static CalendarTask = 'Event';
	static DocumentsNotFound = 'Documents not found!';
	static FormCreateDate = 'Create Date';
	static UserNotAllowedToViewNotifier = 'Limited report handling: User not allowed to view notifier.';
	static SelectRiskInListToSeeThePreview = 'Select risk in list to see the preview';
	static EmailAddressMustBeValid = 'Email address is not valid email address!';
	static FormDecimalNumber = 'Decimal';
	static RemoveUserGroupExternalSystemsWasNotSuccessfulConcurrencyError = 'Failed to remove user group links from external systems, because the data has been modified concurrently by another user!';
	static InstantMessageChannelOnlyAdministratorCannotExitInstantMessageChannel = 'Only chat administrator cannot exit the chat!';
	static ThisMessageWasDeletedByInstantMessageChannelAdministrator = 'This message was deleted by administrator, \'{0}\'';
	static SavingUserParameterParameterWasSuccessful = 'User option \'{0}\' saved successfully!';
	static DoYouReallyWantToSaveData = 'Do you really want to save?';
	static WhistleBlowInformantMustBeNotifiedLatestAtParameter = 'Whistle blow report must be marked as resolved {0} at the latest!';
	static SavingApplicationPermissionsWasNotSuccessfulErrorParameter = 'Failed to save system permissionsi! Virhe: \'{0}\'';
	static SavingEventDefaultHandlerParameterWasNotSuccessfulErrorParameter = 'Failed to save default incident handler \'{0}\'! Error: \'{1}\'';
	static DefaultLanguage = 'Language';
	static EmailAddress = 'Email';
	static DeletingKeywordsParameterWasSuccessful = 'Keywords \'{0}\' removed successfully!';
	static RemovingCalendarTaskHandlerWasNotSuccessfulErrorParameter = 'Failed to remove handlers! Error: \'{0}\'';
	static SavingRecordEmploymentParameterWasNotSuccessfulErrorParameter = 'Failed to save employment \'{0}\'! Error: \'{1}\'';
	static SavingEditableDocumentParameterApprovalWasNotSuccessfulErrorParameter = 'Failed to approve document \'{0}\'! Error: \'{1}\'';
	static DocumentApproved = 'Approved By';
	static PanelVisible = 'Panel Visible';
	static Unlimited = 'Unlimited';
	static RiskContainsOpportunity = 'Risk Contains Opportunity';
	static ReadingFileParameterWasNotSuccessfulErrorParameter = 'Failed to read file \'{0}\' in filesystem! Error: \'{1}\'';
	static City = 'City';
	static DefaultTaskTypes = 'Default Form Templates';
	static CalendarTaskRepetitionCountPrefix = 'After';
	static InstantMessageChannelContainsParameterInstantMessageUsersAndCannotBeDeleted = 'Chat has other participants and cannot be removed!';
	static NewEmploymentMustBeSavedBeforeAttachmentsCanBeAdded = 'New employment must be saved before attachments can be added!';
	static ExitingInstantMessageChannelWasNotSuccessfulConcurrencyError = 'Failed to exit the chat, because data in the chat has been modified concurrently by another user!';
	static ExternalSystemCode = 'Code in System';
	static MovingOpportunityParameterToTrashBinWasNotSuccessfulConcurrencyError = 'Failed to move opportunity \'{0}\' to trash bin, because the data has been modified concurrently by another user!';
	static FileParameterDownloaded = 'File \'{0}\' has been downloaded.';
	static ResetDocumentVersion = 'Reset Document Version';
	static TaskHandlers = 'Limited Visibility';
	static Last7Days = 'Last 7 Days';
	static FormCheckbox = 'Checkbox';
	static DeletingEditableDocumentParameterWasNotSuccessfulConcurrencyError = 'Failed to remove document \'{0}\', because data in the document has been modified concurrently by another user!';
	static RiskCategory = 'Category';
	static AddingAddRecordUserFurtherEducationsWasNotSuccessfulErrorParameter = 'Failed to add educations! Error: \'{0}\'';
	static CompanyLogo = 'Company Logo';
	static DaysAgo120 = '120 Days Ago';
	static OpportunityIsModifiedAfterItWasPublished = 'Opportunity has been modified after it was published.';
	static AccessRightNone_AppReportDescription = 'No access to reports';
	static Copy = 'Copy';
	static AddDocumentTemplate = 'Add Document Template';
	static PrintParameterDownloaded = 'Print has been downloaded.';
	static MovingReportParameterToTrashBinWasNotSuccessfulConcurrencyError = 'Failed to move report \'{0}\' to trash bin, because data in the report has been modified concurrently by another user!';
	static PasswordIsTooShort = 'Password is too short!';
	static RiskProcessParameterNotFound = 'My classification \'{0}\' not found!';
	static WhistleBlowAnonymityAnonymous = 'Anonymous';
	static DoYouReallyWantToRemoveRiskProcessParameter = 'Do you really want to remove my classification \'{0}\'?';
	static NoneSelected = 'None Selected';
	static OpportunityBenefitMustBeDefined = 'Opportunity benefit must be defined!';
	static SelectUserGroups = 'Select User Groups';
	static ChartBuilder = 'Chart Builder';
	static Save = 'Save';
	static EventTypeCostsReportTableDirectCostsByCategoryName = 'Table - Direct Costs - By Category';
	static DeletingUserParameterWasNotSuccessfulErrorParameter = 'Failed to remove user account \'{0}\'! Error: \'{1}\'';
	static TaskChartGroupingFieldGroupingTypeWeek = 'Week';
	static AddUserParameterWasNotSuccessfulConcurrencyError = 'Failed to add user account \'{0}\', because the data has been modified concurrently by another user!';
	static FormTextAreaSize = 'Height';
	static FormTitles = 'Titles';
	static DoYouReallyWantToRemoveWhistleBlowCategoryParameter = 'Do you really want to remove whistle blow category \'{0}\'?';
	static SavePrintAs = 'Save Print As';
	static Unkown = 'Unkown';
	static Public = 'Public';
	static NewFamiliarizationMustBeSavedBeforeAttachmentsCanBeAdded = 'New familiarization must be saved before attachments can be added!';
	static FormUsableInSearchFilter = 'Usable in Search Filter';
	static CalendarTaskRepetitionRepeatIntervalWeeklySuffix = 'weeks(s) on';
	static DeletingKeywordParameterWasNotSuccessfulConcurrencyError = 'Failed to remove keyword \'{0}\', because data in the keyword has been modified concurrently by another user!';
	static CkickToChangeTheIcon = 'Click to change the icon';
	static DeletingRiskCategoriesParameterWasNotSuccessfulErrorParameter = 'Failed to remove risk categories \'{0}\'! Error: \'{1}\'';
	static LastListRow = 'Last List Row';
	static LockedOpportunityParameterCannotBePublished = 'Locked opportunity \'{0}\' cannot be published!';
	static SelectUserGroupOrUser = 'Select User Group or User Account';
	static TaskDataRowMustBeSavedBeforeAttachmentsCanBeAdded = 'Row must be saved before attachments can be added!';
	static AccessRightRead_Event_AC = 'Create, handle and view all';
	static CopyDocumentsFromCompany = 'Copy Documents from This Company';
	static FormFalse = 'False';
	static File = 'File';
	static TaskMustBeSavedBeforeCalendarTasksCanBeAdded = 'Form must be saved before events can be added!';
	static InstantMessagesMenuTitle = 'HoxUp';
	static Remove = 'Remove';
	static MaximumSizeOfFilesThatCanBeAddedInBatchIsParameterMB = 'Maximum total size of files that can be added in batch is  {0} MB!';
	static RiskThreat = 'Threat';
	static SavingKeywordParameterWasNotSuccessfulErrorParameter = 'Failed to save keyword \'{0}\'! Error: \'{1}\'';
	static TargetsOtherCompanies = 'Visibility - Other Companies';
	static ProjectNumber = 'Project Number';
	static SavingWhistleBlowChannelParameterWasNotSuccessfulConcurrencyError = 'Failed to save whistle blow channel \'{0}\', because data in the whistle blow channel has been modified concurrently by another user!';
	static Card = 'Card';
	static YouHaveUnapprovedChangesDoYouWantApproveChanges = 'You have not approved changes that you have made. Do you want to approve changes?';
	static AddMessage = 'Add Message';
	static RecordUserFurtherEducationsBarChartByTimeName = 'Bar Chart - Educations';
	static NotValid = 'Not Valid';
	static NewRecordUserMustBeSavedBeforeTransferredPropertiesCanBeAdded = 'New user record must be saved before transferred properties can be added!';
	static DoYouReallyWantToRemoveSelectedFileFilters = 'Do you really want to remove selected file filters?';
	static ReplyToInstantMessage = 'Reply to message';
	static CopyingFilesAndDocumentsToFolderParameterWasNotSuccessfulErrorParameter = 'Failed to copy files/documents into folder \'{0}\'! Error: \'{1}\'';
	static AddLogisticVoucherCustomer = 'Add Customer';
	static Wage = 'Wage';
	static PreviewIsNotSupportedForThisFileType = 'Preview is not supported for this file type!';
	static RemoveDefaultBasicEducation = 'Remove Default Basic Education';
	static EditLogisticVoucherCompanyPaymentSetting = 'Edit Payment Setting';
	static SavingRecordFurtherEducationGroupParameterWasNotSuccessfulErrorParameter = 'Failed to save education group \'{0}\'! Error: \'{1}\'';
	static FormulaPI = 'Pi';
	static ChartParameterNotFound = 'Chart \'{0}\' not found!';
	static Keyword = 'Keyword';
	static TaskPriorities = 'Form Priorities';
	static RemovingReportTemplateUnitsWasNotSuccessfulErrorParameter = 'Failed to remove units! Error: \'{0}\'';
	static WhistleBlowEventTypeHandlersAdded = 'Handlers added';
	static SavingWhistleBlowCategoryParameterWasSuccessful = 'Whistle blow category \'{0}\' saved successfully!';
	static AccessRightWrite_EventDescription_B = '* Can create incidents\n* Can view all incidents of the unit\n* Can be selected as incident handler and can handle all incidents of the unit\n* Can remove incidents of the unit\n* Can be selected as default handler and person to be notified';
	static StateOpenPlural = 'Open';
	static RemoveCalendarTaskCategory = 'Remove Category';
	static TakePicture = 'Take Picture';
	static InOneYear = 'In One Year';
	static RiskStandardParameterNotFound = 'Standard \'{0}\' not found!';
	static AccessRightWrite_UserGroupDescription = 'Can create, edit and delete the company’s user groups';
	static DeletingUserParametersWasNotSuccessfulErrorParameter = 'Failed to remove user parameters! Error: \'{0}\'';
	static SavingEventTypeBParameterWasSuccessful = 'Category 2 \'{0}\' saved successfully!';
	static MessageType = 'Message Type';
	static EventModuleInfoSettings = 'The size of preview images for incidents attachments, whether to include the "Observer Action" field in the incident, and whether to include location data in the incident.';
	static AgencyWorker = 'Agency Worker';
	static TaskDataRowTotalTypeColAverage = 'Row average';
	static TaskCalendarTasksPersonsInChargeWarning = 'Persons in charge are not defined!';
	static ChartType = 'Chart Type';
	static EventParameterNotFound = 'Incident \'{0}\' not found!';
	static FieldParameterConstainsIllegalCharactersForFileName = 'Value of the field \'{0}\' contains characters that are illegal in file names (<, >, :, ", /, \, |, ? tai *) or it ends with illegal characters (., \' \')!';
	static FormRadio = 'Radio Button';
	static RiskStandardParameterIsInUse = 'Standard \'{0}\' is used in {1} risks and cannot be removed!';
	static SavingCalendarTaskCategoryParameterWasNotSuccessfulErrorParameter = 'Failed to save category \'{0}\'! Error: \'{1}\'';
	static TargetsMyCompany = 'Visibility - My Company';
	static FormSizeSmall = 'Small';
	static NewUserMustBeSavedBeforeUserGroupsCanBeAdded = 'New user must be saved before user groups can be added!';
	static InvalidPasswordChangeRequestParameter = 'Invalid password change request \'{0}\'!';
	static RiskCreated = 'Risk Created';
	static DeletingCalendarTaskCategoriesParameterWasNotSuccessfulConcurrencyError = 'Failed to remove categories \'{0}\', because data in categories has been modified concurrently by another user!';
	static LockedOpportunityParameterCannotBeUnpublished = 'Locked opportunity \'{0}\' cannot be unpublished!';
	static DoYouReallyWantToPublishRiskParameter = 'Do you really want to publish risk \'{0}\'?';
	static WhistleBlowNonAnonymousReportInfo = 'Your name will only be known to those who handle your report, and it will remain anonymous to everyone else.';
	static PrintFileName = 'Print_{0:yyyy-MM-dd_HH-mm}.pdf';
	static RiskCategoriesMustBeDefinedBeforeAddingRiskTemplates = 'Categories must be defined before adding risk templates!';
	static DoYouReallyWantToRestoreOpportunityParameterFromArchive = 'Do you really want to restore opportunity \'{0}\' from archive?';
	static WhistleBlowResolutionOther = 'Other';
	static RestoringTaskParameterFromTrashBinWasNotSuccessfulConcurrencyError = 'Failed to restore form \'{0}\' from trash bin, because data in the form has been modified concurrently by another user!';
	static ReadingDatabaseParameter = 'Reading database \'{0}\'...';
	static CreatingNotifications = 'Creating notifications...';
	static SharedResource = 'Shared Resource';
	static AddCompanyGroupParameterWasSuccessful = 'Company group \'{0}\' added successfully!';
	static Familiarizations = 'Familiarizations';
	static OpenTrashBin = 'Open Trash Bin';
	static RecordUserFamiliarizationApprovalWasSuccessful = 'Familiarization approved!';
	static DoYouReallyWantToArchiveRiskParameter = 'Do you really want to archive risk \'{0}\'?';
	static CopyingFolderDirectoryItemParameterToFolderParameterWasNotSuccessfulConcurrencyError = 'Failed to copy folder \'{0}\' into folder \'{1}\', because data in the folder has been modified concurrently by another user!';
	static EditOpportunity = 'Edit Opportunity';
	static AssessmentCommentMustBeDefined = 'Assessment conclusion must be defined!';
	static RemoveEditableDocument = 'Remove Document';
	static SavingRiskStandardParameterWasSuccessful = 'Standard \'{0}\' saved successfully!';
	static SavingDirectoryItemDocumentParameterWasNotSuccessfulConcurrencyError = 'Failed to save file \'{0}\', because data in the file has been modified concurrently by another user!';
	static Companies = 'Companies';
	static RemoveUserFromUserGroup = 'Remove User Account from User Group';
	static DirectoryItemDocumentsNotFound = 'Files/documents not fond!';
	static RecordUserParameterNotFound = 'User record \'{0}\' not found!';
	static UnpublishingRiskParameterWasNotSuccessfulErrorParameter = 'Failed to unpublish risk \'{0}\'! Error: \'{1}\'';
	static Assessment = 'Assessment';
	static DeletingReportTemplateParameterWasSuccessful = 'Report template \'{0}\' removed successfully!';
	static EventTypesCReportName = 'Incidents - Category 3';
	static SSRSRefreshFinishedInParameterSeconds = 'SSRS refresh finished (duration: {0:N0}s)';
	static EditTask = 'Edit Form';
	static RiskStakeholdersInUse = 'Stakeholders are in use';
	static LoadMore = 'Load More';
	static AccountIBANNumber = 'Bank Account IBAN Number';
	static DeletingRiskStakeholderParameterWasNotSuccessfulErrorParameter = 'Failed to remove stakeholder \'{0}\'! Error: \'{1}\'';
	static UserGroups = 'User Groups';
	static InstantMessageUserInvitationAcceptTypeCannotInvite = 'I cannot be invited to join chat';
	static UserCodeIsAlreadyInUse = 'Username is already in use!';
	static RiskCategoryParameterIsInUse = 'Category \'{0}\' is used in {1} risks and cannot be removed!';
	static TaskRemainderCheckingAndNotificationStarted = 'Form remainder checking and notification started';
	static MobileAppInUse = 'Mobile app in use';
	static AuthorizationLevelAdmin = 'Administrators';
	static ImportingUsersParameterWasSuccessful = 'User accounts \'{0}\' imported successfully!';
	static EventApprovalWasNotSuccessfulErrorParameter = 'Failed to approve incident! Error: \'{0}\'';
	static DeletingFileFiltersParameterWasNotSuccessfulConcurrencyError = 'Failed to remove file filters \'{0}\', because data in file filters has been modified concurrently by another user!';
	static DeletingInstantMessageUserParameterWasNotSuccessfulErrorParameter = 'Failed to remove participant \'{0}\'! Error: \'{1}\'';
	static Repeated = 'Repeated';
	static DeletingRecordUserEmploymentsParameterWasNotSuccessfulConcurrencyError = 'Failed to remove employments \'{0}\',  because data in employments has been modified concurrently by another user!';
	static DeletingFileFilterParameterWasNotSuccessfulConcurrencyError = 'Failed to remove file filter \'{0}\', because data in the file filter has been modified concurrently by another user!';
	static SavingRecordBasicEducationParameterWasNotSuccessfulErrorParameter = 'Failed to save basic education \'{0}\'! Error: \'{1}\'';
	static LoggedInUserAccountIsNotActive = 'Logged in user is not active!';
	static RemoveTaskType = 'Remove Form Template';
	static DeletingRecordUserTransferredPropertyParameterWasSuccessful = 'Transferred property \'{0}\' removed successfully!';
	static Day = 'Day';
	static AddPartners = 'Add Partners';
	static TaskParameterNotFound = 'Form \'{0}\' not found!';
	static ReportTemplateUnits = 'Report Template Visibility';
	static RiskTemplate = 'Risk Template';
	static RiskProcessCodeIsAlreadyInUse = 'My classification name is already in use!';
	static ReportTemplateUsedInAllUnits = 'Report template is usable in all units';
	static CreateReport = 'Create Report';
	static ChartValueFields = 'Chart Value Fields';
	static DaysAgo60 = '60 Days Ago';
	static AccessRightRead_CalendarTaskDescription = '* Can create and edit their own private calendar events\n* Can view public calendar events';
	static UsedFileStorageQuota = 'Used File Storage Quota';
	static RestoringRiskParameterFromArchiveWasSuccessful = 'Risk \'{0}\' has been restored from trash bin!';
	static Password = 'Password';
	static RequestValidationErrorOnFieldParameterWithValueParameter = 'The value \'{1}\' of the field \'{0}\' contains content that is considered dangerous in web applications!';
	static OpportunityParameterNotFound = 'Opportunity \'{0}\' not found!';
	static FormInitializeFromSavedRowDialog = 'Initialize Default Value from Saved Row';
	static BarChart = 'Bar Chart';
	static RecordUserFurtherEducationsTableByTimeName = 'Table - Educations';
	static FormDisabled = 'Input Disabled';
	static Target = 'Target';
	static UserIsPersonInCharge = 'User is person in charge';
	static AddQualification = 'Add Qualification';
	static RecordUserExcelFurtherEducation = 'Educations';
	static RecordParameterLockingFailedRecordIsWriteLockedToUserParameter = 'Failed to lock record \'{0}\'! The record is write locked to user \'{0}\'!';
	static RiskModuleInfoUnits = 'By creating units, you can set the visibility and access rights of risks on a unit-by-unit basis.';
	static RemoveRecordUserAndKeepUser = 'Remove User Record and Keep User Account';
	static Name = 'Name';
	static SavingUserGroupParameterWasNotSuccessfulErrorParameter = 'Failed to save user group \'{0}\'! Error: \'{1}\'';
	static SavingDefaultHandlersWasNotSuccessfulConcurrencyError = 'Failed to save default handlers, because default handlers have been modified concurrently by another user!';
	static MyFilters = 'User\'s Filters';
	static ChartGenerationAborted = 'Chart creation canceled!';
	static AddSharedDocumentTemplate = 'Add Shared Document Template';
	static PublishingOpportunityParameterWasNotSuccessfulErrorParameter = 'Failed to publish opportunity \'{0}\'! Error: \'{1}\'';
	static LockingEventParameterWasNotSuccessful = 'Failed to lock incident \'{0}\'!';
	static SavingTaskStateParameterWasNotSuccessfulConcurrencyError = 'Failed to save form state \'{0}\', because data in the form state has been modified concurrently by another user!';
	static AddedComment = 'Added Comment';
	static WebPageStyle = 'Page Style';
	static TaskPriorityParameterNotFound = 'Form priority \'{0}\' not found!';
	static EditCompanyTaskType = 'Edit Company Form Template';
	static ControlEffiency = 'Control Effiency';
	static DeletingEventPartnerParameterWasNotSuccessfulConcurrencyError = 'Failed to remove incident partner \'{0}\', because data in the incident partner has been modified concurrently by another user!';
	static ApprovalAuthority = 'Approval Authority';
	static ExpiredPlural = 'Expired';
	static RecordUserLogEntryTypeReport = 'Reporting';
	static LockedDocumentParameterCannotBeDeleted = 'Locked document \'{0}\' cannot be removed!';
	static AccessRightRead_InstantMessage_A = 'Internal chats and permissions';
	static FormShowInRow = 'Use in Row';
	static TaskTypesByUnits = 'Form Templates by Units';
	static DeletingWhistleBlowCategoriesParameterWasSuccessful = 'Whistle blow categories \'{0}\' removed successfully!';
	static UserGroupParameterNotFound = 'User group \'{0}\' not found!';
	static NewInstantMessageChannelMustBeSavedBeforeUsersCanBeAdded = 'New chat must be saved before participants can be added!';
	static MovedToTrashBin = 'Moved to Trash Bin';
	static Error = 'Error';
	static DeletingInstantMessageUserParameterWasSuccessful = 'Participant \'{0}\' removed successfully!';
	static DirectoryItemFolderParameterNotFound = 'Folder \'{0}\' not found!';
	static TimeSpanYear = 'Year';
	static DeletingRecordQualificationsParameterWasSuccessful = 'Qualifications \'{0}\' removed successfully!';
	static AddingRiskTemplateUnitsWasSuccessful = 'Units added successfully!';
	static SavingOptionParameterWasNotSuccessfulErrorParameter = 'Failed to save option \'{0}\'! Error: \'{1}\'';
	static ArchiveWhistleBlows = 'Archive Whistle Blow Reports';
	static DoYouReallyWantToRemoveSelectedRecordFamiliarizations = 'Do you really want to remove selected further familiarizations?';
	static Expired = 'Expired';
	static EventUrgencyClasses = 'Urgency Classes';
	static AddWhistleBlow = 'Add Whistle Blow Report';
	static DownloadAttachment = 'Download Selected Attachment';
	static FurtherEductionGroupParameterContainsFurtherEducationsAndCannotBeDeleted = 'Education group \'{0}\' is contains educations and cannot be removed!';
	static EditEventTypeCs = 'Edit Category 3';
	static UsersToBeImported = 'Users to be Imported';
	static EmailHasBeenAlreadySentForThisMessage = 'Email has been already sent for this message!';
	static RemoveNotifiedPerson = 'Remove Person to Be Notified';
	static PublishVoucherToFileSystem = 'Publish Voucher to File System';
	static AddChartValueField = 'Add Chart Value Field';
	static RemoveLogisticVoucherCustomerPaymentSetting = 'Remove Payment Setting';
	static RemoveUserAndRecordUser = 'Remove User Account and User Record';
	static PermissionToCreateEventsToPartners = 'Permission to Create Incidents to Partners';
	static PushEndpoint = 'Push Endpoint';
	static OnlyOneChartValueFieldIsSupported = 'Only one chart value field is supported.\nRemove other value fields!';
	static DoYouReallyWantToRemoveRecordQualificationParameter = 'Do you really want to remove qualification \'{0}\'?';
	static LockTaskTypeAfterSave = 'Lock Form after Save';
	static SavingEventSettingsWasNotSuccessfulErrorParameter = 'Failed to save incident settings! Error: \'{0}\'';
	static SendReadReceiptConfirmation = 'Do you want to send read receipt?';
	static DeletingTaskStateParameterWasNotSuccessfulConcurrencyError = 'Failed to remove form state \'{0}\', because data in the form state has been modified concurrently by another user!';
	static WhistleBlowChannelSettings = 'Whistle Blow Channel Settings';
	static SavingEventTypeCParameterWasNotSuccessfulConcurrencyError = 'Failed to save category 3 \'{0}\', because data in the category 3 has been modified concurrently by another user!';
	static RestoringInstantMessageWasNotSuccessfulConcurrencyError = 'Failed to restore instant message, because data in the instant message has been modified concurrently by another user!';
	static FormShowCreateDate = 'Show Create Date';
	static ByRiskCategory = 'By Category';
	static DoYouReallyWantToUnpublishOpportunityParameter = 'Do you really want to unpublish opportunity \'{0}\'?';
	static FileChangesCheckingAndEmailingFinishedInParameterSeconds = 'File changes checking and emailing finished (duration: {0:N0}s, errors: {1}, files: {2}, emails: {3})';
	static InstantMessageChannelRemoveFromYourselfFromAdministratorsConfirmation = 'Do you really want to remove yourself from administators? Only administrators can manage chat.';
	static EmailingMessageWasNotSuccessfulErrorParameter = 'Failed to send message by email! Error: \'{0}\'';
	static Addition = 'Addition';
	static LockedRiskParameterCannotBeDeleted = 'Locked risk \'{0}\' cannot be removed!';
	static EditDefaultTaskState = 'Edit Default Form State';
	static OpenRow = 'Open Row';
	static DeletingRiskAssesmentParameterWasNotSuccessfulConcurrencyError = 'Failed to remove assessment \'{0}\', because the data has been modified concurrently by another user!';
	static Date = 'Date';
	static SavingPushSendLogParameterWasSuccessful = 'Push notification log saved successfully!';
	static RemoveRiskStakeholder = 'Remove Stakeholder';
	static Required = 'Required';
	static FormulaCeil = 'Rounded to up';
	static TaskDataRowTotalTypeText = 'Text value';
	static SaveUserFurtherEducationConfirmation = 'Do you want to save the education?';
	static Log = 'Logs';
	static DoYouReallyWantToRemoveRecordBasicEducationParameter = 'Do you really want to remove basic education \'{0}\'?';
	static AddUserGroup = 'Add User Group';
	static NewPassword = 'New Password';
	static WhistleBlowAttachmentAddReasonDefaultValue = 'Added attachment that does not contain unnecessary information (e.g. personal information).';
	static RecordBasicEducationCodeIsAlreadyInUse = 'Basic education name is already in use!';
	static DeletingDocumentTemplateParameterWasNotSuccessfulConcurrencyError = 'Failed to remove document template \'{0}\', because data in the document template has been modified concurrently by another user!';
	static DeletingWhistleBlowCategoryParameterWasNotSuccessfulConcurrencyError = 'Failed to remove whistle blow category \'{0}\',  because data in the whistle blow category has been modified concurrently by another user!';
	static FormRemoveFieldConfirmation = 'Do you really want to remove field from form?';
	static FileParameterIsNotImage = 'File \'{0}\' is not a picture!';
	static UserUnapproved = 'I Have Not Approved';
	static DeletingTaskStatesParameterWasNotSuccessfulConcurrencyError = 'Failed to remove form states \'{0}\', because data in form states has been modified concurrently by another user!';
	static FamiliarizationStartDate = 'Familiarization Start Date';
	static DocumentTemplates = 'Document Templates';
	static EditBasicEducation = 'Edit Basic Education';
	static FormColumnWidthPrint = 'Column Width in Print';
	static EfficiencyPercentage = 'Efficiency %';
	static LockedRiskParameterCannotBePublished = 'Locked risk \'{0}\' cannot be published!';
	static MessageTypeParameterNotFound = 'Message type \'{0}\' not found!';
	static SelectEventPartner = 'Select Incident Partner';
	static SavingUserParametersWasNotSuccessfulConcurrencyError = 'Failed to save user options\', because data in the user options has been modified concurrently by another user!';
	static RecordUserModuleInfoFamiliarizations = 'Familiarization is meant to be used for employee\'s initial introduction to the job duties, workplace practices, systems, responsibilities and safety instructions. The purpose is to ensure that the new employee receives the necessary knowledge and skills to perform their duties smoothly right from the start.\n\nNote! Separate training, courses or subsequent competence development are not recorded in this section - they belong in the education section.';
	static DoYouReallyWantToPublishOpportunityParameter = 'Do you really want to publish opportunity \'{0}\'?';
	static DeletingRecordFurtherEducationGroupParameterWasNotSuccessfulErrorParameter = 'Failed to remove education group \'{0}\'! Error: \'{1}\'';
	static SavingEditableDocumentParameterApprovalWasSuccessful = 'Document \'{0}\' approved successfully!';
	static RiskTreatmentStateCompleted = 'Completed';
	static SavingRecordEmploymentParameterWasNotSuccessfulConcurrencyError = 'Failed to save employment \'{0}\', because data in the employment has been modified concurrently by another user!';
	static LockedEventParameterCannotBeDeleted = 'Locked incident \'{0}\' cannot be removed!';
	static FormSelection = 'Selection';
	static ActionIsNotAuthorized = 'Action is not authorized!';
	static Approve = 'Approve';
	static DoYouReallyWantToRemoveDocumentsParameter = 'Do you really want to remove {0} selected files/documents?';
	static NoEvents = 'No events';
	static SavingKeywordParameterWasSuccessful = 'Keyword \'{0}\' saved successfully!';
	static IncludeArchivedRecordUsers = 'Include archived user records';
	static WhistleBlowStateReceived = 'Received';
	static SavingUnitsWasNotSuccessfulErrorParameter = 'Failed to save units! Error: \'{0}\'';
	static FurtherEducations = 'Educations';
	static RemoveTaskState = 'Remove Form State';
	static BannerPath = 'Banner Folder';
	static EditPermission = 'Edit Permission';
	static FormTaskReferenceIsIsInvalid = 'Form reference is invalid!';
	static SavingEditableDocumentParameterPublishWasSuccessful = 'Document \'{0}\' published successfully!';
	static RemovePermission = 'Remove Permission';
	static TaskChartGroupingFieldGroupingTypeMonth = 'Month';
	static SourceDescription = 'Source Description';
	static CompanyParameterNotFound = 'Company \'{0}\' was not found!';
	static DoYouReallyWantToArchiveRecordUserParameter = 'Do you really want to archive user record \'{0}\'?\n\nWhen user record is archived, related user account will be set expired, will be removed from HoxUp channels, incident default handlers and notification receivers and whistleblower default handlers.';
	static SelectCategory = 'Select Category';
	static InheritedContentFilter = '(inherited content filter)';
	static SavingRiskProcessParameterWasNotSuccessfulConcurrencyError = 'Failed to save my classification\'{0}\', because the data has been modified concurrently by another user!';
	static SuccessAudit = 'SuccessAudit';
	static RiskThreatPlaceholder = 'Describe the key causes or underlying factors of the risk. What could lead to the risk materializing?';
	static UserFilterActive = 'Active User Accounts';
	static DeletingRecordUserEmploymentsParameterWasSuccessful = 'Employments \'{0}\' removed successfully!';
	static AdministratorPasswordMustBeDefined = 'Password of the administrator must be defined!';
	static DoYouReallyWantToUnlockEditableDocument = 'Do you really want to unlock document \'{0}\'?';
	static PersonsInChargeRemoveConfirmation = 'Do you really want to remove selected persons in charge?';
	static DefaultRiskTemplates = 'Default Risk Templates';
	static SharedTo = 'Shared to';
	static PaymentSettings = 'Payment Settings';
	static FormWeb = 'Web App';
	static DeletingMessageTypeParameterWasNotSuccessfulConcurrencyError = 'Failed to remove message type \'{0}\', because data in the message type has been modified concurrently by another user!';
	static ExpiresInParameterDays = 'Expires in {0} days';
	static SelectTaskState = 'Select Form State';
	static WhistleBlowSourcePhone = 'Phone';
	static CourseCredits = 'Course Credits';
	static DeletingInstantMessageUsersParameterWasSuccessful = 'Participants \'{0}\' removed successfully!';
	static FormulaSqrt = 'Square root';
	static SavingReportParameterWasSuccessful = 'Report \'{0}\' saved successfully!';
	static ClickToChangeTheLogo = 'Click to change the logo';
	static DoYouReallyWantToUnpublishRiskParameter = 'Do you really want to unpublish risk \'{0}\'?';
	static DeletingRiskTemplatesParameterWasNotSuccessfulConcurrencyError = 'Failed to remove risk templates \'{0}\', because the data has been modified concurrently by another user!';
	static WhistleBlowCreateTime = 'Report Sent Time';
	static DoYouReallyWantToRestoreRiskParameterFromArchive = 'Do you really want to restore risk \'{0}\' from archive?';
	static UserIsActiveInMobile = 'User account is active in mobile application.';
	static LanguageEnglish = 'English';
	static CopyOrMoveFolderParameter = 'Copy or Move Folder \'{0}\'';
	static SelectReportTemplate = 'Select Report Template';
	static WhistleBlowDataInfo = 'Avoid including unnecessary personal data or sensitive information in the details or messages of the report. Mention individuals\' names only if necessary for resolving the matter.';
	static NewRiskMustBeSavedBeforeAttachmentsCanBeAdded = 'New risk must be saved before attachments can be added!';
	static CalendarTaskCategoryCodeIsAlreadyInUse = 'Category name is already in use!';
	static SavingRecordFurtherEducationParameterWasNotSuccessfulErrorParameter = 'Failed to save education \'{0}\'! Error: \'{1}\'';
	static SavingRecordUserTransferredPropertyParameterWasNotSuccessfulConcurrencyError = 'Failed to save transferred property \'{0}\', because data in the transferred property has been modified concurrently by another user!';
	static UserFurtherEducationArhiveExpiredDurationInMonths = 'Automatic education/competency archiving';
	static ListType = 'List Type';
	static ApplicationTempPathParameterNotFound = 'Application temp-folder \'{0}\' not found!';
	static Description = 'Description';
	static Interval = 'Interval';
	static FilterCondition = 'Filter Condition';
	static KeywordsAndCondition = 'All selected keywords';
	static SelectInstantMessageChannelUser = 'Select Participant';
	static FiltersStandard = 'Standard Filters';
	static TaskRemainderCheckingAndNotificationFinishedInParameterSeconds = 'Form remainder checking and notification finished (duration: {0:N0}s, errors: {1}, forms: {2}, emails: {3}, push notifications: {4})';
	static AddRiskAssessment = 'Add Assessment';
	static DeletingFileFilterParameterWasSuccessful = 'File filter \'{0}\' removed successfully!';
	static GroupByMonth = 'Group by Month';
	static RiskProcessName = 'Name of My Classification';
	static NotApproved = 'Not approved';
	static Competencies = 'Competencies';
	static TaskReport = 'Form Report';
	static RestoringOpportunityParameterFromArchiveWasSuccessful = 'Opportunity \'{0}\' has been restored from trash bin!';
	static DatabaseCheckingStarted = 'Database checking started';
	static FamiliarizationStartDateDateEnd = 'Familiarization Start Date - End';
	static NewPrint = 'New Print';
	static SavingOneTimePasswordWasNotSuccessfulErrorParameter = 'Failed to save one time password! Error: \'{0}\'';
	static FamiliarizationEndDate = 'Familiarization End Date';
	static RecordFurtherEducationParameterIsInUseInParameterRecordUsersAndCannotBeDeleted = 'Education \'{0}\' is used in {1} user records and cannot be removed!';
	static ContentFiltering = 'Content Filtering';
	static TaskTypes = 'Form Templates';
	static ToDo = 'Things to Do';
	static DeletingKeywordsParameterWasNotSuccessfulConcurrencyError = 'Failed to remove keywords \'{0}\', because data in keywords has been modified concurrently by another user!';
	static DisconnectFromMicrosoftAccount = 'Disconnect from Microsoft Account';
	static MicrosoftSignInGuide = 'Microsoft Sign in Guide';
	static MoveToTrashBin = 'Move to Trash Bin';
	static ChartValueField = 'Chart Value Field';
	static RecordUserFurtherEducationsPieChartEducationName = 'Pie Chart - Educations - By Name';
	static EventIsNotApprovedByUser = 'User has not approved the incident';
	static KeywordCodeIsAlreadyInUse = 'Keyword code is already in use!';
	static AddLogisticVoucherCustomerPaymentSetting = 'Add Payment Setting';
	static EventTypeTitle = 'Incident Identification Category 1';
	static EmailsSentSuccessfully = 'Emails sent successfully!';
	static FormTaskReference = 'Forms';
	static DeletingFileFilterParameterWasNotSuccessfulUsedInParameterFolders = 'Failed to remove file filter \'{0}\', because the file filter is used in {1} folder!';
	static FormRowPrint = 'Row Print';
	static AddChildEventTypeB = 'Add Subcategory 2';
	static AddCommentsToEvent = 'Add comment by tapping the plus button.';
	static RemoveEventType = 'Remove Category 1';
	static ShowSchema = 'Show Schema';
	static Edit = 'Edit';
	static WhistleBlowMessageHasNotBeenSentCloseConfirmation = 'An unfinished message has not been sent yet. Do you want to close the view?';
	static RiskCategoryMustBeDefined = 'Category must be defined!';
	static MessageTitleMustBeDefined = 'Message title until date must be defined!';
	static ValidityEndDate = 'Validity End Date';
	static DocumentParameterOverwriteConfirmation = 'File \'{0}\' already exists in folder. Do you want to overwrite this file?';
	static CalendarTaskSeries = 'Series';
	static WhistleBlowSourceOral = 'Oral';
	static EditableDocumentCodeMustBeDefined = 'Document name must be defined!';
	static TaskDefaultStatesInstruction = 'Form default states. Form specific states can be defined in form template edit dialog.';
	static DocumentZipFileName = 'Documents_{0:yyyy-MM-dd_HH-mm}.zip';
	static Chart = 'Chart';
	static FormFontSize = 'Font Size';
	static FileSynchronizationToDatabaseStarted = 'Filesystem synchronization with database started';
	static Contents = 'Contents';
	static PaymentVoucherCounter = 'Payment Voucher Counter';
	static DeletingReportParameterWasSuccessful = 'Report \'{0}\' removed successfully!';
	static PartiallyWorks = 'Partially Works';
	static DeletingRiskParameterWasNotSuccessfulErrorParameter = 'Failed to remove risk \'{0}\'! Error: \'{1}\'';
	static DeletingRecordUserTransferredPropertiesParameterWasSuccessful = 'Transferred properties \'{0}\' removed successfully!';
	static RiskProcesses = 'My Classifications';
	static ExternalSystemCompanyCodeMustBeDefined = 'Company code in external system must be defined!';
	static QrCodeAuthenticationTimeoutHour = '1 hour';
	static RemovingRecordUserFamiliarizationHandlersWasSuccessful = 'Approvers removed successfully!';
	static SelectSubject = 'Select Subject';
	static RecordUserFurtherEducationsPieChartName = 'Pie Chart - Educations';
	static Familiarization = 'Familiarization';
	static WhistleBlowChannelMustHaveAtLeastOneAdministrator = 'Whistle blow channel must have at least one administrator!';
	static FileChangesCheckingAndEmailingStarted = 'File changes checking and emailing started';
	static TransferToChannel = 'Move to chat';
	static NewCompanyInformation = 'New Company';
	static Invited = 'Invited';
	static ContactPerson = 'Contact Person';
	static ActionsAndRootCause = 'Actions and Root Cause';
	static Descending = 'Descending';
	static ExpiresInParameterMonths = 'Expires in {0} months';
	static RiskModuleModuleInfoRiskTemplatesNotFound = 'Risk templates not defined, create new risk template by clicking + button.';
	static FormBuilder = 'Form Builder';
	static UserRecordsDashboard = 'Resources Dashboard';
	static AddEmployments = 'Add Employments';
	static Scope = 'Scope';
	static InstantMessageParameterNotFound = 'Instant message \'{0}\' not found!';
	static LogCleaning = 'Clear Log';
	static DoYouReallyWantToRemoveSharedDocumentTemplateParameter = 'Do you really want to remove shared document template \'{0}\'?';
	static DeletingCompanyParameterWasNotSuccessfulConcurrencyError = 'Failed to remove company \'{0}\',  because data in the company has been modified concurrently by another user!';
	static SavingWhistleBlowWasSuccessful = 'Whistle blow report saved successfully!';
	static FormulaCbrt = 'Cubic root';
	static SharedReportAllCompanies = 'Shared to all companies';
	static ExpiredFamiliarizations = 'Expired Familiarizations';
	static VoucherInOutReportSavePath = 'Voucher Summary Print Save Path';
	static RemovingEventHandlersWasSuccessful = 'Handlers removed successfully!';
	static AddRecordUserToUserAccount = 'Add user record to existing user account';
	static WelcomeToUseEsalkkuSystem = 'Welcome to use eSalkku! The first step is to specify your password. Your username was included in the invitation email.';
	static ReminderMinutesBefore = 'minutes before';
	static CalendarTaskRepetitionRepeatIntervalPrefix = 'Recur every';
	static JobLineDataIsEmpty = 'Job line data is missing!';
	static ModifiedBy = 'Modified By';
	static DeletingRecordFurtherEducationGroupParameterWasSuccessful = 'Education group \'{0}\' removed successfully!';
	static SavingRecordEmploymentParameterWasSuccessful = 'Employment \'{0}\' saved successfully!';
	static TaskDefaultStates = 'Default States';
	static LockedEventParameterCannotBeSaved = 'The incident \'{0}\' has been locked to another user and it cannot be saved!';
	static SavingUnitPermissionsWasSuccessful = 'Unit permissions saved successfully!';
	static RemoveDocumentTemplate = 'Remove Document Template';
	static AddReport = 'Add Report';
	static PayeeUsersCanLogInToTheSystem = 'Company users can log in to the system';
	static IndefinitelyNoLocalization = 'Indefinitely';
	static UserInformation = 'User Account';
	static UnlockingEventParameterWasNotSuccessful = 'Failed to unlock incident \'{0}\'!';
	static Approvers = 'Approvers';
	static Actions = 'Actions';
	static DeletingUserGroupsParameterWasNotSuccessfulErrorParameter = 'Failed to remove user groups \'{0}\'! Error: \'{1}\'';
	static Logo = 'Logo';
	static EventTypesMustBeDefinedBeforeAddingEvents = 'Category 1 must be defined before adding incidents!';
	static AccessRightWrite_Task_C = 'Edit and settings access';
	static WhistleBlowStatisticsReceivedRecords = 'Received Reports';
	static SavingEditableDocumentParameterWasNotSuccessfulErrorParameter = 'Failed to save document \'{0}\'! Error: \'{1}\'';
	static NotifiedPersons = 'Notifications';
	static AddRisk = 'Add Risk';
	static AddQualifications = 'Add Qualifications';
	static QrCodeLoginInProgress = 'QR code login in progress...';
	static AllInstantMessageUsersHaveReadMessage = 'All recipients have read your message';
	static ShowArchived = 'Show Archived';
	static AccessRightReadWhistleBlow = 'Limited reports handling';
	static EventTypeCostsReportBarChartDirectCostsByCategoryName = 'Bar Chart - Direct Costs - By Category';
	static ShowOnMap = 'Show on Map';
	static UserCodeClaimNotFound = 'User claim \'code\' not found!';
	static CopyingFolderParameterWasNotSuccessfulErrorParameter = 'Failed to copy folder \'{0}\' into folder \'{1}\' in filesystem! Error: \'{2}\'';
	static RemoveQualification = 'Remove Qualification';
	static LanguageNonLocalEnglish = 'English';
	static AddWhistleBlowChannelAdminParameterWasNotSuccessfulErrorParameter = 'Failed to add administrator \'{0}\'! Error: \'{1}\'';
	static FamiliarizationStartDateStart = 'Familiarization Start Date - Start';
	static CompanyRole = 'Company Role';
	static FormDropdown = 'Dropdown';
	static Title = 'Title';
	static AssessmentDateMustBeDefined = 'Assessment date must be defined!';
	static Ends = 'Ends';
	static RiskCategories = 'Categories';
	static WhistleBlowNonAnonymousReport = 'Report with discretion';
	static Payee = 'Payee';
	static RecordUserQualificationParameterNotFound = 'User record qualification record \'{0}\' not found!';
	static DeletingWhistleBlowCategoriesParameterWasNotSuccessfulErrorParameter = 'Failed to remove whistle blow categories \'{0}\'! Error: \'{1}\'';
	static CostCentreNumber = 'Cost Centre Number';
	static FormulaSubtraction = 'Subtraction';
	static AddTransferredProperties = 'Add Transferred Properties';
	static StartDate = 'Visible From';
	static DeletingInstantMessageChannelWasSuccessful = 'Chat removed successfully!';
	static DeletingPartnersParameterWasNotSuccessfulConcurrencyError = 'Failed to remove partners \'{0}\', because the data has been modified concurrently by another user!';
	static SavingCompanyGroupParameterWasSuccessful = 'Company group \'{0}\' saved successfully!';
	static DeletingDocumentTemplateParameterWasNotSuccessfulErrorParameter = 'Failed to remove document template \'{0}\'! Error: \'{1}\'';
	static AddEvent = 'Add Incident';
	static DoYouReallyWantToRestoreTaskParameterFromArchive = 'Do you really want to restore form \'{0}\' from archive?';
	static ArchivingRecordUserFamiliarizationsWasSuccessful = 'Familiarizations archived successfully!';
	static FormOtherInputs = 'Other Inputs';
	static SavingOneTimePasswordWasNotSuccessfulConcurrencyError = 'Failed to save one time password, because data in the one time password has been modified concurrently by another user!';
	static ApprovedEvent = 'Approved The Incident';
	static ApprovalJustificationMustBeDefined = 'Approval justification must be defined!';
	static NewRecordUserMustBeSavedBeforeRowsCanBeAdded = 'New user record must be saved before rows can be added!';
	static ResultGrouping = 'Result Grouping';
	static LogLine = 'Log Line';
	static SavingRecordUserPartnerParameterWasNotSuccessfulConcurrencyError = 'Failed to save resource partner \'{0}\', because data in the resource partner has been modified concurrently by another user!';
	static DeletingInstantMessageWasSuccessful = 'Instant message removed successfully!';
	static EditDefaultTaskType = 'Edit Default Form Template';
	static SelectImageFile = 'Select image file!';
	static SharedRiskTemplates = 'Shared Risk Templates';
	static SavingEventTypeBParameterWasNotSuccessfulErrorParameter = 'Failed to save category 2 \'{0}\'! Error: \'{1}\'';
	static Identification = 'Identification';
	static CompanyTaskTypesInstruction = 'Notice that modication of form template that is in used in forms, has effect to form\'s data (form data that is saved for tasks may be lost). You can create new form template by clicking + button.';
	static DoYouReallyWantToRemoveUserGroupParameter = 'Do you really want to remove user group \'{0}\'?';
	static Remainders = 'Remainders';
	static DeletingRiskStakeholderParameterWasNotSuccessfulConcurrencyError = 'Failed to remove stakeholder \'{0}\', because the data has been modified concurrently by another user!';
	static LockedDocumentParameterCannotBeMoved = 'Locked document \'{0}\' cannot be moved!';
	static AddTaskType = 'Add Form Template';
	static SavingRiskSettingWasSuccessful = 'Risk settings saved successfully!';
	static LanguageNonLocalFinnish = 'Suomi';
	static DeletingTaskTypeParameterWasNotSuccessfulConcurrencyError = 'Failed to remove form template \'{0}\', because data in the form template has been modified concurrently by another user!';
	static ChangedObserverAction = 'Changed incident observer action';
	static SelectCompanyGroupOrCompany = 'Select Company Group or Company';
	static DeletingRiskCategoryParameterWasNotSuccessfulErrorParameter = 'Failed to remove risk category \'{0}\'! Error: \'{1}\'';
	static AddAppReport = 'Add Report';
	static SavingWhistleBlowWasNotSuccessfulErrorParameter = 'Failed to save whistle blow report! Error: \'{0}\'';
	static UserReport = 'User\'s report';
	static RemovePartner = 'Remove Partner';
	static SelectTaskInListToSeeThePreview = 'Select form in list to see the preview';
	static SetUnitPermissions = 'Set Unit Permissions';
	static NoEventsToShow = 'No incidents to show!';
	static UserRecordStatisticsExpiringInSixMonthsFurtherEducations = 'Educations Expiring in Six Months';
	static EditFamiliarization = 'Edit Familiarization';
	static DoYouReallyWantToRemoveSelectedUserGroups = 'Do you really want to remove selected user groups?';
	static DeletingRiskStandardParameterWasNotSuccessfulErrorParameter = 'Failed to remove standard \'{0}\'! Error: \'{1}\'';
	static NewRecordUserMustBeSavedBeforeEmploymentsCanBeAdded = 'New user record must be saved before employments can be added!';
	static SharedFilter = 'Shared Filter';
	static NextOfKin = 'Next of Kin';
	static VersionProperties = 'Version Properties';
	static AddUserGroupParameterWasSuccessful = 'User group \'{0}\' added successfully!';
	static AddRemainder = 'Add Remainder';
	static TaskMustBeSavedBeforeNewDataRowsCanBeAdded = 'Form must be saved before rows can be added!';
	static DeletingEventTypeBParameterWasNotSuccessfulConcurrencyError = 'Failed to remove category 2 \'{0}\', because data in the category 2 has been modified concurrently by another user!';
	static SavingRiskParameterWasNotSuccessfulErrorParameter = 'Failed to save risk \'{0}\'! Error: \'{1}\'';
	static NoRisksToShow = 'No risks to show!';
	static CalendarTaskRepetitionCountSuffix = 'occurences';
	static EventTypeCostsReportTableDirectCostsByTimeName = 'Table - Direct Costs';
	static DeletingUsersParameterWasNotSuccessfulConcurrencyError = 'Failed to remove user accounts \'{0}\', because data has been modified concurrently by another user!';
	static SearchStartDate = 'Start Date';
	static DeletingUserGroupUsersOfCompanyParameterWasNotSuccessfulErrorParameter = 'Failed to remove user group connections related to company \'{0}\'! Error: \'{1}\'';
	static AccessRightWrite_AppReportDescription_A = '* Can create, edit and publish reports\n* Can add any eSalkku data to reports';
	static NoMessagesToShow = 'No messages to show!';
	static CompanyNameMustBeDefined = 'Name of the company must be defined!';
	static RiskIsModifiedAfterItWasPublished = 'Risk has been modified after it was published.';
	static ReferenceNumberPrefix = 'Reference Number Prefix';
	static CopyingFolderDirectoryItemParameterToFolderParameterWasNotSuccessfulErrorParameter = 'Failed to copy folder \'{0}\' into folder \'{1}\'! Error: \'{2}\'';
	static ReadReceipts = 'Read Receipts';
	static InstantMessageChannelOneUser = 'Chat';
	static DeletingEventTypeBParameterWasSuccessful = 'Category 2 \'{0}\' removed successfully!';
	static WhistleBlowStatisticsRecordCount = 'Active Reports';
	static SavingCalendarTaskParameterWasNotSuccessfulConcurrencyError = 'Failed to save event \'{0}\', because event has been modified concurrently by another user!';
	static ClearSubUnitDefaultHandlers = 'Clear Subunit Default Handlers';
	static SaveDraft = 'Save Draft';
	static AccessRightWrite_TaskDescription = '* Can create and edit forms\n* Can fill in forms and view and edit all rows\n* Can limit form visibility\n* Can set persons in charge for forms';
	static RiskContents = 'Risk Contents';
	static OpportunityDescriptionPlaceholder = 'Describe what the opportunity is, what it involves, and why it is worth taking advantage of.';
	static AllEventHandlersHaveReadMessage = 'All incident handlers have read your comment';
	static DoYouReallyWantToRemoveTaskStateParameter = 'Do you really want to remove form state \'{0}\'?';
	static LockedReportParameterCannotBeDeleted = 'Locked report \'{0}\' cannot be removed!';
	static DoYouReallyWantToRemoveSelectedUsers = 'Do you really want to remove selected users?';
	static SelectChart = 'Select Chart';
	static RestoringTaskParameterFromArchiveWasNotSuccessfulConcurrencyError = 'Failed to restore form \'{0}\' from archive, because data in the form has been modified concurrently by another user!';
	static DefaultRiskCategories = 'Default Risk Categories';
	static DeletingWhistleBlowCategoriesParameterWasNotSuccessfulConcurrencyError = 'Failed to remove whistle blow categories \'{0}\',  because data in whistle blow categories has been modified concurrently by another user!';
	static AddInstantMessageUserParameterWasSuccessful = 'Participant \'{0}\' added successfully!';
	static WhistleBlowNotFound = 'Whistle blow report not found!';
	static RemoveDefaultFurtherEducation = 'Remove Default Education';
	static TaskChartValueFieldCalculationTypeMin = 'Minimum';
	static DeletingUserGroupsParameterWasSuccessful = 'User groups \'{0}\' removed successfully!';
	static SelectComponentInFormToSeeComponentProperties = 'Select component in form to see it\'s properties';
	static Channels = 'Chats';
	static TaskDefaultPriorities = 'Default Priorities';
	static AccessRightRead_EventDescription = '* Can create incidents\n* Can view self-created incidents and incidents where acts as handler';
	static DocumentPublished = 'Published By';
	static Phone = 'Phone';
	static DeletingTaskTypeParameterWasSuccessful = 'Form template \'{0}\' removed successfully!';
	static EventTypeBTitle = 'Incident Identification Category 2';
	static DeletingRiskStakeholderParameterWasSuccessful = 'Stakeholder \'{0}\' removed successfully!';
	static RiskTemplates = 'Risk Templates';
	static SavingRiskAssessmentParameterWasNotSuccessfulErrorParameter = 'Failed to save assessment \'{0}\'! Error: \'{1}\'';
	static EmailSendDate = 'Email Sent Date';
	static EventSenderIsPartnerCompany = 'Incident sender is partner company';
	static LogEventType = 'Type';
	static NotificationsQueuedSuccessfully = 'Notification scheduled to be sent!';
	static RiskTreatmentStateNotNeeded = 'Treatments not Needed';
	static InviteInstantMessageChannelUser = 'Invite Participant';
	static LockedTaskParameterCannotBeArchived = 'Locked form \'{0}\' cannot be archived!';
	static ServiceFeePercent = 'Service Fee (%)';
	static RiskReportForEmployees = 'Risk Report for Employees';
	static OneTimeForm = 'One-time Form';
	static RecordUserLogEntryTypeSave = 'Modification';
	static NotSet = 'Not Set';
	static ReportDialogInfoText = 'The report will be based on searched/filtered rows.';
	static DefaultFurtherEducations = 'Default Educations';
	static ExpiresInYear = 'Expires in year';
	static EmptyingReportTrashBinWasNotSuccessfulErrorParameter = 'Failed to empty report trash bin! Error: \'{0}\'';
	static ReadMode = 'Read Mode';
	static DoYouReallyWantToRestoreAppReportParameterFromArchive = 'Do you really want to restore report \'{0}\' from archive?';
	static AddAttachementsMobile = 'Add attachment by tapping plus buttons.';
	static RowsIncludedInPrint = 'Rows that are Included in Print';
	static Users = 'User Accounts';
	static RenewPersonalizationWithUser = 'Replace Personalization with Selected User Account';
	static LineChart = 'Line Chart';
	static UploadDocument = 'Upload File';
	static DeletingRecordQualificationParameterWasNotSuccessfulConcurrencyError = 'Failed to remove qualification \'{0}\',  because data in the qualification has been modified concurrently by another user!';
	static DeletingRiskStakeholdersParameterWasSuccessful = 'Stakeholders \'{0}\' removed successfully!';
	static WhistleBlowGuide = 'Guide for Reporting';
	static OpportunityBenefitPlaceholder = 'Describe what concrete benefit or improvement is sought by utilizing the opportunity.';
	static WhistleBlowAnonymityNonAnonymous = 'Nonanonymous';
	static Attention = 'Attention!';
	static RiskTraceabilityMedium = 'Monitor';
	static SavingInstantMessageChannelParameterWasSuccessful = 'Chat \'{0}\' saved successfully!';
	static PasswordHasBeenSetSuccessfully = 'Password has been set succesfully. Move to login page.';
	static ProcessingFolderParameter = '* Processing folder \'{0}\'...';
	static SavingEventTypeCParameterWasNotSuccessfulErrorParameter = 'Failed to save category 3 \'{0}\'! Error: \'{1}\'';
	static PrintParameterNotFound = 'Print \'{0}\' not found!';
	static BankBICCode = 'Bank BIC Code';
	static CurrentTopics = 'Current Topics';
	static DeletingRiskTemplateParameterWasSuccessful = 'Risk template \'{0}\' removed successfully!';
	static List = 'List';
	static AccessRightRead_DocumentDescription = '* Can read published eSalkku documents in the folder\n* Can view attachments in the folder';
	static ExitingInstantMessageChannelWasNotSuccessfulErrorParameter = 'Failed to exit the chat! Error: \'{0}\'';
	static DeletingTaskPriorityParameterWasNotSuccessfulErrorParameter = 'Failed to remove form priority \'{0}\'! Error: \'{1}\'';
	static DeletingUsersParameterWasNotSuccessfulErrorParameter = 'Failed to remove user accounts \'{0}\'! Error: \'{1}\'';
	static AttachmentIsEmpty = 'Attachment \'{0}\' is empty!';
	static SearchDocuments = 'Search Documents';
	static AddCompanies = 'Add Companies';
	static StudyWeeks = 'Study Weeks';
	static Choose = 'Choose';
	static DeletingRiskTemplateParameterWasNotSuccessfulConcurrencyError = 'Failed to remove risk template \'{0}\', because the data has been modified concurrently by another user!';
	static RestoringRiskParameterFromTrashBinWasNotSuccessfulErrorParameter = 'Failed to restore risk \'{0}\' from trash bin! Error: \'{1}\'';
	static WhistleBlowStatisticsAnonymousRecords = 'Anonymous Reports';
	static ModifiedDescription = 'Modified Description';
	static Base64EncodedBinaryData = 'Base64 encoded binary data';
	static Filters = 'Filters';
	static EventTypesReportTableByCategoryName = 'Table - By Category';
	static DocumentModuleInfoPublishVersionHistorySize = 'Amount of previously published versions are retained when document is published.';
	static RiskAssesmentFrequency = 'Assesment Frequency';
	static AddLogisticVoucherTransportCompany = 'Add Transport Company';
	static DefaultRiskStandards = 'Default Standards';
	static FileParameterNotFound = 'File \'{0}\' not found!';
	static DeletingCompanyGroupsParameterWasSuccessful = 'Company groups \'{0}\' removed successfully!';
	static PreviewWeb = 'Preview (Web)';
	static LockedRiskParameterCannotBeMovedToTrashBin = 'Locked risk \'{0}\' cannot be moved to trash bin!';
	static DeletingMessageTypeParameterWasNotSuccessfulUsedInParameterMessages = 'Failed to remove message type \'{0}\', because the message type is used in {1} messages!';
	static CompanyCodeClaimNotFound = 'User claim \'company code\' not found!';
	static RiskApprovalNotApproved = 'Not Approved';
	static SavingTaskTypeParameterWasSuccessful = 'Form template \'{0}\' saved successfully!';
	static PostalAddress = 'Street Address';
	static OldPassword = 'Old Password';
	static TaskModuleProperties = 'Forms Properties';
	static UserRecordStatisticsUserAccountConnectedCards = 'User Account Connected Cards';
	static SearchCurrentTopics = 'Search Current Topics';
	static ArchivingTaskParameterWasNotSuccessfulConcurrencyError = 'Failed to archive form \'{0}\', because data in the form has been modified concurrently by another user!';
	static RemoveCompany = 'Remove Company';
	static AddDefaultTaskState = 'Add Default Form State';
	static OpportunityDescriptionMustBeDefined = 'Opportunity description must be defined!';
	static TaskHandlerParameterNotFound = 'Person \'{0}\' not found!';
	static CompanyGroup = 'Company Group';
	static AccountNumberTkbInCredit = 'Sales Account';
	static SetPermissions = 'Permissions Summary';
	static ContentVersion = 'Content Version';
	static Identifier = 'Identifier';
	static PageName = 'Page Name';
	static FieldParameterMaxLengthIsParameter = 'Field \'{0}\' max length is {0} characters!';
	static Partner = 'Partner';
	static MyReports = 'User\'s Reports';
	static SavingCalendarTaskCategoryParameterWasNotSuccessfulConcurrencyError = 'Failed to save category \'{0}\', because data in the category has been modified concurrently by another user!';
	static DeletingRecordUserPartnerParameterWasNotSuccessfulErrorParameter = 'Failed to remove resource partner \'{0}\'! Error: \'{1}\'';
	static PasswordConfirmationDoesNotMatchPassword = 'Password does not match the confirm password!';
	static CompanyGroupNameMustBeDefined = 'Name of the company group must be defined!';
	static EditDefaultHandlers = 'Edit Default Handlers';
	static CalendarTaskRemoveSeries = 'Remove Series';
	static Receiver = 'Receiver';
	static Sorting = 'Sorting';
	static LogSizeInDays = 'Log Size in Days (0 = No Limit)';
	static UnpublishingOpportunityParameterWasNotSuccessfulConcurrencyError = 'Failed to unpublish opportunity \'{0}\', because the data has been modified concurrently by another user!';
	static RemovingTaskTypeUnitsWasSuccessful = 'Units removed successfully!';
	static AllJobTitles = 'All Job Titles';
	static EventPartnerIsAlreadyInDefined = 'Incident partner is already defined!';
	static ApprovalJustification = 'Approval Justification';
	static SavingRecordFamiliarizationParameterWasSuccessful = 'Familiarization \'{0}\' saved successfully!';
	static PublishingReportParameterWasNotSuccessfulConcurrencyError = 'Failed to publish report \'{0}\', because data in the report has been modified concurrently by another user!';
	static GeneralInfo = 'General';
	static RiskTreatmentStateLate = 'Late';
	static EventApprovalWasSuccessful = 'Incident approved!';
	static ProcessingTimeDays = 'Processing Time (d)';
	static SavingRiskStandardParameterWasNotSuccessfulConcurrencyError = 'Failed to save standard \'{0}\', because the data has been modified concurrently by another user!';
	static ArchivingWhistleBlowsParameterWasNotSuccessfulErrorParameter = 'Failed to archive whistle blow reports \'{0}\'! Error: \'{1}\'';
	static SelectTaskType = 'Select Form Template';
	static DeletingTaskDataRowWasNotSuccessfulConcurrencyError = 'Failed to remove the form row, because data in the form row has been modified concurrently by another user!';
	static DoYouReallyWantToArchiveOpportunityParameter = 'Do you really want to archive opportunity \'{0}\'?';
	static SavingEventTypeParameterWasNotSuccessfulErrorParameter = 'Failed to save category 1 \'{0}\'! Error: \'{1}\'';
	static State = 'State';
	static ParameterIsNotValidAccountIBANNumber = '\'{0}\' is not valid bank account IBAN number!';
	static WhistleBlowPasswordConfirmed = 'Whistle blow report has been sent. You can check the status of your report by clicking "Follow Report" button on the main page.';
	static DoYouReallyWantToRestoreAppReportParameterFromATrashBin = 'Do you really want to restore report \'{0}\' from trash bin?';
	static FormulaMax = 'Maximum';
	static SavingRecordUserQualificationParameterWasNotSuccessfulErrorParameter = 'Failed to save qualification \'{0}\'! Error: \'{1}\'';
	static WhistleBlowResolutionCanceled = 'Canceled';
	static AddRiskFromTemplate = 'Add Risk from Template';
	static BasicInformation = 'General';
	static MaximumSizeOfSingleAttachment = 'Maximum size of a attachment is {0} MB!';
	static AddingAttachmentParameterWasSuccessful = 'Attachment \'{0}\' added successfully!';
	static WhistleBlowReportIHaveSavedThePassword = 'I have stored the password in the safe storage so I can use it for checking the status of my report.';
	static MicrosoftAccount = 'Microsoft Account';
	static AccessRightWrite_CalendarTaskDescription = '* Can create and edit their own private calendar events\n* Can create and edit public calendar events';
	static SavingRiskTemplateParameterWasNotSuccessfulErrorParameter = 'Failed to save risk template \'{0}\'! Error: \'{1}\'';
	static AddingTaskHandlersWasSuccessful = 'Persons added successfully!';
	static FileParameterAlreadyExistsInFileSystem = 'File \'{0}\' already exists in the filesystem!';
	static DoYouWantToPublishEvent = 'Do you want to publish the incident?';
	static AddingAttachmentParameterWasNotSuccessfulErrorParameter = 'Failed to add attachment \'{0}\'! Error: \'{1}\'';
	static FormMaxTextLength = 'Maximum Text Length';
	static UserRecordStatisticsActiveCards = 'Active Cards';
	static NoCalendarTasksToShow = 'No events to show';
	static WhistleBlowDescriptionMustBeDefined = 'Incident description must be defined!';
	static AddingReportTemplateUnitsWasNotSuccessfulErrorParameter = 'Failed to add units! Error: \'{0}\'';
	static TransferredPropertyType = 'Transferred Property Type';
	static Employment = 'Employment';
	static Files = 'Files';
	static AddUsersParameterWasNotSuccessfulConcurrencyError = 'Failed to add user accounts \'{0}\', because the data has been modified concurrently by another user!';
	static Close = 'Close';
	static DeletingTaskStatesParameterWasNotSuccessfulErrorParameter = 'Failed to remove form states \'{0}\'! Error: \'{1}\'';
	static DeletingRecordUserEmploymentParameterWasNotSuccessfulConcurrencyError = 'Failed to remove employment \'{0}\',  because data in the employment has been modified concurrently by another user!';
	static AllCalendarTaskUsers = 'All calendar users';
	static FormExpressionEditor = 'Expression Editor';
	static DoYouReallyWantToRemoveUserParameter = 'Do you really want to remove user \'{0}\'?';
	static DeletingRiskCategoriesParameterWasSuccessful = 'Risk categories \'{0}\' removed successfully!';
	static ExpireTime = 'Expire Time';
	static SavingEventUrgencyClassParameterWasNotSuccessfulConcurrencyError = 'Failed to save urgency class \'{0}\', because data in the urgency class has been modified concurrently by another user!';
	static FileParameterIsNotOpenXmlWorkbook = 'File \'{0}\' is not open xml workbook (.xlsx tai .xlsm)!';
	static ChartProperties = 'Chart Properties';
	static RestoringOpportunityParameterFromArchiveWasNotSuccessfulErrorParameter = 'Failed to restore opportunity \'{0}\' from trash bin! Error: \'{1}\'';
	static EmptyingTaskTrashBinWasNotSuccessfulConcurrencyError = 'Failed to empty form trash bin, because data in the forms has been modified concurrently by another user!';
	static DoYouReallyWantToRemoveSelectedApprovers = 'Do you really want to remove selected approvers?';
	static DeletingCompaniesParameterWasNotSuccessfulErrorParameter = 'Failed to remove companies \'{0}\'! Error: \'{1}\'';
	static RecordUserReport = 'User Record Report';
	static LogIn = 'Log In';
	static UserGroupsMustBeDefined = 'User groups must be defined!';
	static SystemAdminMessage = 'Message to all system users';
	static GroupByPerson = 'Group by Person';
	static DefaultEventHandlers = 'Default Incident Handlers';
	static SavingRecordUserQualificationParameterWasSuccessful = 'Qualification \'{0}\' saved successfully!';
	static FileStorageQuotaGB = 'File Storage Quota (GB)';
	static SavingUnitsWasNotSuccessfulConcurrencyError = 'Failed to save units, because data in units has been modified concurrently by another user!';
	static DeletingRiskProcessParameterWasNotSuccessfulErrorParameter = 'Failed to remove my classification \'{0}\'! Error: \'{1}\'';
	static AuthorizationLevelSystemAdmin = 'System Administrator';
	static DeletingTaskPriorityParameterWasSuccessful = 'Form priority \'{0}\' removed successfully!';
	static DeletingTaskParameterWasNotSuccessfulErrorParameter = 'Failed to remove form \'{0}\'! Error: \'{1}\'';
	static AddTask = 'Add Form';
	static SavingImagesWasSuccessful = 'Images saved successfully!';
	static Parameters = 'Parameters';
	static TasksFound = 'FormsFound';
	static ModifiedActions = 'Modified Actions';
	static MessageMustBeSavedBeforeAttachmentsCanBeAdded = 'Message must be saved before attachments can be added!';
	static EmailAddressParameterIsInvalid = 'Email address \'{0}\' is not valid!';
	static EditRemainder = 'Edit Remainder';
	static SavingMessageTypeParameterWasSuccessful = 'Message type \'{0}\' saved successfully!';
	static SavingEventParameterWasNotSuccessfulConcurrencyError = 'Failed to save incident \'{0}\', because data in the incident has been modified concurrently by another user!';
	static RequestParameterNotFound = 'Request \'{0}\' not found!';
	static Filtered = 'Filtered';
	static Handlers = 'Handlers';
	static WhistleBlowSeverityLow = 'Low';
	static AddingRecordUserSalaryRowsWasNotSuccessfulErrorParameter = 'Failed to add salary rows! Error: \'{0}\'';
	static SavingWhistleBlowChannelParameterWasSuccessful = 'Whistle blow channel \'{0}\' saved successfully!';
	static EmploymentType = 'Employment Type';
	static EventTypeMustBeDefined = 'Category 1 must be defined!';
	static EmployeeTypeMustBeDefined = 'Employment type must be defined!';
	static WhistleBlowFollowReport = 'Follow Report';
	static ControlEffiencyMustBeDefined = 'Control effiency must be defined!';
	static FormulaExponent = 'Exponent';
	static DoYouReallyWantToRemoveChartPanelParameter = 'Do you really want to remove chart \'{0}\'?';
	static DefaultEventHandlerParameterNotFound = 'Default incident handler \'{0}\' not found!';
	static EmptyTaskTrashBinConfirmation = 'Do you really want to permanently remove all forms from trash bin? Removed forms cannot be restored.';
	static SystemSettings = 'System Settings';
	static LockingTaskParameterWasNotSuccessful = 'Failed to lock form \'{0}\'!';
	static NoInstantMessageChannelsToShow = 'No chats to show!';
	static FormExpressionMustBeDefined = 'Uttryck måste definieras!';
	static SavingUserParameterParameterWasNotSuccessfulErrorParameter = 'Failed to save user option \'{0}\'! Error: \'{1}\'';
	static RiskControls = 'Controls';
	static ReportsModified = 'Favorite Reports';
	static Hours = 'hours';
	static PasswordMustContainUppercaseChar = 'Password must contain uppercase alphabet!';
	static AddingEventHandlersWasSuccessful = 'Handlers added successfully!';
	static WhistleBlowUrl = 'Whistle Blow Channel Web Address';
	static SavingTaskStateParameterWasNotSuccessfulErrorParameter = 'Failed to save form state \'{0}\'! Error: \'{1}\'';
	static DocumentModuleInfoFileFilters = 'Document file filters are used to restrict the visibility of files within the folder. Visibility is limited for users who have read access to the folder.';
	static SharedReportCompany = 'Shared to company';
	static WhistleBlowCategories = 'Whistle Blow Categories';
	static TheSystemDoesNotSupportYourWebBrowserUpdateToLatestBrowserVersion = 'This system does not support your web browser. Update your web browser to latest version.';
	static DocumentHasBeenModifiedAfterItWasPublished = 'Document has been modified after it was published.';
	static NewComment = 'New Comment';
	static AccessRightWrite_InstantMessageDescription = 'Can start chats and group chats with users in own and linked companies';
	static DoYouReallyWantToRemoveFileFilterParameter = 'Do you really want to remove file filter \'{0}\'?';
	static AppReportTemplateModuleInfoCompanyReportTemplatesNotFound = 'Report templates not defined, create new report template by clicking + button.';
	static WhistleBlowInformantHasReadMessage = 'Whistle blow report informant has read your message';
	static AccessRightNone_LogDescription = 'No access to log entries';
	static Opportunities = 'Opportunities';
	static WageGroup = 'Wage Group';
	static ValidPlural = 'Valid';
	static DeletingTaskParameterWasSuccessful = 'Form \'{0}\' removed successfully!';
	static ProjectName = 'Project Name';
	static ApproveEventHandlerConfirmation2 = 'Do you really want to approve incident?';
	static RemoveInstantMessageChannelUser = 'Remove participant';
	static RemoveEventTypeB = 'Remove Category 2';
	static InTrashBin = 'In Trash Bin';
	static ErrorUserChangeWouldLeadToInvalidDefaultEventHandlers = 'User changes will lead to situation where some default incident handlers or notified persons do not have permissions to handle incidents of units. Changes that have affect for default incident handlers or notified persons can be made only in \'Incidents Properties\' dialog!';
	static DoYouReallyWantToRemoveCalendarTaskParameter = 'Do you really want to remove event \'{0}\'?';
	static RelatedToDatabaseRecordType = 'Related to';
	static Selected = 'Selected';
	static RestoringReportParameterFromArchiveWasNotSuccessfulErrorParameter = 'Failed to restore report \'{0}\' from archive! Error: \'{1}\'';
	static LastNameMustBeDefined = 'Last name must be defined!';
	static FileFilterCodeIsAlreadyInUse = 'File filter code is already in use!';
	static DeletingDefaultEventHandlerParameterWasNotSuccessfulConcurrencyError = 'Failed to remove default incident handler \'{0}\', because data in the default incident handler has been modified concurrently by another user!';
	static DeletingTaskPriorityParameterWasNotSuccessfulConcurrencyError = 'Failed to remove form priority \'{0}\', because data in the form priority has been modified concurrently by another user!';
	static SavingJobParameterWasSuccessful = 'Job \'{0}\' saved successfully!';
	static Orientation = 'Orientation';
	static LastYear = 'Last Year';
	static RestoringTaskParameterFromTrashBinWasNotSuccessfulErrorParameter = 'Failed to restore form \'{0}\' from trash bin! Error: \'{1}\'';
	static DoYouReallyWantToRemoveSelectedTaskStates = 'Do you really want to remove selected form states?';
	static Usage = 'Usage';
	static RequestPasswordChangeLinkHasBeenSentTitle = 'Password Change Link';
	static AddQualificationToMultipleUserRecords = 'Add Qualification to Multiple User Records';
	static Qualifications = 'Qualifications';
	static AddUsers = 'Add User Accounts';
	static RemoveAttachment = 'Remove Attachment';
	static DoYouReallyWantToRemoveEventTypeCParameter = 'Do you really want to remove category 3 \'{0}\'?';
	static AddEventUrgencyClass = 'Add Urgency Class';
	static ThisChannelHasBeenArchived = 'This chat has been archived!';
	static RiskProcessParameterIsInUse = 'My classification \'{0}\' is used in {1} risks and cannot be removed!';
	static WhistleBlowReportHasBeenSaved = 'Whistle blow report has be saved';
	static AddCompanyGroupsParameterWasNotSuccessfulConcurrencyError = 'Failed to add company groups \'{0}\', because the data has been modified concurrently by another user!';
	static EditLogisticVoucherCustomerPaymentSetting = 'Edit Payment Setting';
	static Functions = 'Functions';
	static PersonInCharge = 'Person in Charge';
	static ChangedUrgencyClass = 'Changed incident urgency class';
	static LastName = 'Last Name';
	static CopyingFilesAndDocumentsToFolderParameterWasSuccessful = 'Files/documents copied into folder \'{0}\' successfully!';
	static Undefined = 'Undefined';
	static RemoveSharedDocumentTemplate = 'Remove Shared Document Template';
	static AddTaskState = 'Add Form State';
	static ReportTemplate = 'Report Template';
	static ImportingTaskDataRowsWasNotSuccessfulErrorParameter = 'Failed to import rows! Error: \'{0}\'';
	static ApprovalAuthorityMustBeDefined = 'Authority must be defined!';
	static Landscape = 'Landscape';
	static AccessRightRead_Task_C = 'Fill access (own)';
	static InTesting = 'In Testing';
	static FormTextAlignmentRight = 'Align Text Right';
	static SavePrint = 'Save Print';
	static CalendarTaskRepetitionEndDatePrefix = 'After date';
	static GroupByEducation = 'Group by Education';
	static SelectCompanyGroup = 'Select Company Group';
	static ANew = 'New';
	static MessagePreservationTime = 'Message Preservation Time';
	static EventTypeCostsReportTableIndirectCostsByCategoryName = 'Table - Indirect Costs - By Category';
	static AllSelected = 'All Selected';
	static ModifyExistingSharedDocumentTemplate = 'Modify existing shared document template';
	static RemoveFilter = 'Remove Filter';
	static RestoreFromArchive = 'Restore from Archive';
	static InstantMessageAttachmentFolderParameterNotFound = 'Application instant message attachment folder \'{0}\' not found!';
	static DocumentTemplateCodeIsAlreadyInUse = 'Document template code is already in use!';
	static DefaultStyle = 'Default';
	static EventSettings = 'Incident Settings';
	static ShowReportRowAmountInFrontPage = 'Show report row amount in front page';
	static Properties = 'Properties';
	static RequestPasswordChangeLinkHasBeenSent = 'If the username you entered is registered in the eSalkku system, you will receive an email with a link to change your password. If the message is not in your inbox, please also check your spam folder.';
	static SeasonalWorker = 'Seasonal Worker';
	static DeletingAttachmentsParameterWasNotSuccessfulErrorParameter = 'Failed to remove attachments \'{0}\'! Error: \'{1}\'';
	static EditEventTypeBs = 'Edit Category 2';
	static AccessRightWriteWhistleBlow = 'Full reports handling';
	static DeletingWhistleBlowParameterWasNotSuccessfulConcurrencyError = 'Failed to remove whistle blow report \'{0}\',  because data in the whistle blow report has been modified concurrently by another user!';
	static RestoreTaskFromTrashBin = 'Restore Form from Trash Bin';
	static QrCodeUsers = 'QR Code User Accounts';
	static AttachmentParameterDownloaded = 'Attachment has been downloaded.';
	static PrintRowInformation = 'Print Row Information';
	static Task = 'Form';
	static AddCompanyTaskType = 'Add Form Template to Company';
	static RiskModuleInfoRiskCategories = 'Categories are used to group risks and opportunities by topic, such as personnel, environment or business.';
	static CreatingPrint = 'Creating print...';
	static SavingWhistleBlowChannelParameterWasNotSuccessfulErrorParameter = 'Failed to save whistle blow channel \'{0}\'! Error: \'{1}\'';
	static Sending = 'Sending...';
	static PermissionsToCreateEventsToEventPartner = 'Permission to Create Incidents to Partner';
	static UserParameterHasInvitedYouToJoinInstantMessageChannelParameter = 'User \'{0}\' has invited you to join in chat';
	static AuthorizationLevelNone = 'No Rights';
	static FiscalNumber = 'Fiscal Number';
	static Code = 'Code';
	static RiskLevelNegligible = 'Negligible';
	static AccessRightWrite_AppReport_A = 'Extended edit access';
	static Panels = 'Panels';
	static AllDay = 'All Day';
	static AccessRightWrite_InstantMessage_A = 'Internal / External chats and permissions';
	static CurrentWorkPlaceNotAdded = 'Current workplace not added!';
	static DeletingCalendarTaskCategoryParameterWasNotSuccessfulConcurrencyError = 'Failed to remove category \'{0}\', because data in the category has been modified concurrently by another user!';
	static AccessRightWrite_Record = 'All unit\'s user records';
	static SavingSettingsWasSuccessful = 'Settings saved successfully!';
	static SavingDirectoryItemFolderParameterWasNotSuccessfulConcurrencyError = 'Failed to save folder \'{0}\', because data in the folder has been modified concurrently by another user!';
	static RecordFurtherEducationCodeIsAlreadyInUse = 'Education name is already in use!';
	static DeletingOneTimePasswordWasNotSuccessfulErrorParameter = 'Failed to remove one time password! Error: \'{0}\'';
	static Others = 'Others';
	static SavingUserGroupParameterWasNotSuccessfulConcurrencyError = 'Failed to save user group \'{0}\', because data in the user group has been modified concurrently by another user!';
	static ReportGenerationAborted = 'Report creation canceled!';
	static AdminMessage = 'Message to managers';
	static MovingOpportunityParameterToTrashBinWasNotSuccessfulErrorParameter = 'Failed to move opportunity \'{0}\' to trash bin! Error: \'{1}\'';
	static DeletingInstantMessageWasNotSuccessfulConcurrencyError = 'Failed to remove instant message, because data in the instant message has been modified concurrently by another user!';
	static NewCompanyGroupMustBeSavedBeforeUsersCanBeAdded = 'New company group must be saved before companies can be added!';
	static RiskApprovalApproved = 'Approved';
	static UserParameterNotFound = 'User \'{0}\' not found!';
	static DocumentModuleProperties = 'Documents Properties';
	static AccessRightNone_RiskDescription = 'No access to the unit’s risks and opportunities';
	static NotInUse = 'Not in Use';
	static AddImageFromClipboard = 'Add image from clipboard';
	static SaveReport = 'Save Report';
	static AddEventTypeCsToEvent = 'Add category 3 by tapping the pen button.';
	static FormTime = 'Time (< 24h)';
	static CopyingFileParameterWasNotSuccessfulErrorParameter = 'Failed to copy file \'{0}\' as file \'{1}\' in filesystem! Error: \'{2}\'';
	static AccessRightNone_CalendarTaskDescription = 'No access to the calendar';
	static AnyTime = 'Any Time';
	static EnterUserName = 'Enter user name!';
	static AddDefaultEventHandler = 'Add Default Incident Handler';
	static RenamingFileParameterWasNotSuccessfulErrorParameter = 'Failed to rename file (\'{0}\' => \'{1}\') in filesystem! Error: \'{2}\'';
	static Salary = 'Salary';
	static DeletingEditableDocumentParameterWasSuccessful = 'Document \'{0}\' removed successfully!';
	static AccessRightRead_Message_A = 'Extended read access';
	static FilesParameterAreEmpty = 'Files \'{0}\' are empty!';
	static SavingRecordUserParameterWasNotSuccessfulConcurrencyError = 'Failed to save user record \'{0}\', because user record data has been modified concurrently by another user!';
	static RiskAssessment = 'Assessment';
	static RecordBasicEducationParameterIsInUseInParameterRecordUsersAndCannotBeDeleted = 'Basic education \'{0}\' is used in {1} user records and cannot be removed!';
	static SavingFileFilterParameterWasNotSuccessfulConcurrencyError = 'Failed to save file filter \'{0}\', because data in the file filter has been modified concurrently by another user!';
	static DoYouReallyWantToUnlockEvent = 'Do you really want to unlock incident \'{0}\'?';
	static DoYouReallyWantToRemoveCompanyParameter = 'Do you really want to remove company \'{0}\'?';
	static RiskLikelihood5 = 'Almost Certain';
	static RiskLikelihood4 = 'Probable';
	static FormTexts = 'Texts';
	static RiskLikelihood2 = 'Unlikely';
	static RiskLikelihood1 = 'Improbable';
	static DocumentNameIsIllegal = 'Document name is not allowed (reserved name)!';
	static WhistleBlowSourceOther = 'Other';
	static LastParameterYears = 'Last {0} Years';
	static DeletingKeywordParameterWasSuccessful = 'Keyword \'{0}\' removed successfully!';
	static SelectedDocumentTypes = 'Show only selected document types';
	static SelectEventType = 'Select Category 1';
	static SavingTaskPriorityParameterWasSuccessful = 'Form priority \'{0}\' saved successfully!';
	static RiskManagement = 'Risk Management';
	static AddUsersParameterWasSuccessful = 'User accounts \'{0}\' added successfully!';
	static SavingApplicationPermissionsWasNotSuccessfulConcurrencyError = 'Failed to save system permissions, because data in system permissions has been modified concurrently by another user!';
	static DoYouReallyWantToExitInstantMessageChannel = 'Do you really want to exit the chat?';
	static CurrentWorkPlace = 'Current Workplace';
	static AddUserToUserGroup = 'Add User Account into User Group';
	static FormulaSin = 'Sine';
	static FormIntegerNumber = 'Integer';
	static Info = 'Info';
	static ReportTemplateParameterNotFound = 'Report template \'{0}\' not found!';
	static AddRow = 'Add Row';
	static DeletingInstantMessageChannelWasNotSuccessfulErrorParameter = 'Failed to remove chat! Error: \'{0}\'';
	static ViewLogLine = 'Show Log Line';
	static AddPartnersParameterWasNotSuccessfulErrorParameter = 'Failed to add partners \'{0}\'! Error: \'{1}\'';
	static DoYouReallyWantToMoveTaskParameterToTrashBin = 'Do you want to move form \'{0}\' to trash bin?';
	static Reminders = 'Reminders';
	static UserIdClaimNotFound = 'User claim \'id\' not found!';
	static ReportBuilder = 'Report Builder';
	static DeletingDocumentTemplatesParameterWasNotSuccessfulConcurrencyError = 'Failed to remove document templates \'{0}\', because data in document templates has been modified concurrently by another user!';
	static SavingEventMessageWasSuccessful = 'Comment saved successfully!';
	static CalendarTaskRepetitionEnd = 'Finish';
	static WhistleBlowChannelPageNameCodeIsAlreadyInUse = 'Whistle blow chanel page name is already in use!';
	static Remainder = 'Remainder';
	static DeletingRecordUserTransferredPropertiesParameterWasNotSuccessfulConcurrencyError = 'Failed to remove transferred properties \'{0}\',  because data in transferred properties has been modified concurrently by another user!';
	static LockedReportParameterCannotBeSaved = 'The report \'{0}\' has been locked to another user and it cannot be saved!';
	static RiskStandardCodeIsAlreadyInUse = 'Standard name is already in use!';
	static InstantMessageChannelAdministrator = 'Administrator';
	static SavingRiskCategoryParameterWasNotSuccessfulConcurrencyError = 'Failed to save risk category \'{0}\', because the data has been modified concurrently by another user!';
	static TaskTypeSchemaMustBeDefined = 'Form template schema must be defined!';
	static MovingFilesAndDocumentsToFolderParameterWasSuccessful = 'Files/Documents moved into folder \'{0}\' successfully!';
	static UserClaimParameterNotFoundNotFound = 'User claim \'{0}\' not found!';
	static EditDefaultEventType = 'Edit Default Category 1';
	static QrCode = 'QR Code';
	static CustomerNumber = 'Customer Number';
	static Browse = 'Browse';
	static HoursPerTrainingDay = 'Hours per Training Day';
	static DeletingInstantMessageUserParameterWasNotSuccessfulConcurrencyError = 'Failed to remove participant \'{0}\', because the data has been modified concurrently by another user!';
	static FrontPageDocuments = 'eSalkku Instructions';
	static WorkShift = 'Work Shift';
	static Uploaded = 'Uploaded';
	static ToggleSidePanel = 'Show/Hide Side Panel';
	static SharedReportTemplates = 'Shared Report Templates';
	static DocumentModified = 'Last Modified By';
	static PublishingOpportunityParameterWasSuccessful = 'Opportunity \'{0}\' published successfully!';
	static RemoveEventTypeC = 'Remove Category 3';
	static RecordUserExcelFamiliarization = 'Familiarizations';
	static TaskDataRowsToBeImported = 'Rows to be Imported';
	static ChangeToReadMode = 'Change to Read Mode';
	static Previous = 'Previous';
	static RequestPasswordChangeMessage3 = 'button. Email that contains information how to reset your password will be sent to email address that is connected to your user account.';
	static RequestPasswordChangeMessage2 = 'Send';
	static RequestPasswordChangeMessage1 = 'If you have forgot your password fill your current eSalkku username below and click ';
	static AddPanel = 'Add Panel';
	static EditSharedDocumentTemplate = 'Edit Shared Document Template';
	static AddEmployment = 'Add Employment';
	static DocumentParameterAlreadyExists = 'Document \'{0}\' already exists in the folder!';
	static RiskCategoryParameterHasChildNodesAndCannotBeDeleted = 'Category \'{0}\' contains risk subcategories and cannot be removed!';
	static EmptyDocument = 'Empty document';
	static WhistleBlowReportHasBeenSavedBottomText = 'You must store the password before you can close this page.';
	static FolderCannotBeMovedToItsSubFolder = 'Folder cannot be moved in its own subfolder!';
	static DeletingUserGroupUsersOfCompanyParameterWasSuccessful = 'User group connections related to company \'{0}\' removed successfully!';
	static PublishingOpportunityParameterWasNotSuccessfulConcurrencyError = 'Failed to publish opportunity \'{0}\', because the data has been modified concurrently by another user!';
	static AddFileOrTakePicture = 'Add a file or take a picture';
	static Minutes = 'Minutes';
	static RemovingRiskAssessmentHandlersWasNotSuccessfulErrorParameter = 'Failed to remove persons! Error: \'{0}\'';
	static ReminderDaysBefore = 'days before';
	static DocumentNameParameterConstainsIllegalCharacters = 'Document name \'{0}\' contains forbidden characters (<, >, :, ", /, \, |, ? or *) or ends with forbidden character (., \' \')!';
	static WhistleBlowDescriptionEditReasonDefaultValue = 'Personal data not necessary for resolving the matter has been removed from the report. The removal does not affect the processing of the report.';
	static QrCodeUserGroups = 'QR Code User Groups';
	static SendingEmail = 'Sending email...';
	static AddUserGroups = 'Add User Groups';
	static RemoveRecordUserAndUser = 'Remove User Record and User Account';
	static DeletingRecordBasicEducationParameterWasNotSuccessfulConcurrencyError = 'Failed to remove basic education \'{0}\',  because data in the basic education has been modified concurrently by another user!';
	static RecordUserModuleInfoUnits = 'Units can be used for grouing user records.';
	static EventTypeCParameterNotFound = 'Category 3 \'{0}\' not found!';
	static InUse = 'In Use';
	static TaskHandler = 'Limited Visibility';
	static YouHaveNotSavedChangesSaveChangesBeforePublishingTaskType = 'You have not saved changes that you have made. Save changes before publishing the form template.';
	static DeletingRiskTemplatesParameterWasSuccessful = 'Risk templates \'{0}\' removed successfully!';
	static ScopeUnit = 'Unit';
	static ArchivingRiskParameterWasNotSuccessfulErrorParameter = 'Failed to archive risk \'{0}\'! Error: \'{1}\'';
	static AccessRightNone_RecordDescription = 'No access to records';
	static RiskLevel = 'Risk Level';
	static UnitParameterNotFound = 'Unit \'{0}\' was not found!';
	static Invoicing = 'Invoicing';
	static SortOrder = 'Sort order';
	static CurrentCalendarYear = 'Current Calendar Year';
	static FileFilterNameMustBeDefined = 'File filter name must be defined!';
	static Start = 'Start';
	static FormCalculated = 'Calculated';
	static DocumentProperties = 'File/Document Properties';
	static EventTypeBParameterNotFound = 'Category 2 \'{0}\' not found!';
	static FolderProperties = 'Folder Properties';
	static Send = 'Send';
	static SavingMessageParameterWasNotSuccessfulConcurrencyError = 'Failed to save message \'{0}\', because data in the message has been modified concurrently by another user!';
	static MaximumPasswordLengthCanParameterCharacters = 'Maximum password length can be {0} characters!';
	static SavingRecordUserPartnerParameterWasSuccessful = 'Resource partner \'{0}\' saved successfully!';
	static EventTypeCostsReportPieChartDirectCostsName = 'Pie Chart - Direct Costs';
	static WhistleBlowMustBeReceivedLatestAtParameter = 'Whistle blow report must be marked as received {0} at the latest!';
	static AccessRightRead_RiskDescription = 'Can read published risks and opportunities';
	static UnpublishingRiskParameterWasSuccessful = 'Risk \'{0}\' unpublished successfully!';
	static FormBooleans = 'True/False';
	static DeletingRiskCategoryParameterWasNotSuccessfulConcurrencyError = 'Failed to remove risk category \'{0}\', because the data has been modified concurrently by another user!';
	static PrivacyPolicy = 'Privacy Policy';
	static DeletingRecordBasicEducationsParameterWasSuccessful = 'Basic educations \'{0}\' removed successfully!';
	static ActiveUserRightsCannotBeCopiedToDirectoryItemFolderParameter = 'Active Permissions Cannot Be Copied to Folder \'{0}\'!';
	static NoFurtherEducationsToShow = 'No educations to show!';
	static EditTaskPriority = 'Edit Form Priority';
	static Permissions = 'Permissions';
	static FormSortField = 'Sort Field';
	static RemoveRiskCategory = 'Remove Category';
	static RiskTemplateUsedInAllUnits = 'Risk template is usable in all units';
	static MessageModuleProperties = 'Current Topics Properties';
	static RiskTemplatesMustBeDefinedBeforeAddingRisks = 'Risk templates must be defined before adding risks!';
	static RecordBasicEducationParameterNotFound = 'Basic education \'{0}\' not found!';
	static AddWhistleBlowChannelAdminsParameterWasSuccessful = 'Administrators \'{0}\' added successfully!';
	static CalendarTaskRepetitionRepeatIntervalMonthPrefix = 'Day';
	static InstantMessageChannelArchivingTypeRemoveChannelAtDateParameter = 'Remove Archived Chat and Messages at {0}';
	static FurtherEducationReports = 'Education Reports';
	static EditableDocumentCodeIsAlreadyInUse = 'Document name is already in use!';
	static SearchEndDate = 'End Date';
	static FormulaDateAndTimeDiffInTimeSpan = 'Time difference in hours';
	static EventsDashboard = 'Incidents Dashboard';
	static AssesmentPeriod = 'Assesment Period';
	static DeletingAttachmentParameterWasNotSuccessfulConcurrencyError = 'Failed to remove attachment \'{0}\', because the data has been modified concurrently by another user!';
	static ApprovalJustificationPlaceholder = 'Please justify here why the risk is accepted or conditionally accepted.';
	static SendPasswordChangeEmail = 'Send Password Change Link by Email';
	static AllPartners = '\'All Partners\'';
	static ActiveUserRights = 'Active Permissions';
	static TaskDefaultPrioritiesInUse = 'Default priorities in use';
	static PasswordHasBeenCopiedToClipboard = 'Password has been copied to clipboard!';
	static InstantMessageChannelUsersNotUsable = 'User does not anymore belong to chat participants';
	static NotImplementedYet = 'Not implemented yet!';
	static AccessRightWrite = 'Edit access';
	static FormVerticalDirection = 'Vertical Layout';
	static LockedCalendarTaskParameterCannotBeSaved = 'The event \'{0}\' has been locked to another user and it cannot be saved!';
	static DeletingWhistleBlowChannelAdminsParameterWasNotSuccessfulErrorParameter = 'Failed to remove administrators \'{0}\'! Error: \'{1}\'';
	static ChartGenerationFailed = 'Failed to create chart!';
	static RemoveReport = 'Remove Report';
	static RestoreReportFromTrashBin = 'Restore Report from Trash Bin';
	static SavingTaskStateParameterWasSuccessful = 'Form state \'{0}\' saved successfully!';
	static CheckingExistanceOfFolderParameterWasNotSuccessfulErrorParameter = 'Failed to check existance of folder \'{0}\' in filesystem! Error: \'{1}\'';
	static RiskLikelihood3 = 'Moderate';
	static AddAttachment = 'Add Attachment';
	static WhistleBlowStatisticsInProgressRecords = 'In Progress Reports';
	static SelectRiskCategory = 'Select Category';
	static AllLogisticVoucherCustomers = 'All Customers';
	static Change = 'Change';
	static AddOpportunity = 'Add Opportunity';
	static CourseCredit = 'Course Credit';
	static PasswordMustBeDefined = 'Password must be defined!';
	static DeletingUserGroupParameterWasNotSuccessfulErrorParameter = 'Failed to remove user group \'{0}\'! Error: \'{1}\'';
	static RiskLevelCritical = 'Critical';
	static NewMenu = 'New Menu';
	static ClearSubUnitDefaultHandlersAndNotifiedPersons = 'Clear Subunit Default Handlers and Notified Persons';
	static DocumentTypes = 'Document Types';
	static RecordUserWithSameFirstNameMiddleNameAndLastNameAlreadyExists = 'User record with the same first name \'{0}\', last name \'{2}\' and middle name \'{1}\' already exists!';
	static WhistleBlowInternalMessageConfirmation = 'Do you want to save new internal message?';
	static RemovingCalendarTaskHandlersWasSuccessful = 'Handlers removed successfully!';
	static SelectRemovingMethod = 'Select Removing Method';
	static RestoreFromTrashBin = 'Restore from Trash Bin';
	static ClearSubFolderPermissions = 'Clear Subfolder Permissions';
	static MinimumPasswordLength = 'Minimum Password Length';
	static DocumentNameIsTooLong = 'Document name \'{0}\' is too long!';
	static FormTextArea = 'Long Text Input';
	static SavingInstantMessageChannelUserUserWasSuccessful = 'Participant saved successfully!';
	static EventModuleInfoPermissions = 'Visibility and access rights for incidents channels. Access can be granted to QR code users.';
	static RecordUserSettingsParameterNotFound = 'Resource settings \'{0}\' not found!';
	static Administrator = 'Administrator';
	static EventTypeCParameterChildrenAreInUseInParameterEventsAndCannotBeDeleted = 'Category 3 \'{0}\' subcategories are used in {1} incidents and category 3 cannot be removed!';
	static AddingRiskAssessmentHandlersWasSuccessful = 'Persons added successfully!';
	static User = 'User Account';
	static IncludeOnlyActiveUsers = 'Include only users with active user account and current work place';
	static RiskModuleInfoRiskStandards = 'Enable this if you want to link risks and opportunities to standards. Standard information is used in filters and reports.';
	static UserIsSystemAdminClaimNotFound = 'User claim \'userIsSystemAdmin\' not found!';
	static JobTypePushNotification = 'Push Notification';
	static SharedReport = 'Shared Report';
	static SavePasswordAndMoveToLoginPage = 'Save Password and Move to Login Page';
	static RemoveCompanyTaskType = 'Remove Company Form Template';
	static AddEventType = 'Add Category 1';
	static DeletingRecordUserPartnerParameterWasNotSuccessfulConcurrencyError = 'Failed to remove resource partner \'{0}\', because data in the resource partner has been modified concurrently by another user!';
	static EditLogisticVoucherTransportCompany = 'Edit Transport Company';
	static LogEventTime = 'Time';
	static Intern = 'Intern';
	static SaveAsFavorite = 'Save as Favorite';
	static AddPermission = 'Add Permission';
	static SavingEventTypeParameterWasSuccessful = 'Category 1 \'{0}\' saved successfully!';
	static HandlersMustBeDefined = 'Handlers must be defined!';
	static MessageModuleInfoPermissions = 'Visibility and access rights of Current Topics channels. Access can be granted to QR code users.';
	static RemoveRiskPermanently = 'Remove Risk Permanently';
	static MovingFolderDirectoryItemParameterToFolderParameterWasNotSuccessfulErrorParameter = 'Failed to move folder \'{0}\' into folder \'{1}\'! Error: \'{2}\'';
	static Ascending = 'Ascending';
	static SavingSharedPanelWasNotSuccessfulConcurrencyError = 'Failed to save shared panel, because data in the shared panel has been modified concurrently by another user!';
	static EventTypeCodeIsAlreadyInUse = 'Category 1 name is already in use!';
	static ExpiringIn90Days = 'Include educations expiring in 90 days';
	static DeletingRecordUserEmploymentParameterWasNotSuccessfulErrorParameter = 'Failed to remove employment \'{0}\'! Error: \'{1}\'';
	static WhistleBlowSeverityNormal = 'Normal';
	static Empty = 'Empty';
	static ExternalIntraSystemCompanyTokenMustBeDefined = 'Company token in external eSalkku system must be defined!';
	static Aprint = 'Print';
	static AddDefaultHandler = 'Add Default Handler';
	static DownloadDocument = 'Open/Download Selected Files/Documents';
	static PersonsInCharge = 'Persons in Charge';
	static DeletingDirectoryItemFolderParameterWasNotSuccessfulErrorParameter = 'Failed to remove folder \'{0}\'! Error: \'{1}\'';
	static CompanyGroupParameterNotFound = 'Company group \'{0}\' was not found!';
	static QualificationRequirementParameterValid = 'Qualification: {0} valid educations';
	static RiskTemplateRemoveConfirmation = 'Do you really want to remove risk template \'{0}\'?';
	static NotificationsSentSuccessfully = 'Notifications sent successfully!';
	static LockedTaskParameterCannotBeMovedToTrashBin = 'Locked form \'{0}\' cannot be moved to trash bin!';
	static AddFamiliarizationToMultipleUserRecords = 'Add Familiarization to Multiple User Records';
	static FormulaDateAndTimeDiffInMinutes = 'Time difference in minutes';
	static FormCalculatedDecimalNumber = 'Calculated Decimal';
	static SavingRiskAssessmentParameterWasSuccessful = 'Assessment \'{0}\' saved successfully!';
	static PrintOrientation = 'Print Orientation';
	static CalendarTaskCategoryParameterIsInUseInParameterCalendarTasksAndCannotBeDeleted = 'Category \'{0}\' is used in {1} events and cannot be removed!';
	static AddFolder = 'Add Folder';
	static SavingRecordUserSettingsWasSuccessful = 'Resource settings saved successfully!';
	static WorkShiftType = 'Work Shift Type';
	static FormShowModifyUser = 'Show Modify User';
	static ArchivingOpportunityParameterWasNotSuccessfulErrorParameter = 'Failed to archive opportunity \'{0}\'! Error: \'{1}\'';
	static ConfirmPassword = 'Confirm Password';
	static QualificationIsInvalid = 'Qualification is not valid!';
	static MovingTaskParameterToTrashBinWasNotSuccessfulErrorParameter = 'Failed to move form \'{0}\' to trash bin! Error: \'{1}\'';
	static DeletingAttachmentParameterWasNotSuccessfulErrorParameter = 'Failed to remove attachment \'{0}\'! Error: \'{1}\'';
	static ThisWeek = 'This Week';
	static SavingWhistleBlowWasNotSuccessfulConcurrencyError = 'Failed to save whistle blow report, because data in the report has been modified concurrently by another user!';
	static TasksExcelByTaskRows = 'Filtered by Form Rows';
	static AccessRightWrite_RecordDescription_A = '* Can read and edit all records in the unit\n* Can archive and remove records';
	static SavingRiskCategoryParameterWasSuccessful = 'Risk category \'{0}\' saved successfully!';
	static CurrentAndPreviousCalendarMonth = 'Current and Previous Calendar Month';
	static UpdateUserGroupParameterExternalSystemsWasNotSuccessfulErrorParameter = 'Failed to link user group \'{0}\' to external systems! Error: \'{1}\'';
	static InstantMessageChannelParameterNotFound = 'Chat \'{0}\' not found!';
	static ReportIsModifiedAfterItWasPublished = 'Report has been modified after it was published.';
	static PanelSize3 = '1 x 2';
	static Comment = 'Comment';
	static Banner = 'Banner';
	static SharedFiltersAndReports = 'Shared Filters and Reports';
	static RiskAssessmentParameterNotFound = 'Assessment \'{0}\' not found!';
	static InvalidInvitationParameter = 'Invalid invitation \'{0}\'!';
	static ChangedEventUnit = 'Changed incident unit';
	static DeletingCompanyParameterWasSuccessful = 'Company \'{0}\' removed successfully!';
	static FormTextPreWrap = 'Preserve Text Line Breaks';
	static AddEventTypesToEvent = 'Add category 1 by tapping the pen button.';
	static SavingRecordBasicEducationParameterWasNotSuccessfulConcurrencyError = 'Failed to save basic education \'{0}\', because data in the basic education has been modified concurrently by another user!';
	static Created = 'Created By';
	static CanShareContentToCompanies = 'Content Can Be Shared to These Partners';
	static DeletingEventUrgencyClassesParameterWasNotSuccessfulConcurrencyError = 'Failed to remove urgency classes \'{0}\',  because data in urgency classes has been modified concurrently by another user!';
	static DeletingEventTypeParameterWasNotSuccessfulErrorParameter = 'Failed to remove category 1 \'{0}\'! Error: \'{1}\'';
	static PasswordMustContainLowercaseChar = 'Password must contain lowercase alphabet!';
	static DeletingCompanyGroupParameterWasNotSuccessfulErrorParameter = 'Failed to remove company group \'{0}\'! Error: \'{1}\'';
	static RiskOwnerMustBeDefined = 'Owner must be defined!';
	static MessageStartDateMustBeDefined = 'Message visible until date must be defined!';
	static AllDocumentTypes = 'Show all document types';
	static TitleIsAlreadyInUse = 'Title is already in use!';
	static CalendarTaskRepetitionEndDateSuffix = '';
	static SavingRecordFurtherEducationGroupParameterWasNotSuccessfulConcurrencyError = 'Failed to save education group \'{0}\', because data in the education group has been modified concurrently by another user!';
	static DeletingRiskAssesmentParameterWasSuccessful = 'Assessment \'{0}\' removed successfully!';
	static DoYouReallyWantToRemoveFolderParameter = 'Do you really want to remove folder \'{0}\'?';
	static RecurringCalendarTaskCannotHaveMoreThanParameterOccurences = 'Recurring event cannot have more than {0} occurences!';
	static JobTypeEmail = 'Emailing';
	static SelectUserGroup = 'Select User Group';
	static UserCodeUpdateWasNotSuccessfulErrorParameter = 'Failed to update user code! Error: \'{0}\'';
	static ShowDraftVersion = 'Show Draft Contents';
	static TaskMustBeSavedBeforeAttachmentsCanBeAdded = 'Form must be saved before attachments can be added!';
	static DeletingCalendarTaskParameterWasNotSuccessfulErrorParameter = 'Failed to remove event \'{0}\'! Error: \'{1}\'';
	static FormDocumentReferenceWarning = 'Set document reference required data ({0}) in Properties panel!';
	static SavingOpportunityParameterWasSuccessful = 'Opportunity \'{0}\' saved successfully!';
	static SavingOptionParameterWasSuccessful = 'Option \'{0}\' saved successfully!';
	static DeletingPartnersParameterWasNotSuccessfulErrorParameter = 'Failed to remove partners\'{0}\'! Error: \'{1}\'';
	static CompanyCodeMustBeDefined = 'Code of the company must be defined!';
	static UnreadMessagesParameter = 'Unread messages: {0}';
	static TaskDefaultPrioritiesInstruction = 'Form default priorities. Form specific priorities can be defined in form template edit dialog.';
	static SavingTaskTypeParameterWasNotSuccessfulConcurrencyError = 'Failed to save form template \'{0}\', because data in the form template has been modified concurrently by another user!';
	static DeletingFileFilterParameterWasNotSuccessfulErrorParameter = 'Failed to remove file filter \'{0}\'! Error: \'{1}\'';
	static FormulaTrunc = 'Integer part';
	static DoYouReallyWantToRemoveSelectedRiskStakeholders = 'Do you really want to remove selected stakeholders?';
	static Admins = 'Administrators';
	static EditUser = 'Edit User Account';
	static Summary = 'Summary';
	static RiskStandards = 'Standards';
	static SendMessage = 'Send Message';
	static SelectApprovers = 'Select Approvers';
	static RefreshList = 'Refresh List';
	static InstantMessageSettings = 'Instant Message Settings (HoxUp)';
	static DoYouReallyWantToSave = 'Do you want to save?';
	static NoUnusedFormFieldsAvailable = 'No unused fields available!';
	static Locked = 'Locked';
	static AccessRightWrite_UserDescription = 'Can create, edit and delete the user accounts';
	static AddHandlers = 'Add handlers';
	static SendReadReceiptInfo = 'Send read receipt by tapping &#10003; button.';
	static SavingInstantMessageChannelUserWasNotSuccessfulErrorParameter = 'Failed to save participant! Error: \'{0}\'';
	static TaskPriorityCodeMustBeDefined = 'Form priority name must be defined!';
	static SendReadReceipt = 'Send Read Receipt';
	static PermissionToIdentificateEvents = 'Permission to Create and Identify Incidents';
	static DefaultHandlers = 'Default Handlers';
	static RemovingTaskHandlerWasNotSuccessfulErrorParameter = 'Failed to remove persons! Error: \'{0}\'';
	static Unlock = 'Unlock';
	static FormOption = 'Option';
	static UserRecordStatisticsMissingQualifications = 'Missing Qualifications';
	static SelectDocumentInListToSeeThePreview = 'Select document in list to see the preview';
	static BasicEducationsMustBeDefinedBeforeAddingRecordUsers = 'Basic educations must be defined before adding user records!';
	static EmptyRiskTemplate = 'Empty Risk Template';
	static ReportGenerationFailed = 'Failed to create report!';
	static PrintIsEmpty = 'Print is empty!';
	static OpportunityBenefit = 'Benefit';
	static SavingEditableDocumentParameterPublishWasNotSuccessfulErrorParameter = 'Failed to publish document \'{0}\'! Error: \'{1}\'';
	static FileParameterDoesNotContainAnyTaskDataRows = 'File \'{0}\' does not contain any rows!';
	static Valid = 'Valid';
	static UserHasNotLoggedIn = 'User has never logged in to the system.';
	static MyFiltersAndReports = 'User\'s Filters and Reports';
	static UserPasswordMustBeValid = 'Password must be at least 8 characters long and it must contain lowercase letters, capital letters and at least one number or special character.';
	static CurrentAndPreviousCalendarYear = 'Current and Previous Calendar Year';
	static AdditionalFunctions = 'Additional Functions';
	static FormInitializeFromSavedRow = 'Initialize from Saved Row';
	static SaveReportAs = 'Save Report As';
	static SavingEventUrgencyClassParameterWasSuccessful = 'Urgency class \'{0}\' saved successfully!';
	static ArchiveExpiredFamiliarizations = 'Archive Expired Familiarizations';
	static PasteDefaultHandlers = 'Paste Default Handlers';
	static EventModuleInfoDefaultHandlers = 'The default handler(s) of an incident and, if needed, the recipient(s) of the notification are set for each unit individually.';
	static EditEventTypeC = 'Edit Category 3';
	static Font = 'Font';
	static AddEventMessage = 'Add Comment';
	static WhistleBlowDateAndTimeCannotBeInFuture = 'Incident time cannot be in future!';
	static EventTypeC = 'Category 3';
	static UserGroupParameterIsInUseInParameterUsersAndCannotBeDeleted = 'User group \'{0}\' is used in {1} users and cannot be removed!';
	static UserCanBeSelectedAsEventHandler = 'User can be selected as incident handler';
	static EventTypeBParameterIsInUseInParameterEventsAndCannotBeDeleted = 'Category 2 \'{0}\' is used in {1} incidents and cannot be removed!';
	static Custom = 'Custom';
	static TasksExcelByTasks = 'Filtered by Forms';
	static Charts = 'Charts';
	static LockedOpportunityParameterCannotBeRestored = 'Locked opportunity \'{0}\' cannot be restored!';
	static SearchCalendarTasks = 'Search Events';
	static AddCompanyToCompanyGroup = 'Add Company into Company Group';
	static ShowPublishVersion = 'Show publish version';
	static FormProperties = 'Properties';
	static IncludeArchivedFurtherEducations = 'Include archived further educations';
	static WhistleBlowResolutionJunk = 'Junk Mail';
	static RecordUserFamiliarizationApprovalWasNotSuccessfulErrorParameter = 'Failed to approve familiarization! Error: \'{0}\'';
	static AdditionalSettings = 'Additional Settings';
	static WhistleBlowWasNotFoundExplanation = 'Check the whistle blow report password.';
	static TargetDoesNotHaveFoldersWithWritePermissions = 'Target does not have folders with write permissions!';
	static DoYouReallyWantToRemoveRecordUserTransferredPropertyParameter = 'Do you really want to remove transferred property \'{0}\'?';
	static WhistleBlowEventTypeReadDescription = 'Opened for reading';
	static WhistleBlowDateAndTime = 'Incident Time';
	static AuthorizationLevel = 'Authorization Level';
	static OperationNotAllowedForRootFolderParameter = 'Operation is not allowed for root folder \'{0}\'!';
	static PathMustBeDefined = 'Path must be defined!';
	static MovingRiskParameterToTrashBinWasNotSuccessfulConcurrencyError = 'Failed to move risk \'{0}\' to trash bin, because the data has been modified concurrently by another user!';
	static Approver = 'Approver';
	static DoYouReallyWantToRemoveRecordUserEmploymentParameter = 'Do you really want to remove employment \'{0}\'?';
	static RemovingWhistleBlowHandlerWasNotSuccessfulErrorParameter = 'Failed to remove handlers! Error: \'{0}\'';
	static DocumentModuleInfoDocumentTemplates = 'System document templates. The templates are used when creating new documents.';
	static Events = 'Incidents';
	static ChartAtLeastOneValueFieldMustBeDefined = 'At least one chart value field must be defined!';
	static DoYouReallyWantToReplaceDocumentTemplateParameter = 'Do you really want to replace document template \'{0}\'?';
	static SelectOperatorOrFunction = 'Select Operator or Function';
	static LockedReportParameterCannotBeUnpublished = 'Locked report \'{0}\' cannot be unpublished!';
	static WhistleBlowDescriptionEditReason = 'Edit Reason';
	static SelectUser = 'Select User Account';
	static SavingRecordFurtherEducationParameterWasSuccessful = 'Education \'{0}\' saved successfully!';
	static SavingDirectoryItemPermissionsWasNotSuccessfulConcurrencyError = 'Failed to save folder permissions, because folders have been modified concurrently by another user!';
	static MissingPlural = 'Missing';
	static DocumentParameterDownloaded = 'Document has been downloaded.';
	static DeletingAttachmentsParameterWasNotSuccessfulConcurrencyError = 'Failed to remove attachments \'{0}\', because data has been modified concurrently by another user!';
	static ValidityStartDate = 'Validity Start Date';
	static RemoveLogisticVoucherCustomer = 'Remove Customer';
	static RemoveUserGroupExternalSystemsWasSuccessful = 'User group links to external systems removed successfully!';
	static UserAccountConnected = 'User Account Connected';
	static FieldParameterContainsInvalidCodeCharacters = 'Value of the field \'{0}\' contains characters that are illegal in codes ( \, ^, ?, &, <, >, /, +, :) or it ends with illegal characters (.)!';
	static PropertyTransferred = 'Transferred';
	static ExternalSystemCompanyCodeClaimNotFound = 'User claim \'externalSystemCompanyCode\' not found!';
	static ChangeLanguage = 'Change Language';
	static TaskStateParameterNotFound = 'Form state \'{0}\' not found!';
	static DoYouReallyWantToUnpublishAppReportParameter = 'Do you really want to unpublish report \'{0}\'?';
	static SavingTaskPriorityParameterWasNotSuccessfulErrorParameter = 'Failed to save form priority \'{0}\'! Error: \'{1}\'';
	static EmploymentEndDateCannotPrecedeEmploymentStartDate = 'Employment end date cannot precede employment start date!';
	static DoYouReallyWantToUnlockTask = 'Do you really want to unlock form \'{0}\'?';
	static SavingUserParametersWasSuccessful = 'User options saved successfully!';
	static DoYouReallyWantToArchiveAppReportParameter = 'Do you really want to archive report \'{0}\'?';
	static WhistleBlowArchivingTypeChangeStateAndRemoveAllData = 'Change whistle blow report state to \'Archived\' and keep only information that is needed for statistics';
	static RestoringReportParameterFromTrashBinWasNotSuccessfulConcurrencyError = 'Failed to restore report \'{0}\' from trash bin, because data in the report has been modified concurrently by another user!';
	static SavingApplicationPermissionsWasSuccessful = 'System permissions saved successfully!';
	static EditableDocumentUnpublishConfirmation = 'Do you want to remove the published file?';
	static DoYouReallyWantToRemoveUnitParameter = 'Do you really want to remove unit \'{0}\'?';
	static RecordUserExcelUserList = 'Personnel';
	static OtherInformation = 'Other Information';
	static FolderParameterAlreadyExistsInFileSystem = 'Folder \'{0}\' already exists in the filesystem!';
	static Messages = 'Messages';
	static ReadReceiptNotGiven = 'Receipt unsent';
	static UserIsInstantMessageChannelOnlyAdministratorInParameterInstantMessageChannels = 'User is only chat administrator in {0} chats!';
	static AddPartnerParameterWasNotSuccessfulConcurrencyError = 'Failed to add partner \'{0}\', because the data has been modified concurrently by another user!';
	static StudyWeek = 'Study Week';
	static RemoveCalendarTask = 'Remove event';
	static Anonymity = 'Anonymity';
	static DoYouReallyWantToRemoveMessageTypeParameter = 'Do you really want to remove message type \'{0}\'?';
	static DocumentVersionParameterNotFound = 'Document version \'{0}\' not found!';
	static WhistleBlowStateInProgress = 'In Progress';
	static AddCompaniesParameterWasNotSuccessfulConcurrencyError = 'Failed to add companies \'{0}\', because the data has been modified concurrently by another user!';
	static EventTypeCostsReportPieChartIndirectCostsName = 'Pie Chart - Indirect Costs';
	static Yearly = 'Yearly';
	static RecordFamiliarizationCodeIsAlreadyInUse = 'Familiarization name is already in use!';
	static FileFilterCodeMustBeDefined = 'File filter code must be defined!';
	static Units = 'Units';
	static IdentificationDetails = 'Identification Details';
	static EventsFound = 'Incidents Found';
	static CopyDefaultHandlers = 'Copy Default Handlers';
	static SavingRiskSettingWasNotSuccessfulErrorParameter = 'Failed to save risk settings! Error: \'{0}\'';
	static TaskChartShowDataLabels = 'Show Numeric Value in Chart';
	static NewWhistleBlowMustBeSavedBeforeHandlersCanBeAdded = 'New report must be saved before rows can be added!';
	static FormTitlePageLayout1 = 'Default';
	static ModifyExistingDocumentTemplate = 'Modify existing document template';
	static DraftCannotBeApprovedDoYouWantToSaveDraftAnyway = 'Draft cannot be approved! Do you want to save draft anyway (approval will not be saved)?';
	static DeletingOneTimePasswordWasNotSuccessfulConcurrencyError = 'Failed to remove one time password, because data in the one time password has been modified concurrently by another user!';
	static PrintSelectedRows = 'Print Selected Rows';
	static CalendarTaskEndDateMustBeAfterStartDate = 'Event end time must be after start time!';
	static LockedOpportunityParameterCannotBeSaved = 'The opportunity \'{0}\' has been locked to another user and it cannot be saved!';
	static EditCompany = 'Edit Company';
	static ExternalSystemUserCodeClaimNotFound = 'User claim \'externalSystemUserCode\' not found!';
	static DeletingInstantMessageUsersParameterWasNotSuccessfulConcurrencyError = 'Failed to remove participants \'{0}\', because data has been modified concurrently by another user!';
	static SavingUnitPermissionsWasNotSuccessfulConcurrencyError = 'Failed to save unit permissions, because permissions have been modified concurrently by another user!';
	static DefaultRiskStakeholders = 'Default Stakeholders';
	static DeletingCompaniesParameterWasSuccessful = 'Companies \'{0}\' removed successfully!';
	static YouHaveNotSavedChangesDoYouWantToSaveChanges = 'You have not saved changes that you have made. Do you want to save changes?';
	static DeletingCalendarTaskParameterWasSuccessful = 'Event \'{0}\' removed successfully!';
	static All = 'All';
	static DocumentTemplateCodeMustBeDefined = 'Document template code must be defined!';
	static SavingCalendarTaskParameterWasSuccessful = 'Event \'{0}\' saved successfully!';
	static LastWeek = 'Last Week';
	static RecordUserPartnerParameterNotFound = 'Resource partner \'{0}\' not found!';
	static DefaultLanguageHasBeenChanged = 'Language has been changed!';
	static DeletingRecordQualificationParameterWasNotSuccessfulErrorParameter = 'Failed to remove qualification \'{0}\'! Error: \'{1}\'';
	static SavingDefaultHandlersWasNotSuccessfulErrorParameter = 'Failed to save default handlers! Error: \'{0}\'';
	static DoYouReallyWantToCreateRemainderInPast = 'Do you really want to create remainder in the past?';
	static FamiliarizationTime = 'Familiarization Time';
	static AddUserGroupsParameterWasNotSuccessfulErrorParameter = 'Failed to add user groups \'{0}\'! Error: \'{1}\'';
	static RiskProcessParameterHasChildNodesAndCannotBeDeleted = 'My classification \'{0}\' contains subclassifications and cannot be removed!';
	static PasswordChangeRequestHasBeenExpired = 'Password change request \'{0}\' has been expired!';
	static AllUnits = 'All Units';
	static ReportTemplateCodeIsAlreadyInUse = 'Report template name is already in use!';
	static MovingReportParameterToTrashBinWasNotSuccessfulErrorParameter = 'Failed to move report \'{0}\' to trash bin! Error: \'{1}\'';
	static AccessRightWrite_RiskDescription = 'Can create, edit and assess risks and opportunities';
	static PublishDate = 'Publish Date';
	static ReadOnly = 'Read Only';
	static CompanyGroupModuleProperties = 'Company Groups Properties';
	static Other = 'Other';
	static AccessRightWrite_DocumentDescription = '* Can create, edit and publish eSalkku documents\n* Can add and manage attachments in the folder\n* Can edit folder access rights';
	static AdditionalIdentifier = 'Additional Identifier';
	static DoYouReallyWantToUnlockCalendarTask = 'Do you really want to unlock event \'{0}\'?';
	static TiedostoturvaUseType = 'Tiedostoturva';
	static MessageEndDate = 'Visible Until';
	static DoYouReallyWantToRemoveEventTypeParameter = 'Do you really want to remove category 1 \'{0}\'?';
	static DraftCannotBeApproved = 'Draft cannot be approved!';
	static RememberMe = 'Remember me';
	static FormExpressionFormat = 'Expression Result Formatting';
	static DefaultFamiliarizations = 'Default Familiarizations';
	static DoYouReallyWantToRemoveSelectedCalendarTaskHandlers = 'Do you really want to remove selected attendees?';
	static FormReportReferenceIsIsInvalid = 'Resource reference is invalid!';
	static SavingRecordUserSettingsWasNotSuccessfulErrorParameter = 'Failed to save resource settings! Error: \'{0}\'';
	static UserRecordStatisticsSavedCards = 'Saved Cards';
	static AdminMustBeDefined = 'Administrator must be defined!';
	static Validity = 'Validity';
	static ReadReceiptRequired = 'Read Receipt Required';
	static TaskChartGroupingFieldGroupingTypeHalfYear = 'Half Year';
	static AccessRightWrite_AppReportDescription = '* Can create, edit and publish reports\n* Can add eSalkku data to reports if the user has access to that data';
	static SomeEventHandlersHaveReadMessage = 'Some incident handlers have read your comment';
	static AddUsersParameterWasNotSuccessfulErrorParameter = 'Failed to add user accounts \'{0}\'! Error: \'{1}\'';
	static NewCompanyMustBeSavedBeforeCompanyGroupsCanBeAdded = 'New company must be saved before company groups can be added!';
	static DeletingTaskPrioritiesParameterWasNotSuccessfulErrorParameter = 'Failed to remove form priorities \'{0}\'! Error: \'{1}\'';
	static EventReport = 'Incident Report';
	static RecordUserModuleInfoBasicEducations = 'Set the basic educations to be used in user records.';
	static ExternalIntraSystems = 'External eSalkku Systems';
	static SavingEventTypeCsWasSuccessful = 'Category 3 saved successfully!';
	static ExternalIntraSystemUserTokenMustBeDefined = 'User token in external eSalkku system must be defined!';
	static FolderNameIsTooLong = 'Folder name \'{0}\' is too long!';
	static RiskStakeholderParameterHasChildNodesAndCannotBeDeleted = 'Stakeholder \'{0}\' contains substakeholders and cannot be removed!';
	static TaskModuleInfoPermissions = 'Visibility and access rights for forms.';
	static CopyingFilesAndDocumentsToFolderParameterWasNotSuccessfulConcurrencyError = 'Failed to copy files/documents into folder \'{0}\', because data in the folder has been modified concurrently by another user!';
	static PreviousCalendarMonth = 'Previous Calendar Month';
	static MinimumPasswordLengthMustBeAtLeastParameterCharacters = 'Minimum password length must be at least {0} characters!';
	static RemoveBasicEducation = 'Remove Basic Education';
	static DeletingTaskDataRowWasSuccessful = 'The form row removed successfully!';
	static ArchiveExpiredFurtherEducations = 'Archive Expired Educations';
	static RequestPasswordChangeTitle = 'Forgot password?';
	static ArchivingOpportunityParameterWasSuccessful = 'Opportunity\'{0}\' archived successfully!';
	static RestoringTaskParameterFromArchiveWasNotSuccessfulErrorParameter = 'Failed to restore form \'{0}\' from archive! Error: \'{1}\'';
	static UserRecordCards = 'User Records';
	static LockingTaskDataRowWasNotSuccessful = 'Failed to lock the form row!';
	static AccessRightNone_InstantMessageDescription = 'No HoxUp access';
	static EventModuleInfoEventTypes = 'Categories are used for filtering and reporting incidents. If needed, a category can be made selectable by the person reporting the incident.';
	static LoginAddress = 'Log In Address';
	static EventTypeB = 'Category 2';
	static SharePanelParametrToUserGroups = 'Share Panel \'{0}\' to User Groups';
	static SavingEventTypeBsWasSuccessful = 'Category 2 saved successfully!';
	static SavingReportTemplateParameterWasNotSuccessfulErrorParameter = 'Failed to save report template \'{0}\'! Error: \'{1}\'';
	static SavingRiskTemplateParameterWasNotSuccessfulConcurrencyError = 'Failed to save risk template \'{0}\', because the data has been modified concurrently by another user!';
	static LockedRiskParameterCannotBeSaved = 'The risk \'{0}\' has been locked to another user and it cannot be saved!';
	static PrivacyPolicyUrl = 'Privacy Policy Web Address';
	static MonthAbbr = 'mo';
	static SavingRiskStakeholderParameterWasNotSuccessfulConcurrencyError = 'Failed to save stakeholder \'{0}\', because the data has been modified concurrently by another user!';
	static TasksInUse = 'Forms in use';
	static AccessRightRead_TaskDescription_BC = '* Can fill in forms\n* Can read and edit form rows';
	static NewUserGroupMustBeSavedBeforeUsersCanBeAdded = 'New user group must be saved before users can be added!';
	static FormWidthPrint = 'Width in Print';
	static SavingRecordFurtherEducationGroupParameterWasSuccessful = 'Education group \'{0}\' saved successfully!';
	static UpdateCompanyExternalSystemsWasNotSuccessfulErrorParameter = 'Failed to link company to external systems! Error: \'{0}\'';
	static ChangeCompany = 'Change Company';
	static AddFurtherEducationGroup = 'Add Education Group';
	static WhistleBlowInformantInstuctions = 'Informant Instuctions';
	static UnpublishingReportParameterWasNotSuccessfulConcurrencyError = 'Failed to unpublish report \'{0}\', because data in the report has been modified concurrently by another user!';
	static RemovePicture = 'Remove Picture';
	static AddCompanyGroupParameterWasNotSuccessfulConcurrencyError = 'Failed to company group \'{0}\', because the data has been modified concurrently by another user!';
	static Calendar = 'Calendar';
	static MessageTypes = 'Message Types';
	static LockedRiskParameterCannotBeUnpublished = 'Locked risk \'{0}\' cannot be unpublished!';
	static FirstNameMustBeDefined = 'First name must be defined!';
	static PanelName = 'Panel Name';
	static RiskApprovalConditional = 'Conditionally Approved';
	static WhistleBlowReport = 'Whistle Blow Report';
	static InstantMessageChannelUserParameterNotFound = 'Chat party \'{0}\' not found!';
	static Update = 'Update';
	static DoYouReallyWantToRemovePrintParameter = 'Do you really want to remove print \'{0}\'?';
	static DoYouReallyWantToRemoveWhistleBlowParameter = 'Do you really want to remove whistle blow report \'{0}\'?';
	static Groups = 'Groups';
	static DeletingRecordFurtherEducationsParameterWasNotSuccessfulConcurrencyError = 'Failed to remove educations \'{0}\',  because data in educations has been modified concurrently by another user!';
	static DeletingEventParameterWasSuccessful = 'Incident \'{0}\' removed successfully!';
	static FormulaCos = 'Cosine';
	static AddTaskPriority = 'Add Form Priority';
	static DefaultEventUrgencyClassParameterCannotBeDeleted = 'Default urgency class cannot be removed!';
	static RecordBasicEducationCodeMustBeDefined = 'Basic education name must be defined!';
	static ImmediateAction = 'Remedial Action';
	static SavingUnitPermissionsWasNotSuccessfulErrorParameter = 'Failed to save unit permissions! Error: \'{0}\'';
	static FormCodeIsAlreadyInUse = 'Form name is already in use!';
	static UpdateUserParameterExternalSystemsWasNotSuccessfulErrorParameter = 'Failed to link user \'{0}\' to external systems! Error: \'{1}\'';
	static DocumentRootPathMustBeDefined = 'Document root path must be defined!';
	static EmptyingTaskTrashBinWasSuccessful = 'Form trash bin is now empty!';
	static SelectRiskType = 'Select Risk Type';
	static AddPhotosAndAttachmentsMobile = 'Add photo or attachment by tapping camera or plus buttons.';
	static RiskStakeholderParameterIsInUse = 'Stakeholder \'{0}\' is used in {1} risks and cannot be removed!';
	static CompanyIdClaimNotFound = 'User claim \'company id\' not found!';
	static AccessRightWriteInstantMessages = 'Company Internal and Intercompany Chat';
	static PreviewPrint = 'Preview (Print)';
	static OtherForms = 'Other Forms';
	static UserProfile = 'User Account';
	static AccessRightRead_EventDescription_A = '* Can create incidents\n* Can view self-created incidents and incidents where acts as handler\n* Can be selected as incident handler\n* Can be selected as default handler and person to be notified';
	static DeletingUserParameterWasNotSuccessfulConcurrencyError = 'Failed to remove user account \'{0}\', because the data has been modified concurrently by another user!';
	static TrendingDown = 'Trending Down';
	static ReadImp = 'Read';
	static TaskTypeNameMustBeDefined = 'Form template name must be defined!';
	static PublishingRiskParameterWasNotSuccessfulErrorParameter = 'Failed to publish risk \'{0}\'! Error: \'{1}\'';
	static RemoveDefaultTaskState = 'Remove Default Form State';
	static FileRemovalWasSuccessful = 'File removed successfully!';
	static AssessmentTreatmentsMustBeDefined = 'Treatments must be defined!';
	static ValidityEndDateEnd = 'Validity End Date - End';
	static RestoringReportParameterFromTrashBinWasSuccessful = 'Report \'{0}\' has been restored from trash bin!';
	static PersonsRemoveConfirmation = 'Do you really want to remove selected persons?';
	static RemovingTaskHandlersWasSuccessful = 'Persons removed successfully!';
	static DeletingWhistleBlowChannelAdminParameterWasSuccessful = 'Administrator \'{0}\' removed successfully!';
	static EmailMessage = 'Send Message by Email';
	static FolderParameterAlreadyExists = 'Folder \'{0}\' already exists!';
	static RecordUserFurtherEducationParameterNotFound = 'Education \'{0}\' not found!';
	static ValidityEndDateStart = 'Validity End Date - Start';
	static DeletingRecordFamiliarizationParameterWasNotSuccessfulConcurrencyError = 'Failed to remove familiarization \'{0}\',  because data in the familiarization has been modified concurrently by another user!';
	static SelectState = 'Select State';
	static SearchEvents = 'Search Incidents';
	static TaskStateCodeMustBeDefined = 'Form state name must be defined!';
	static AddChildRiskProcess = 'Add My Subclassification';
	static DoYouReallyWantToRemoveRecordUserParameter = 'Do you really want to remove user record \'{0}\'?';
	static RecordParameterLockingFailed = 'Failed to lock record \'{0}\'!';
	static InvitationParameterNotFound = 'Invitation \'{0}\' not found!';
	static AuthorizationLevelQrCodeUser = 'QR Code User';
	static NoLocking = 'No Locking';
	static AccessRightWrite_Event_B = 'Create, handle all, view all and remove';
	static LogDocumentPreview = 'Log Document Preview';
	static SavingInstantMessageWasSuccessful = 'Instant message saved successfully!';
	static RemovingReportTemplateUnitsWasSuccessful = 'Units removed successfully!';
	static ObserverAction = 'Observer Action';
	static NoFilters = ' No Filters!';
	static FormHeight = 'Height';
	static SavingKeywordParameterWasNotSuccessfulConcurrencyError = 'Failed to save keyword \'{0}\', because data in the keyword has been modified concurrently by another user!';
	static WhistleBlowUrlInfo = 'Only system administrator can change the address';
	static SavingWhistleBlowMessageWasSuccessful = 'Message saved successfully!';
	static TaskState = 'Form State';
	static EditCalendarTask = 'Edit Event';
	static LoginAllowMicrosoft = 'Allow Log In with Microsoft Account';
	static SavingPrintWasSuccessful = 'Print saved successfully!';
	static ModifyDateEndDate = 'Last Modified Until';
	static DoYouReallyWantToUnlockOpportunity = 'Do you really want to unlock opportunity \'{0}\'?';
	static UserToken = 'User Token';
	static RiskTemplateParameterNotFound = 'Risk template \'{0}\' not found!';
	static RemoveEvent = 'Remove Incident';
	static DeletingRecordUserEmploymentsParameterWasNotSuccessfulErrorParameter = 'Failed to remove employments \'{0}\'! Error: \'{1}\'';
	static CurrentTopicsAbbr = 'Topics';
	static RemoveCompanyFromCompanyGroup = 'Remove Company from Company Group';
	static SavingRiskParameterWasSuccessful = 'Risk \'{0}\' saved successfully!';
	static EditTransferredProperty = 'Edit Transferred Property';
	static EventsExcel = 'Incidents - Excel';
	static RemoveComment = 'Remove Comment';
	static WhistleBlowInformantDescription = 'Please describe what is happened';
	static DeletingRecordFurtherEducationGroupParameterWasNotSuccessfulConcurrencyError = 'Failed to remove education group \'{0}\',  because data in the education group has been modified concurrently by another user!';
	static SavingEventSettingsWasNotSuccessfulConcurrencyError = 'Failed to save incident settings, because  incident settings have been modified concurrently by another user!';
	static Report = 'Report';
	static ImportUsers = 'Import User Accounts';
	static TaskPriorityParameterIsInUseInParameterTasksAndCannotBeDeleted = 'Form priority \'{0}\' is used in {1} forms and cannot be removed!';
	static DeletingEventTypeParameterWasNotSuccessfulConcurrencyError = 'Failed to remove category 1 \'{0}\', because data in the category 1 has been modified concurrently by another user!';
	static NextAssessmentDateMustBeDefined = 'Next assessment date must be defined!';
	static TogglePreviewPanel = 'Show/Hide Preview';
	static RemoveFile = 'Remove File';
	static ShowUserGroups = 'Show User Groups';
	static EventType = 'Category 1';
	static EditRow = 'Edit Row';
	static MessageDateMustBeDefined = 'Message date must be defined!';
	static EmptyingRiskManagementTrashBinWasNotSuccessfulErrorParameter = 'Failed to empty risk management trash bin! Error: \'{0}\'';
	static OperationAborted = 'Operation aborted!';
	static TaskTypeUnits = 'Form Template Visibility';
	static PasswordChangeRequestParameterNotFound = 'Password change request \'{0}\' not found!';
	static NoPermission = 'No Permissions';
	static FormTitle2 = 'Title 2';
	static RiskProcessesInUse = 'My classifications are in use';
	static SearchRisks = 'Search Risks';
	static AccessRightWrite_MessageDescription = 'Can create, edit and publish messages in the unit’s Current topics';
	static UserIsCompanyAdminClaimNotFound = 'User claim \'userIsCompanyAdmin\' not found!';
	static Errors = 'Errors';
	static SavingRecordFamiliarizationParameterWasNotSuccessfulConcurrencyError = 'Failed to save familiarization \'{0}\', because data in the familiarization has been modified concurrently by another user!';
	static AssessmentCommentPlaceholder = 'Describe the current status of the assessment here. How the management actions described in the basic information are working, what has changed and why the assessment has been given.';
	static FormulaMultiplication = 'Multiplication';
	static FormTaskTypeIsNotSelected = 'Form has not been selected!';
	static SaveMessage = 'Save Message';
	static DoYouReallyWantToRemoveSelectedRiskAssessments = 'Do you really want to remove selected assessments?';
	static TaskPriority = 'Priority';
	static MoneyOut = 'Money Out';
	static ImpactMustBeDefined = 'Impact must be defined!';
	static SelectFurtherEducation = 'Select Education';
	static DeletingEventUrgencyClassParameterWasNotSuccessfulConcurrencyError = 'Failed to remove urgency class \'{0}\',  because data in the urgency class has been modified concurrently by another user!';
	static CompanyTaskTypeSettings = 'Form Template Settings';
	static SavingUserParameterWasNotSuccessfulErrorParameter = 'Failed to save user \'{0}\'! Error: \'{1}\'';
	static RemoveRemainder = 'Remove Remainder';
	static CopyContentToDocumentContent = 'Copy Content to Document Content';
	static Cancel = 'Cancel';
	static TrainingEndDate = 'End Date';
	static FormSignature = 'Signature';
	static AddUserGroupParameterWasNotSuccessfulConcurrencyError = 'Failed to add user group \'{0}\', because the data has been modified concurrently by another user!';
	static DocumentModuleInfoKeywords = 'Keywords can used in documents. The keywords are used for filtering documents.';
	static ClickToCancelAutomaticLogout = 'User session is about to expire, please click this dialog to prevent automatic logout.';
	static SharedFilters = 'Shared Filters';
	static EventTypeCostsReportBarChartDirectCostsByTimeName = 'Bar Chart - Direct Costs';
	static DoYouReallyWantToRemovePartnerParameter = 'Do you really want to remove partner \'{0}\'?';
	static AccessRightRead_RecordDescription = 'Can read and edit own record';
	static WhistleBlowReportHasBeenSavedTopText = 'Store below password in secure storage. The passwords gives you access to you report. Do not share password with anyone!';
	static Maximum = 'Maximum';
	static DeletingCompanyGroupParameterWasNotSuccessfulConcurrencyError = 'Failed to remove company group \'{0}\', because the data has been modified concurrently by another user!';
	static WhistleBlowEventTypeAttachmentsRemoved = 'Attachments removed';
	static DoYouReallyWantToUnlockTaskDataRow = 'Do you really want to unlock form row?';
	static AllCompanies = 'All Companies';
	static SavingUserParameterParameterWasNotSuccessfulConcurrencyError = 'Failed to save user option \'{0}\', because data in the user option has been modified concurrently by another user!';
	static Unpublish = 'Unpublish';
	static TrainingStartDate = 'Start Date';
	static FolderNameConstainsIllegalCharacters = 'Folder name contains illegal characters (<, >, :, ", /, \, |, ? tai *) or it ends with illegal characters (., \' \')!';
	static EventTypeBCodeMustBeDefined = 'Category 2 name must be defined!';
	static RemoveInvalidDefaultEventHandlersConfirmation = 'Some default incident handlers or notified persons do not have permissions to handle incidents of units. Do you want to automatically remove these incidents handlers or notified persons before saving new settings?';
	static SendinEmailNotificationsWasNotSuccessfulErrorParameter = 'Failed to send notifications to by email! Error: \'{0}\'';
	static PrintEvent = 'Print Incident';
	static TaskCalendarTasksInfo = 'Event email notifications will be sent only for persons in charge.';
	static NoFamiliarizationsToShow = 'No familiarizations to show!';
	static RemoveRiskAssessment = 'Remove Assessment';
	static AddDefaultEventType = 'Add Default Category 1';
	static RecordEmailNotificationShowExpired = 'Include Expired Educations';
	static Year = 'Year';
	static Row = 'row';
	static ExternalSystemCompanyTokenParameterIsAlreadyInUse = 'Company token \'{0}\' is already in use!';
	static RiskReportExtensive = 'Extensive Risk Report';
	static CopyUnitDefaultHandlersAndNotifiedPersonsToAllSameLevelUnits = 'Copy Default Handlers and Notified Persons to All Same Level Units';
	static Expand = 'Expand';
	static TaskTypeUsedInAllUnits = 'Form template is usable in all units';
	static WhistleBlowEditDescription = 'Edit Report';
	static CompetencyGroup = 'Competency Group';
	static SourceFolderAndTargetFolderAreSame = 'Source folder and destination folder are equal!';
	static Removed = 'Removed';
	static DeletingCalendarTaskCategoryParameterWasSuccessful = 'Category \'{0}\' removed successfully!';
	static AddingRecordUserFamiliarizationsWasSuccessful = 'Familiarizations added successfully!';
	static EditInstantMessageChannel = 'Edit Chat';
	static DoYouReallyWantToRemoveEditableDocumentParameter = 'Do you really want to remove document \'{0}\'? All files that are related to the document will be removed.';
	static FormMinimumValue = 'Minimum Value';
	static RemoveEmployment = 'Remove Employment';
	static OtherCompanies = 'Other Companies';
	static UserGroup = 'User Group';
	static AccessRightWrite_RiskDescription_A = '* Can create, edit and assess risks and opportunities\n* Can manage risk management settings (categories, standards, stakeholders and custom classifications)';
	static WhistleBlowDashboard = 'Whistleblower Dashboard';
	static FailureAudit = 'FailureAudit';
	static NewMessage = 'New Message';
	static DeletingTaskDataRowWasNotSuccessfulErrorParameter = 'Failed to remove the form row! Error: \'{0}\'';
	static DeletingRiskAssesmentsParameterWasSuccessful = 'Assessments \'{0}\' removed successfully!';
	static CalendarTaskRepetitionRepeatIntervalYearlySuffix = 'year(s) on';
	static AccessRightWrite_Record_A = 'All unit\'s user records, archival and removal';
	static TaskChartValueFieldCalculationTypeCount = 'Count';
	static MessageMustBeDefined = 'Message contents must be defined!';
	static CalendarTaskEditOccurrence = 'Edit Occurrence';
	static ChartGroupingField = 'Chart Grouping Field';
	static ReadReceiptGivenPlur = 'Read Receipt Sent';
	static ExternalSystemDatabaseInterfaceError = 'External eSalkku system database interface error!';
	static CompanyWithSysAdminAuthorizationLevelNotFound = 'Company that is related to \'System administrator\' user group was not found!';
	static MarkMessageAsRead = 'Mark message as read';
	static DeletingRiskStandardParameterWasSuccessful = 'Standard \'{0}\' removed successfully!';
	static ProcessingTime = 'Processing Time';
	static DeletingEventUrgencyClassesParameterWasSuccessful = 'Urgency classes \'{0}\' removed successfully!';
	static DocumentNameParameterIsIllegal = 'Document name \'{0}\' is not allowed (reserved name)!';
	static TaskChartGroupingFieldGroupingTypeQuartal = 'Quartal';
	static RemoveRiskTemplate = 'Remove Risk Template';
	static SavingInstantMessageChannelParameterWasNotSuccessfulErrorParameter = 'Failed to save chat \'{0}\'! Error: \'{1}\'';
	static InternalMessages = 'Internal Messages';
	static FormExpression = 'Expression';
	static EmployeeTypeIsNotSupported = 'Employee type \'{0}\' is not supported!';
	static RiskTemplateUnits = 'Risk Template Visibility';
	static ShowOnlyUnitsThatAreInUse = 'Show Only Units That Are in Use';
	static EventTypeParameterNotFound = 'Category 1 \'{0}\' not found!';
	static DeletingRecordQualificationsParameterWasNotSuccessfulConcurrencyError = 'Failed to remove qualifications \'{0}\',  because data in qualifications has been modified concurrently by another user!';
	static FolderPath = 'Folder Path';
	static ImportTaskDataRowsDialogInstruction = 'Upload excel file to import rows or download excel template where you can fill form row information. Notice that excel file may contain more fields than what are shown in row list and it does not contain fields that user cannot input.';
	static SharedDocumentTemplates = 'Shared Document Templates';
	static NoDataToShow = 'No data to show!';
	static AddPartnerParameterWasSuccessful = 'Partner \'{0}\' added successfully!';
	static EditAll = 'Edit All';
	static BrowserInfo = 'Browser';
	static PersonsInChargeMustBeDefined = 'Persons in charge must be defined!';
	static DeletingOptionParameterWasNotSuccessfulErrorParameter = 'Failed to remove option \'{0}\'! Error: \'{1}\'';
	static Last180Days = 'Last 180 Days';
	static AddApprovers = 'Add Approvers';
	static ExpiringIn120Days = 'Include educations expiring in 120 days';
	static SavingDefaultHandlersWasSuccessful = 'Default handlers saved successfully!';
	static AddInstantMessageUsersParameterWasNotSuccessfulErrorParameter = 'Failed to add participants \'{0}\'! Error: \'{1}\'';
	static RecentlyUpdated = 'Recently updated';
	static MaxSearchResultCount = 'Max Search Result Count';
	static IgnoreFilePatterns = 'Ignore Files Pattern';
	static EditEventType = 'Edit Category 1';
	static SaveInstantMessageChannel = 'Save Chat';
	static FormLineBreak = 'Line Break';
	static CalendarTaskStateNotStarted = 'Not started';
	static RecordUserModuleProperties = 'User Records Properties';
	static SearchFurtherEducations = 'Search Educations';
	static MessageUnit = 'Publisher Unit';
	static SaveFilter = 'Save Filter';
	static MessageModuleInfoUnits = 'The unit is a channel where Current Topics messages are published.';
	static DeletingRecordFamiliarizationParameterWasSuccessful = 'Familiarization \'{0}\' removed successfully!';
	static ShortName = 'Short Name';
	static RemovingEventHandlerWasNotSuccessfulErrorParameter = 'Failed to remove handlers! Error: \'{0}\'';
	static MoveTaskToTrashBin = 'Move Form toTrash Bin';
	static DoYouReallyWantToRemoveSelectedHandlers = 'Do you really want to remove selected handlers?';
	static SavingEventSettingsWasSuccessful = 'Incident settings saved successfully!';
	static ManageSharedPanels = 'Manage Shared Panels';
	static CalendarTaskModuleInfoCategories = 'Categories can be assigned to calendar entries to classify them. These categories are used for filtering the entries.';
	static FormWidth = 'Width';
	static LockedTaskParameterCannotBeDeleted = 'Locked form \'{0}\' cannot be removed!';
	static InvitationParameterHasBeenExpired = 'Invitation \'{0}\' has been expired!';
	static WhistleBlowInformantTitle = 'What is your concern?';
	static WhistleBlowResolutionResolved = 'Resolved';
	static FieldsToBePrinted = 'Fields to Be Printed';
	static UpdatingApplication = 'Updating application...';
	static FurtherEducationCompetencyMustBeSelected = 'Education / competency must be selected!';
	static ReminderNone = 'No remainder';
	static CopyGroupPermissions = 'Copy Group Permissions to Memory';
	static DescriptionMustBeDefined = 'Description must be defined!';
	static SavingTaskParameterWasSuccessful = 'Form \'{0}\' saved successfully!';
	static ShowInheritedPermissions = 'Show Inherited Permissions';
	static SavingRecordUserParameterWasNotSuccessfulErrorParameter = 'Failed to save user record \'{0}\'! Error: \'{1}\'';
	static DeletingRiskProcessesParameterWasNotSuccessfulErrorParameter = 'Failed to remove my classifications \'{0}\'! Error: \'{1}\'';
	static RiskAssessmentApprovalWasNotSuccessfulErrorParameter = 'Failed to approve assessment \'{0}\'! Error: \'{1}\'';
	static RemoveRiskStandard = 'Remove Standard';
	static Event = 'Incident';
	static InParameterYears = 'In {0} Years';
	static GetPhoto = 'Get Photo';
	static AdditionalInformation = 'Additional Information';
	static ApplicationTempPathIsNotSpecified = 'Application temp-folder is not specified!';
	static EducationsAndCompetencies = 'Educations and Competencies';
	static Version = 'Version';
	static DoYouReallyWantToRemoveSelectedDocumentTemplates = 'Do you really want to remove selected document templates?';
	static GetMore = 'Show More';
	static InstantMessageChannel = 'Chat';
	static FormTitle1 = 'Title 1';
	static FormCompactStyle = 'Compact';
	static ReportTemplateRemoveConfirmation = 'Do you really want to remove report template \'{0}\'?';
	static Import = 'Import';
	static SelectEventReceiver = 'Select Incident Receiver';
	static UserEndDate = 'Validity Expires';
	static Company = 'Company';
	static InstantMessageChannelGroupExternal = 'Group (intercompany)';
	static DoYouReallyWantToRemoveRiskStandardParameter = 'Do you really want to remove standard \'{0}\'?';
	static DeletingEventTypeCParameterWasSuccessful = 'Category 3 \'{0}\' removed successfully!';
	static UnpublishingOpportunityParameterWasSuccessful = 'Opportunity \'{0}\' unpublished successfully!';
	static IHaveForgotMyPassword = 'I have forgot my password';
	static FormCreateUser = 'Create User';
	static LockedCalendarTaskParameterCannotBeDeleted = 'Locked event \'{0}\' cannot be removed!';
	static FormShowModifyDate = 'Show Modify Date';
	static AccessRightWrite_CompanyGroupDescription = 'Can create, edit and delete the company groups';
	static VersionHistory = 'Version History';
	static ExitInstantMessageChannel = 'Exit Chat';
	static Reminder = 'Reminder';
	static AddingEventHandlerWasNotSuccessfulErrorParameter = 'Failed to add handlers! Error: \'{0}\'';
	static SavingInstantMessageWasNotSuccessfulErrorParameter = 'Failed to save instant message! Error: \'{0}\'';
	static AddEventHandlersToEvent = 'Add handler by tapping the plus button.';
	static RemoveUnit = 'Remove Unit';
	static EditEmployment = 'Edit Employment';
	static WhistleBlowEventTypeMessageAdded = 'Message added';
	static FormDocumentReferenceDocumentNotFound = 'Published document that is refered by document reference not found!';
	static RiskTreatmentStateInProgress = 'In Progress';
	static ActiveUserTasks = 'Active user created forms';
	static ReadReceiptGiven = 'Receipt sent';
	static SavingEditableDocumentParameterWasNotSuccessfulConcurrencyError = 'Failed to save document \'{0}\', because data in the document has been modified concurrently by another user!';
	static DeletingAttachmentParameterWasSuccessful = 'Attachment \'{0}\' removed successfully!';
	static InvalidValueInArgumentParameter = 'Invalid value in argument \'{0}\'!';
	static PaymentTermInDays = 'Payment Term in Days';
	static SavingRecordFurtherEducationParameterWasNotSuccessfulConcurrencyError = 'Failed to save education \'{0}\', because data in the education has been modified concurrently by another user!';
	static DetectingLocation = 'Detecting location...';
	static DeletingDocumentTemplateParameterWasSuccessful = 'Document template \'{0}\' removed successfully!';
	static DeletingDirectoryItemFolderParameterWasNotSuccessfulConcurrencyError = 'Failed to remove folder \'{0}\', because data in the folder has been modified concurrently by another user!';
	static FormRecordReference = 'Resources';
	static RiskModuleInfoRiskProcesses = 'Enable this if you want to classify risks and opportunities according to your organisation’s own needs, for example by process or legislation.';
	static TransportCompany = 'Transport Company';
	static MovingFolderParameterWasNotSuccessfulErrorParameter = 'Failed to move folder \'{0}\' into folder \'{1}\' in filesystem! Error: \'{2}\'';
	static FormRowSettings = 'Row Settings';
	static Rejected = 'Rejected';
	static CalendarTaskRepetitionRepeatIntervalMonthSuffix = 'of month';
	static DoYouReallyWantToRemoveDocumentTemplateParameter = 'Do you really want to remove document template \'{0}\'?';
	static EditRisk = 'Edit Risk';
	static DeletingTaskPrioritiesParameterWasSuccessful = 'Form priorities \'{0}\' removed successfully!';
	static ExpiringIn180Days = 'Include educations expiring in 180 days';
	static AddTaskTypeFromTemplate = 'Add Form Template from Template';
	static ShowExpired = 'Show Expired';
	static AddingRecordUserFamiliarizationHandlersWasSuccessful = 'Approvers added successfully!';
	static AmountOfComments = 'Amount of Comments';
	static Tasks = 'Forms';
	static RiskTreatmentIsLate = 'Treatment is late!';
	static RemoveUserAndKeepRecordUser = 'Remove User Account and Keep User Record';
	static RestoringReportParameterFromTrashBinWasNotSuccessfulErrorParameter = 'Failed to restore report \'{0}\' from trash bin! Error: \'{1}\'';
	static ExpiredFurtherEducations = 'Expired Educations';
	static DoYouReallyWantToRemoveSelectedCalendarTaskCategories = 'Do you really want to remove selected categories?';
	static Returned = 'Returned';
	static AddFileFilter = 'Add File Filter';
	static ModifyDateStartDate = 'Last Modified From';
	static RemoveLogisticVoucherPaymentSetting = 'Remove Payment Setting';
	static EventIsApprovedByUser = 'User has approved the incident';
	static DoYouReallyWantToRemoveEventTypeBParameter = 'Do you really want to remove category 2 \'{0}\'?';
	static DependencyResolvingFailedForInterfaceParameter = 'Implementation was not found for interface \'{0}\'!';
	static UsersOfThisCompany = 'Users of My Company';
	static EventUrgencyClassParameterIsInUseInParameterEventsAndCannotBeDeleted = 'Urgency class \'{0}\' is used in {1} incidents and cannot be removed!';
	static UnpublishingEditableDocumentParameterWasSuccessful = 'Document \'{0}\' unpublished successfully!';
	static RiskStandard = 'Standard';
	static CreatingFolderParameterWasNotSuccessfulErrorParameter = 'Failed to create folder \'{0}\' in filesystem! Error: \'{1}\'';
	static UserParameterPermissionDeniedForUnitParameter = 'User \'{0}\' does not have required permissions for unit \'{1}\'!';
	static UnlockingEditableDocumentParameterWasNotSuccessful = 'Failed to unlock document \'{0}\'!';
	static MovingOpportunityParameterToTrashBinWasSuccessful = 'Opportunity \'{0}\' has been moved to trash bin!';
	static WhistleBlowChannelWasNotFound = 'Whistle blow channel not found!';
	static SavingDocumentTemplateParameterWasSuccessful = 'Document template \'{0}\' saved successfully!';
	static EditUnit = 'Edit Unit';
	static SavingEventTypesWasSuccessful = 'Category 1 saved successfully!';
	static TrendingUp = 'Trending Up';
	static RecordUserFurtherEducationsTableByEducationName = 'Table - Educations - By Name';
	static KeywordCodeMustBeDefined = 'Keyword code must be defined!';
	static JobTypeEventNotification = 'Incident Notification';
	static WhistleBlowReceiver = 'Receiver';
	static InvalidReCAPTCHA = 'Human verification failed! Are you a robot?';
	static DefaultBasicEducations = 'Default Basic Educations';
	static SavingReadReceiptWasSuccessful = 'Read receipt saved successfully!';
	static SavingOpportunityParameterWasNotSuccessfulConcurrencyError = 'Failed to save opportunity \'{0}\', because the data has been modified concurrently by another user!';
	static RestoreRiskOrOpportunityFromTrashBin = 'Restore Risk or Opportunity from Trash Bin';
	static SavingTaskTypeParameterWasNotSuccessfulErrorParameter = 'Failed to save form template \'{0}\'! Error: \'{1}\'';
	static DoYouReallyWantToArchiveTaskParameter = 'Do you really want to archive form \'{0}\'?';
	static PanelIsSharedWithoutUserGroups = 'Panel us shared, but user groups are not defined!';
	static Observer = 'Observer';
	static ArchivingRecordUserFamiliarizationsWasNotSuccessfulErrorParameter = 'Failed to archive further familiarizations! Error: \'{0}\'';
	static Default = 'Default';
	static NormalSize = 'Normal Size';
	static DeletingRecordFamiliarizationsParameterWasSuccessful = 'Familiarizations \'{0}\' removed successfully!';
	static FormCoverPage = 'Cover Page';
	static CopyPermissionToAllSameLevelUnits = 'Copy Permission to All Same Level Units';
	static AddingRiskTemplateUnitsWasNotSuccessfulErrorParameter = 'Failed to add units! Error: \'{0}\'';
	static CompanyGroupCodeIsAlreadyInUse = 'Code of the company group is already in use!';
	static TaskStatesMustBeDefinedBeforeAddingTasks = 'Form states must be defined before adding forms!';
	static View = 'View';
	static SaveAndSend = 'Save and Send';
	static EditableDocumentVersionMustBeDefined = 'Document version number must be defined!';
	static TaskDataRowTotalTypeExpression = 'Calculation';
	static FullNameClaimNotFound = 'User claim \'name\' not found!';
	static AddingRiskAssessmentHandlersWasNotSuccessfulErrorParameter = 'Failed to add persons! Error: \'{0}\'';
	static RemoveImage = 'Remove Image';
	static SavingImagesNotSuccessfulErrorParameter = 'Failed to save images! Error: \'{0}\'';
	static TaskTypeNotAnyAllowedForUser = 'No any form templates are allowed for the user!';
	static SavingRecordUserParameterWasSuccessful = 'User record \'{0}\' saved successfully!';
	static FormSortAscending = 'Ascending Order';
	static DefaultRiskProcesses = 'Default My Classifications';
	static FolderTreePermissions = 'Folder Tree Permissions';
	static SelectEventTypeC = 'Select Category 3';
	static FurtherEducation = 'Education';
	static EmptyReportTrashBinConfirmation = 'Do you really want to permanently remove all reports from trash bin? Removed reports cannot be restored.';
	static AccessRightRead_TaskDescription_C = '* Can fill in row-based forms\n* Can read and edit only their own rows';
	static Picture = 'Picture';
	static DoYouReallyWantToRemoveRiskStakeholderParameter = 'Do you really want to remove stakeholder \'{0}\'?';
	static AccessRightWrite_EventDescription = '* Can create incidents\n* Can view all incidents of the unit\n* Can be selected as incident handler and can handle all incidents of the unit\n* Can be selected as default handler and person to be notified';
	static ChartRemoveFieldConfirmation = 'Do you really want to remove chart from form?';
	static RecordUserExcelTabName = 'User Records';
	static FormField = 'Field';
	static AddMessageType = 'Add Message Type';
	static FormEventReferenceIsIsInvalid = 'Incident reference is invalid!';
	static AddCompanyParameterWasNotSuccessfulConcurrencyError = 'Failed to add company \'{0}\', because the data has been modified concurrently by another user!';
	static UsedInParameterTasks = 'Used in {0} forms';
	static RecordUsersFound = 'User Records Found';
	static ReminderWeekBefore = 'week before';
	static EditEventTypeB = 'Edit Category 2';
	static EventTypesBReportName = 'Incidents - Category 2';
	static DocumentTemplateParameterNotFound = 'Document template \'{0}\' not found!';
	static AddRecordUserAndUserAccount = 'Add user record and new user account';
	static AuthorizationLevelUser = 'Users';
	static CalendarTaskOpenSeries = 'Open Series';
	static ReminderHoursBefore = 'hours before';
	static DeletingFileFiltersParameterWasNotSuccessfulErrorParameter = 'Failed to remove file filters \'{0}\'! Error: \'{1}\'';
	static UserGroupModuleProperties = 'User Groups Properties';
	static EventTypeBParameterChildrenAreInUseInParameterEventsAndCannotBeDeleted = 'Category 2 \'{0}\' subcategories are used in {1} incidents and category 2 cannot be removed!';
	static DeletingEventPartnerParameterWasSuccessful = 'Incident partner \'{0}\' removed successfully!';
	static SavingEmailSendLogParameterWasNotSuccessfulErrorParameter = 'Failed to save email log! Error: \'{0}\'';
	static GroupByFamiliarization = 'Group by Familiarization';
	static DoYouReallyWantToRemoveEventUrgencyClassParameter = 'Do you really want to remove urgency class \'{0}\'?';
	static Last30Days = 'Last 30 Days';
	static UserRecordStatisticsUnapprovedFamiliarizations = 'Unapproved Familiarizations';
	static RestoringOpportunityParameterFromTrashBinWasSuccessful = 'Opportunity \'{0}\' has been restored from trash bin!';
	static AccountNumberTkbInDebit = 'Sales Receivable Account';
	static AuthorizationLevelSuperUser = 'Superuser';
	static InstantMessageChannelMustHaveAtLeastOneAdministrator = 'Chat must have at least one administrator!';
	static Hidden = 'Hidden';
	static WhistleBlowCategoryCodeIsAlreadyInUse = 'Whistle blow category name is already in use!';
	static UserCannotRecieveEmailNotifications = 'User will not receive email notifications';
	static MovingFolderDirectoryItemParameterToFolderParameterWasNotSuccessfulConcurrencyError = 'Failed to move folder \'{0}\' into folder \'{1}\',  because data in the folder has been modified concurrently by another user!';
	static DeletingUsersParameterWasSuccessful = 'User accounts \'{0}\' removed successfully!';
	static RiskStandardsMustBeDefinedBeforeAddingRisks = 'Standards must be defined before adding risks!';
	static CompanyGroups = 'Company Groups';
	static FormBoldFont = 'Bold Font';
	static WhistleBlowStateArchived = 'Archived';
	static RecordUser = 'User Record';
	static DefaultEventUrgencyClasses = 'Default Urgency Classes';
	static CalendarTaskRemoveOccurrence = 'Remove Occurrence';
	static Images = 'Images';
	static EmptyRiskManagementTrashBin = 'Empty Risk Management Trash Bin';
	static UserClaimsNotFound = 'User claims not found!';
	static ShowChartInFrontPage = 'Show chart in front page';
	static CalendarTaskOpenOccurrence = 'Open Occurrence';
	static FileFilterParameterNotFound = 'File filter \'{0}\' not found!';
	static CreatingFileParameterWasNotSuccessfulErrorParameter = 'Failed to create file \'{0}\' in filesystem! Error: \'{1}\'';
	static WholeHistory = 'Whole History';
	static DeletingWhistleBlowChannelAdminsParameterWasNotSuccessfulConcurrencyError = 'Failed to remove administrators \'{0}\', because the data has been modified concurrently by another user!';
	static AddFurtherEducationToMultipleUserRecords = 'Add Education to Multiple User Records';
	static SavingEventParameterWasNotSuccessfulErrorParameter = 'Failed to save incident \'{0}\'! Error: \'{1}\'';
	static DeletingRecordUserParameterWasSuccessful = 'User record \'{0}\' removed successfully!';
	static FormDocumentReferenceDocumentIdIsInvalid = 'Document reference documentId is invalid!';
	static WhistleBlowAttachmentRemoveReasonDefaultValue = 'Removed an attachment containing unnecessary information (e.g., personal data).';
	static EmptyingTaskTrashBinWasSuccessfulErrorParameter = 'Failed to empty form trash bin! Error: \'{0}\'';
	static InheritedUserRights = 'Inherited Permissions';
	static RemoveEventPartner = 'Remove Incident Partner';
	static NewPasswordMustBeDefined = 'New password must be defined!';
	static LogoSquare = 'Small Logo';
	static UnitHandlingIncomingEvents = 'Unit That Handles Incidents Sent by the Partner';
	static Yes = 'Yes';
	static ReportTemplateNotAnyAllowedForUser = 'No any report templates are allowed for the user!';
	static DeletingTaskStateParameterWasSuccessful = 'Form state \'{0}\' removed successfully!';
	static RiskModuleInfoPermissions = 'Visibility and access rights for risks. Access can be granted to QR code users.';
	static SavingOpportunityParameterWasNotSuccessfulErrorParameter = 'Failed to save opportunity \'{0}\'! Error: \'{1}\'';
	static PublishingRiskParameterWasSuccessful = 'Risk \'{0}\' published successfully!';
	static AllWhistleBlowHandlersHaveReadMessage = 'All whistle blow report handlers have read your message';
	static UseInheritedContentFiltering = 'Use inherited content filtering';
	static PublishEvent = 'Publish Incident';
	static WhistleBlowArchivingTypeChangeStateAndRemoveInformantData = 'Change whistle blow report state to \'Archived\' and remove informant  data';
	static ReportTemplateRemoveFieldConfirmation = 'Do you really want to remove field from report template?';
	static AddEventPartner = 'Add Incident Partner';
	static EmptyReport = 'Empty Report';
	static DoCleanLog = 'Clear Log';
	static DeletingReportTemplatesParameterWasNotSuccessfulErrorParameter = 'Failed to remove report templates \'{0}\'! Error: \'{1}\'';
	static UserFilterExpired = 'Expired';
	static FileFilters = 'File Filters';
	static FamiliarizationTrainer = 'Trainer';
	static SavingInstantMessageChannelParameterWasNotSuccessfulConcurrencyError = 'Failed to save chat \'{0}\', because data in the chat has been modified concurrently by another user!';
	static SearchFamiliarizations = 'Search Familiarizations';
	static LockedToUser = 'Locked by User';
	static AccessRightNone_DocumentDescription = 'No access to folder contents';
	static AccessRightNone_CompanyGroupDescription = 'No access to company groups';
	static WriteBelowFieldWordParameterToConfirmTheOperation = 'Write word \'{0}\' to the field below to confirm the operation';
	static Amount = 'Amount';
	static UserGroupCodeMustBeDefined = 'User group code must be defined!';
	static EInvoiceAddress = 'E-invoice Address';
	static Monthly = 'Monthly';
	static RecordFurtherEducationGroupCodeIsAlreadyInUse = 'Education group name is already in use!';
	static DoYouReallyWantToRemoveRiskParameterPermanently = 'Do you really want to permanently remove risk \'{0}\'? Removed risk cannot be restored.';
	static Missing = 'Missing';
	static SavingEventTypeCsWasNotSuccessfulErrorParameter = 'Failed to save category 3! Error: \'{0}\'';
	static PageFooterText = 'System Page Footer Text';
	static HandlersAndAttachments = 'Handlers and Attachments';
	static AddInstantMessageChannel = 'Add Chat';
	static SavingDirectoryItemFolderParameterWasSuccessful = 'Folder \'{0}\' saved successfully!';
	static FolderNameMustBeDefined = 'Folder name must be defined!';
	static DeletingUserParametersWasNotSuccessfulConcurrencyError = 'Failed to remove user parameters, because data in the parameters has been modified concurrently by another user!';
	static SelectRiskTemplate = 'Select Risk Template';
	static DeletingRiskParameterWasSuccessful = 'Risk \'{0}\' removed successfully!';
	static DoYouReallyWantToRemoveCalendarTaskCategoryParameter = 'Do you really want to remove category \'{0}\'?';
	static RemoveDefaultEventHandler = 'Remove Default Incident Handler';
	static ProcessedFolderParameterErrorCountParameter = '* Folder \'{0}\' completed, errors: {1}';
	static InstantMessageUserInvitationAcceptTypeAutoAcceptInvitation = 'I will automatically accept invitation to join chat';
	static DeletingMessageTypesParameterWasNotSuccessfulErrorParameter = 'Failed to remove message types \'{0}\'! Error: \'{1}\'';
	static ObserverActionMustBeDefined = 'Observer action must be defined!';
	static LogisticVoucher = 'Transport Invoicing';
	static DoesNotWork = 'Does not Work';
	static RecordUserUser = 'User record user account';
	static Payer = 'Payer';
	static RestoringInstantMessageWasSuccessful = 'Instant message restored successfully!';
	static AddEventTypeBsToEvent = 'Add category 2 by tapping the pen button.';
	static DeletingRiskCategoryParameterWasSuccessful = 'Risk category \'{0}\' removed successfully!';
	static DeletingUserGroupParameterWasSuccessful = 'User group \'{0}\' removed successfully!';
	static SavingAttachmentsWasNotSuccessfulErrorParameter = 'Failed to save attachments! Error: \'{0}\'';
	static Or = 'Or';
	static EventTypeCs = 'Category 3';
	static Group = 'Group';
	static WhistleBlowParameterNotFound = 'Whistle blow report \'{0}\' not found!';
	static SelectReminder = 'Select Reminder';
	static Message = 'Message';
	static CalendarTaskModuleInfoPermissions = 'Visibility and access rights of the calendar feature. Access can be granted to QR code users.';
	static ImportTaskDataRows = 'Import Rows';
	static InstantMessageChannelInformation = 'Chat information';
	static WhistleBlowSourceSystem = 'System';
	static SummaryRow = 'Summary Row';
	static PositionErrorTimeout = 'Location information reading timeout.';
	static DeletingWhistleBlowParameterWasSuccessful = 'Whistle blow report \'{0}\' removed successfully!';
	static SavingRiskStandardParameterWasNotSuccessfulErrorParameter = 'Failed to save standard \'{0}\'! Error: \'{1}\'';
	static DeletingRecordFamiliarizationParameterWasNotSuccessfulErrorParameter = 'Failed to remove familiarization \'{0}\'! Error: \'{1}\'';
	static EditableDocumentSaveBeforeApproveConfirmation = 'Do want to save changes  to the document before approval?';
	static DoYouReallyWantToRemoveTaskPriorityParameter = 'Do you really want to remove form priority \'{0}\'?';
	static DoYouReallyWantToRemoveSelectedRiskTemplates = 'Do you really want to remove selected risk templates?';
	static WhistleBlowDescription = 'Incident Description';
	static DownloadFileTemplate = 'Download File Template';
	static DoYouReallyWantToRemoveThisInstantMessage = 'Do you really want to remove this instant message? Instant message will be removed from all parties.';
	static EditDefaultBasicEducation = 'Edit Default Basic Education';
	static TaskTypeParameterNotFound = 'Form template \'{0}\' not found!';
	static DeletingFileParameterWasNotSuccessfulErrorParameter = 'Failed to remove file \'{0}\' in filesystem! Error: \'{1}\'';
	static UserRecordStatisticsArchivedCards = 'Archived Cards';
	static SavingRecordUserSettingsWasNotSuccessfulConcurrencyError = 'Failed to save resource settings, because resource settings have been modified concurrently by another user!';
	static WhistleBlowStatisticsNonAnonymousRecords = 'Nonanonymous Reports';
	static SavingRiskProcessParameterWasNotSuccessfulErrorParameter = 'Failed to save my classification \'{0}\'! Error: \'{1}\'';
	static AccessRightRead_TaskDescription = 'Can read forms';
	static RemoveTransferredProperty = 'Remove Transferred Property';
	static AddCompanyGroupsParameterWasSuccessful = 'Company groups \'{0}\' added successfully!';
	static SavingDirectoryItemDocumentParameterWasSuccessful = 'File \'{0}\' saved successfully!';
	static EditDocumentTemplate = 'Edit Document Template';
	static MaximumSizeOfImageIsParameterMB = 'Maximum size of the image is {0} MB, bigger images will be automatically resized.';
	static CompanyGroupAll = '\'All Companies\'';
	static AddingAddRecordUserQualificationsWasSuccessful = 'Qualifications added successfully!';
	static NoToDos = 'No open things to do';
	static FrontPage = 'Dashboard';
	static RiskStakeholder = 'Stakeholder';
	static FormulaMin = 'Minimum';
	static MoveUp = 'Move Upwards';
	static MovingRiskParameterToTrashBinWasSuccessful = 'Risk \'{0}\' has been moved to trash bin!';
	static RemoveLogisticVoucherCompanyPaymentSetting = 'Remove Payment Setting';
	static ConnectToMicrosoftAccount = 'Connect to Microsoft Account';
	static WhistleBlowSeverityHigh = 'High';
	static ChartTestData = 'Chart Test Data';
	static CopyDefaultHandlersToAllSameLevelUnits = 'Copy Default Handlers to All Same Level Units';
	static TrashBin = 'Trash Bin';
	static SelectDate = 'Select Date';
	static PanelSize1 = '1 x 1';
	static SavingChartWasNotSuccessfulErrorParameter = 'Failed to save chart! Error: \'{0}\'';
	static ArchivingReportParameterWasNotSuccessfulConcurrencyError = 'Failed to archive report \'{0}\', because data in the report has been modified concurrently by another user!';
	static WhistleBlowInformantMessageConfirmation = 'Do you want to send new message to informant?';
	static DeletingRecordFurtherEducationsParameterWasSuccessful = 'Educations \'{0}\' removed successfully!';
	static DoYouReallyWantToRemoveRiskAssessmentParameter = 'Do you really want to remove assessment \'{0}\'?';
	static EditMessage = 'Edit Message';
	static FormRelativeDefinition = 'Relative Definition';
	static SavingEventTypeBParameterWasNotSuccessfulConcurrencyError = 'Failed to save category 2 \'{0}\', because data in the incident category 2 has been modified concurrently by another user!';
	static FamiliarizationEndDateCannotPrecedeFamiliarizationStartDate = 'End date cannot precede start date!';
	static SendingEmails = 'Sending emails...';
	static Attachments = 'Attachments';
	static TaskType = 'Form Template';
	static IncludeArchivedFamiliarizations = 'Include archived familiarizations';
	static RestoringRiskParameterFromArchiveWasNotSuccessfulConcurrencyError = 'Failed to restore risk \'{0}\' from archive, because the data has been modified concurrently by another user!';
	static IntervalMustBeDefined = 'Interval must be defined!';
	static CurrentCalendarMonth = 'Current Calendar Month';
	static MovingFilesAndDocumentsToFolderParameterWasNotSuccessfulErrorParameter = 'Failed to move files/documents into folder \'{0}! Error: \'{1}\'';
	static AddingAddRecordUserFurtherEducationsWasSuccessful = 'Educations added successfully!';
	static DeletingInstantMessageChannelWasNotSuccessfulConcurrencyError = 'Failed to remove participant, because the data has been modified concurrently by another user!';
	static EventPartnerParameterNotFound = 'Incident partner \'{0}\' not found!';
	static UnreadInstantMessages = 'Unread messages';
	static RemoveWhistleBlowCategory = 'Remove Whistle Blow Category';
	static AddChildRiskStandard = 'Add Substandard';
	static OpenWhistleBlowInstruction = 'Enter the password that you received when the whistle blow report was submitted.';
	static EventCreator = 'Creator';
	static PasswordMustContainDigitOrSpecialCharacter = 'Password must contain number or special character!';
	static EditFileFilter = 'Edit File Filter';
	static NoFilesToAdd = 'No files to add!';
	static RemoveDefaultEventType = 'Remove Default Category 1';
	static TaskDashboard = 'Forms';
	static SavingFileFilterParameterWasNotSuccessfulErrorParameter = 'Failed to save file filter \'{0}\'! Error: \'{1}\'';
	static DoYouReallyWantToRemoveReportParameter = 'Do you really want to remove report \'{0}\'?';
	static WhistleBlowSendReport = 'Send Report';
	static FormTrue = 'True';
	static CalendarTaskFilterByState = 'Filter Events by State';
	static ExternalSystems = 'External Systems';
	static FormTimeSpan = 'Time Amount (h:mm)';
	static TreatmentEfficiency = 'Treatment Efficiency';
	static FormMobile = 'Mobile App';
	static RiskTreatmentsPlaceholder = 'Describe here the main measures to reduce the risk or improve management.';
	static SavingRecordUserPartnerParameterWasNotSuccessfulErrorParameter = 'Failed to save resource partner \'{0}\'! Error: \'{1}\'';
	static Distribution = 'Distribution';
	static WhistleBlowSeverityUnspecified = 'Unspecified';
	static ZipFileCreationFailed = 'Failed to create zip file! Error: \'{0}\'';
	static EventModuleInfoUrgencyClasses = 'Urgency classes used in incidents. These classes are utilized in sorting, filtering, and reporting incidents.';
	static CommentMustNotBeEmpty = 'Comment must not be empty!';
	static EventTypeParameterChildrenAreInUseInParameterEventsAndCannotBeDeleted = 'Category 1 \'{0}\' subcategories are used in {1} incidents and category 1 cannot be removed!';
	static VerifyUserName = 'Verify that username is correct (\'{0}\')!';
	static DoYouReallyWantToMoveRiskParameterToTrashBin = 'Do you want to move risk \'{0}\' to trash bin?';
	static RecordUserPartners = 'Resource partners';
	static AccessRightNone_TaskDescription = 'No access to forms';
	static RemoveRecordUserAndUserSetExpired = 'Remove User Record and Set User Account Expired';
	static DeletingRecordUserTransferredPropertyParameterWasNotSuccessfulConcurrencyError = 'Failed to remove transferred property \'{0}\',  because data in the transferred property has been modified concurrently by another user!';
	static UserName = 'Username';
	static FilterIsActive = 'Filter is Active';
	static PublishVersion = 'Publish Version';
	static SavingMessageParameterWasSuccessful = 'Message \'{0}\' saved successfully!';
	static ApprovalComment = 'Approval Comment';
	static UserHasUsedMobile = 'User account has has been active in mobile application in last 30 days.';
	static SavingPushSendLogParameterWasNotSuccessfulErrorParameter = 'Failed to save push notification! Error: \'{0}\'';
	static ReportContents = 'Report Contents';
	static FormTextInputs = 'Text Inputs';
	static ChangesMaxAmount = 'Maximum amount of changes';
	static RecordFurtherEducationGroupParameterNotFound = 'Education group \'{0}\' not found!';
	static UserRecordStatisticsExpiredFamiliarizations = 'Expired Familiarizations';
	static AccessRightNone_EventDescription = 'No access to create, view nor handle incidents of the unit.';
	static Reports = 'Reports';
	static MoneyIn = 'Money In';
	static SavingCompanyParameterWasNotSuccessfulErrorParameter = 'Failed to save company \'{0}\'! Error: \'{1}\'';
	static SelectChartToSeeChartProperties = 'Select chart to see it\'s properties';
	static And = 'and';
	static DoYouReallyWantToRemovePartnersParameter = 'Do you really want to remove partners \'{0}\'?';
	static AddSalaryRowToMultipleUserRecords = 'Add Salary Row to Multiple User Records';
	static AccountNumberTkbOutDebit = 'Trade Payable Account';
	static EventTypesReportBarChartByCategoryName = 'Bar Chart - By Category';
	static EmploymentStartDate = 'Employment Start Date';
	static Process = 'Process';
	static CalendarTaskRepetitionRepeatIntervalDayMonthSeparator = 'of';
	static EventTypeCTitle = 'Incident Identification Category 3';
	static UserCodeMustBeValid = 'Username must be 8-50 characters long and it cannot contain whitespaces.';
	static DoYouReallyWantToRemoveDefaultEventHandlerParameter = 'Do you really want to remove default incident handler \'{0}\'?';
	static WhistleBlowArchivingTypeChangeState = 'Change whistle blow report state to \'Archived\'';
	static FolderParameterAlreadyExistsInTargetFolder = 'Folder \'{0}\' already exists in the destination folder!';
	static CalendarTaskCategoryParameterNotFound = 'Category \'{0}\' was not found!';
	static RiskStakeholderParameterNotFound = 'Stakeholder \'{0}\' not found!';
	static DeletingCalendarTaskCategoriesParameterWasSuccessful = 'Categories \'{0}\' removed successfully!';
	static WhistleBlowStateResolved = 'Resolved';
	static InvitationPasswordReset = 'Invitation / Password Reset';
	static FormColumnTitle = 'Column Title';
	static SavingFilterWasNotSuccessfulConcurrencyError = 'Failed to save filter, because data in the filter has been modified concurrently by another user!';
	static ReportsStandard = 'Standard Reports';
	static RestoringTaskParameterFromArchiveWasSuccessful = 'Form \'{0}\' has been restored from archive!';
	static OnlyImageAndPdfAttachmentsAreAllowedInvalidAttachmentParamater = 'Only image and pdf attachments are allowed! Attachments \'{0}\' are Invalid.';
	static NotUsableForSelectedTaskType = 'Not allowed for selected form!';
	static WhistleBlow = 'Whistleblower';
	static SavingEventTypeBsWasNotSuccessfulErrorParameter = 'Failed to save category 2! Error: \'{0}\'';
	static DeletingRecordUserTransferredPropertiesParameterWasNotSuccessfulErrorParameter = 'Failed to remove transferred properties \'{0}\'! Error: \'{1}\'';
	static ThisPartOfApplicationIsNotInUse = 'This part of application is not in use!';
	static AddingAddRecordUserTransferredPropertiesWasSuccessful = 'Transferred properties added successfully!';
	static DoYouReallyWantToRemoveKeywordParameter = 'Do you really want to remove keyword \'{0}\'?';
	static Select = 'Select';
	static AddEventMessageConfirmation = 'Do you want to add the comment? The comment cannot be edited after it has been added.';
	static GroupByYear = 'Group by Year';
	static SavingEventMessageWasNotSuccessfulErrorParameter = 'Failed to save comment! Error: \'{0}\'';
	static TrainingTime = 'Training Time';
	static DeletingCompaniesParameterWasNotSuccessfulConcurrencyError = 'Failed to remove companies \'{0}\', because data has been modified concurrently by another user!';
	static EventTypeCostsReportBarChartIndirectCostsByTimeName = 'Bar Chart - Indirect Costs';
	static SavingCompanyGroupParameterWasNotSuccessfulErrorParameter = 'Failed to save company group \'{0}\'! Error: \'{1}\'';
	static MovingTaskParameterToTrashBinWasNotSuccessfulConcurrencyError = 'Failed to move form \'{0}\' to trash bin, because data in the form has been modified concurrently by another user!';
	static FurtherEducationsHistory = 'Registered Educations';
	static Internet = 'Internet';
	static AccessRightFull = 'All permissions';
	static DeletingRecordBasicEducationParameterWasNotSuccessfulErrorParameter = 'Failed to remove basic education \'{0}\'! Error: \'{1}\'';
	static Yesterday = 'Yesterday';
	static DoYouReallyWantToRemoveRiskCategoryParameter = 'Do you really want to remove risk category \'{0}\'?';
	static DeletingRecordFurtherEducationParameterWasNotSuccessfulErrorParameter = 'Failed to remove education \'{0}\'! Error: \'{1}\'';
	static LockedReportParameterCannotBePublished = 'Locked report \'{0}\' cannot be published!';
	static DeletingEditableDocumentParameterWasNotSuccessfulErrorParameter = 'Failed to remove document \'{0}\'! Error: \'{1}\'';
	static AccessRightRead_Record = 'Own user record';
	static NoPublishedMessages = 'No published messages';
	static DoYouReallyWantToMoveOpportunityParameterToTrashBin = 'Do you want to move opportunity \'{0}\' to trash bin?';
	static MaximumTotalSizeOfAttachmentsIsParameterMB = 'Maximum total size of all attachments is  {0} MB!';
	static DeletingRiskStandardsParameterWasSuccessful = 'Standards \'{0}\' removed successfully!';
	static PanelIsShared = 'Panel is Shared';
	static JobResultParameterNotFound = 'Job result \'{0}\' not found!';
	static AutoSaveVersionHistorySize = 'Autosave Version History Size';
	static DoYouReallyWantToRemoveAttachmentParameter = 'Do you really want to remove attachment \'{0}\'?';
	static AddFurtherEducations = 'Add educations';
	static End = 'End';
	static RemovingRecordUserFamiliarizationHandlerWasNotSuccessfulErrorParameter = 'Failed to remove approvers! Error: \'{0}\'';
	static EmailSent = 'Email Sent';
	static RiskTreatments = 'Treatments';
	static RecordEmailNotificationType = 'I Want to Receive Company Resources Educations Report (Expiring Educations)';
	static EventTypeBs = 'Category 2';
	static DocumentRootPathIsNotEmpty = 'Document root path is not empty folder!';
	static DoYouReallyWantToRemoveFilterParameter = 'Do you really want to remove filter \'{0}\'?';
	static EventHandler = 'Handler';
	static ShowUsers = 'Show User Accounts';
	static PreventiveAction = 'Preventive Action';
	static SavingEmailSendLogParameterWasSuccessful = 'Email log saved successfully!';
	static DoYouReallyWantToMoveReportParameterToTrashBin = 'Do you want to move report \'{0}\' to trash bin?';
	static SavingOptionParameterWasNotSuccessfulConcurrencyError = 'Failed to save option \'{0}\', because data in the option has been modified concurrently by another user!';
	static RemoveRow = 'Remove Row';
	static DeletingRiskStandardsParameterWasNotSuccessfulErrorParameter = 'Failed to remove standards \'{0}\'! Error: \'{1}\'';
	static WhistleBlowAnonymousReportInfo = 'If you do not want to reveal your name during the reporting process, choose this option.';
	static ChangePassword = 'Change Password';
	static ArchivingRecordUserFurtherEducationsWasNotSuccessfulErrorParameter = 'Failed to archive educations! Error: \'{0}\'';
	static AccessRightRead_Event_C = 'Create and view all';
	static RecordUserFurtherEducationsBarChartByEducationName = 'Bar Chart - Educations - By Name';
	static Folder = 'Folder';
	static EventTypesGeneric = 'Types';
	static FormModifyUser = 'Modify User';
	static ByName = 'By Name';
	static DeletingEventUrgencyClassParameterWasNotSuccessfulErrorParameter = 'Failed to remove urgency class \'{0}\'! Error: \'{1}\'!';
	static InvalidRequest = 'Invalid Request!';
	static UserRecordStatisticsExpiredQualifications = 'Expired Qualifications';
	static KeywordsOrCondition = 'Any of selected keywords';
	static EditDefaultFurtherEducation = 'Edit Default Education';
	static SpecifedTimeFrame = 'Specifed Time Frame';
	static DeletingEventTypeBParameterWasNotSuccessfulErrorParameter = 'Failed to remove category 2 \'{0}\'! Error: \'{1}\'';
	static UnitProperties = 'Unit Properties';
	static SavingDocumentTemplateParameterWasNotSuccessfulConcurrencyError = 'Failed to save document template \'{0}\', because data in the document template has been modified concurrently by another user!';
	static SaveTaskConfirmation = 'Do you want to save the form?';
	static WhistleBlowInformation = 'Report Information';
	static SaveComment = 'Save Comment';
	static Approval = 'Approval';
	static AddRiskAssessments = 'Add Assessments';
	static PublishingRiskParameterWasNotSuccessfulConcurrencyError = 'Failed to publish risk \'{0}\', because the data has been modified concurrently by another user!';
	static TaskChartValueFieldCalculationTypeMedian = 'Median';
	static FamiliarizationsMustBeDefinedBeforeAddingRecordUserFamiliarizations = 'Company familiarizations must be defined before adding user record familiarizations!';
	static PanelSize2 = '2 x 1';
	static RiskThreatMustBeDefined = 'Threat must be defined!';
	static EditRecordUserPartner = 'Edit Resource Partner';
	static LockedReportParameterCannotBeRestored = 'Locked report \'{0}\' cannot be restored!';
	static SaveInstantMessageChannelConfirmation = 'Do you want to save the chat?';
	static SaveFilterAs = 'Save Filter As';
	static ActivePlural = 'Active';
	static Last120Days = 'Last 120 Days';
	static Min = 'Min';
	static ExportToExcel = 'Export to Excel';
	static FirstRows = 'First Rows';
	static SavingWhistleBlowMessageWasNotSuccessfulErrorParameter = 'Failed to save message! Error: \'{0}\'';
	static MyLastModifications = 'User\'s Latest Modifications';
	static SavingMessageTypeParameterWasNotSuccessfulErrorParameter = 'Failed to save message type \'{0}\'! Error: \'{1}\'';
	static AssessmentComment = 'Assessment Conclusion';
	static ChangeSystemLanguageToSwedish = 'Change Language to Swedish';
	static DeletingTaskParameterWasNotSuccessfulConcurrencyError = 'Failed to remove form \'{0}\', because data in the form has been modified concurrently by another user!';
	static DeletingCalendarTaskCategoryParameterWasNotSuccessfulErrorParameter = 'Failed to remove category \'{0}\'! Error: \'{1}\'';
	static ModifyDate = 'Last Modified';
	static AccessRightRead_EventDescription_C = '* Can create incidents\n* Can view all incidents of the unit\n* Can be selected as person to be notified';
	static LockedDocumentsParameterCannotBeMoved = 'Locked documents \'{0}\' cannot be moved!';
	static SaveUserFamiliarizationConfirmation = 'Do you want to save the familiarization?';
	static RemovePayer = 'Remove Payer';
	static FormColumnWidth = 'Column Width';
	static AddUserGroupsParameterWasSuccessful = 'User groups \'{0}\' added successfully!';
	static UserFilterNoUserGroup = 'No User Group';
	static FormEmptyArea = 'Empty Area';
	static SaveEventHandlerConfirmation = 'Do you want to save the incident?';
	static AddSharedPanel = 'Add Shared Panel';
	static Resources = 'Resources';
	static DoYouReallyWantToRemoveEventParameter = 'Do you really want to remove incident \'{0}\'?';
	static ImageProperties = 'Image Properties';
	static SavingSharedPanelWasNotSuccessfulErrorParameter = 'Failed to save shared panel! Error: \'{1}\'';
	static DeletingKeywordsParameterWasNotSuccessfulErrorParameter = 'Failed to remove keywords \'{0}\'! Error: \'{1}\'';
	static InstantMessagePartners = 'Instant Message Partners';
	static RestoringReportParameterFromArchiveWasNotSuccessfulConcurrencyError = 'Failed to restore report \'{0}\' from archive, because data in the report has been modified concurrently by another user!';
	static WaitingToBeApproved = 'Waiting to be approved';
	static ImageChangeInterval = 'Image Change Interval';
	static Warning = 'Warning';
	static OldestMessage = 'Oldest Message';
	static QualificationRequirementOneValid = 'Qualification: 1 valid education';
	static Last2Years = 'Last 2 Years';
	static AccessRightWrite_CompanyDescription = 'Can edit the company name, address details, password settings and logo';
	static Subject = 'Subject';
	static SavingEventDefaultHandlerParameterWasSuccessful = 'Default incident handler \'{0}\' saved successfully!';
	static DeletingMessageTypesParameterWasSuccessful = 'Message types \'{0}\' removed successfully!';
	static RequiredValidQualificationCount = 'Required Valid Qualification Count';
	static ResidualRisk = 'Residual Risk';
	static AccessRightWrite_AppReport = 'Limited edit access';
	static TaskCreated = 'Created By';
	static RemoveFolder = 'Remove Folder';
	static Conversions = 'Conversions';
	static SharePanel = 'Share Panel';
	static EditFurtherEducation = 'Edit Education';
	static EditAttachment = 'Edit Attachment';
	static DeletingDirectoryItemDocumentParameterWasSuccessful = 'File \'{0}\' removed successfully!';
	static FormRequired = 'Input Required';
	static PageNameMustBeDefined = 'Page name must be defined!';
	static PushNotificationInUse = 'I Want to Receive Push Notifications (eSalkku Mobile)';
	static LanguageParameterIsNotSupported = 'Language \'{0}\' is not supported!';
	static AccountNumberTkbOutCredit = 'Trade Account';
	static NoName = 'Anonymous';
	static DeletingRiskProcessParameterWasSuccessful = 'My classification \'{0}\' removed successfully!';
	static EditEventTypes = 'Edit Category 1';
	static DoYouReallyWantToRestoreThisInstantMessage = 'Do you really want to restore this instant message?';
	static SelectRecordUserTypeToBeCreated = 'Select user record type for new record';
	static AddQrCodeUserGroup = 'Add QR Code User Group';
	static UsedQuota = 'Used Quota';
	static WhistleBlowWasNotFound = 'Whistle blow report not found!';
	static CalendarTaskEditSeries = 'Edit Series';
	static NotSelected = 'Not Selected';
	static FormTitle3 = 'Title 3';
	static AccessRightNone_UserDescription = 'No access to user accounts';
	static RestoringTaskParameterFromTrashBinWasSuccessful = 'Form \'{0}\' has been restored from trash bin!';
	static RiskStakeholderCodeIsAlreadyInUse = 'Stakeholder name is already in use!';
	static PortalInUse = 'Login Portal Is in Use';
	static DocumentEndDate = 'Valid Until';
	static DeletingAttachmentsWasNotSuccessfulErrorParameter = 'Failed to remove attachments! Error: \'{0}\'';
	static ReportTemplatesMustBeDefinedBeforeAddingReports = 'Report templates must be defined before adding reports!';
	static AddNotifiedPerson = 'Add Person to Be Notified';
	static Collapse = 'Collapse';
	static DeletingTaskStatesParameterWasSuccessful = 'Form states \'{0}\' removed successfully!';
	static DefaultSettings = 'Default Settings';
	static UserFilterQrCodeUser = 'QR Code User Accounts';
	static CalendarTaskOccurrence = 'Occurrence';
	static AddDefaultTaskType = 'Add Default Form Template';
	static YouDeletedThisMessage = 'You deleted this message';
	static WhistleBlowResolutionUnspecified = 'Not Resolved';
	static Clear = 'Clear';
	static DeletingCompanyGroupsParameterWasNotSuccessfulErrorParameter = 'Failed to remove company groups \'{0}\'! Error: \'{1}\'';
	static JobTitleMustBeDefined = 'Job title must be defined!';
	static LogisticVoucherCustomer = 'Customer';
	static NewInstantMessageChannelGroupInternal = 'New Group (company internal)';
	static Location = 'Location';
	static RiskSettingNotFound = 'Risk settings not found!';
	static OpenWhistleBlow = 'Open Whistle Blow Report';
	static PrintTask = 'Print Form';
	static InheritedUserRight = '(inherited permission)';
	static DoYouReallyWantToClearLog = 'Do you really want to clear the log?';
	static FormRecordReferenceWarning = 'Set resource reference required data ({0}) in Properties panel!';
	static EditableDocumentPublishConfirmation = 'Do you want to publish document to file?';
	static DeletingMessageParameterWasNotSuccessfulErrorParameter = 'Failed to remove message \'{0}\'! Error: \'{1}\'';
	static SavingTaskDataRowWasNotSuccessfulErrorParameter = 'Failed to save the form row! Error: \'{0}\'';
	static FormSizeLarge = 'Large';
	static Operators = 'Operators';
	static FormNumbers = 'Numbers';
	static CompanyInstantMessageChannels = 'Company Chats';
	static PublishTaskType = 'Publish Form Template';
	static AccessRightRead_MessageDescription_A = 'Can read published messages in the unit’s Current topics and messages published by partners';
	static Text = 'Text';
	static FormTextInput = 'Text Input';
	static TaskTaskChartGroupingFieldGroupingTypeValue = 'Value';
	static Test = 'Test';
	static InstantMessages = 'Instant Messages';
	static TaskPrioritiesMustBeDefinedBeforeAddingTasks = 'Form priorities must be defined before adding forms!';
	static RiskApprovalInfo = 'If the residual risk is {0} or greater, the risk must be approved.';
	static AddChildDefaultEventType = 'Add Default Subcategory 1';
	static Qualification = 'Qualification';
	static ArgumentParameterIsNULL = 'Value of the argument \'{0}\' is NULL!';
	static UserRecordStatisticsExpiredFurtherEducations = 'Expired Educations';
	static NoImagesToShow = 'No images to show';
	static EventClosed = 'Incident Closed';
	static DeletingUserGroupsParameterWasNotSuccessfulConcurrencyError = 'Failed to remove user groups \'{0}\', because data in user groups has been modified concurrently by another user!';
	static UnlockingTaskDataRowWasNotSuccessful = 'Failed to unlock the form row!';
	static Risks = 'Risks';
	static UnlockingTaskParameterWasNotSuccessful = 'Failed to unlock form \'{0}\'!';
	static QualificationIsValid = 'Qualification is valid';
	static PublishingReportParameterWasNotSuccessfulErrorParameter = 'Failed to publish report \'{0}\'! Error: \'{1}\'';
	static SelectUrgencyClass = 'Select Urgency Class';
	static OpportunityDescription = 'Description';
	static ReminderDayBefore = 'day before';
	static InstantMessageChannelUsers = 'Participants';
	static SavingPrintWasNotSuccessfulErrorParameter = 'Failed to save print! Error: \'{1}\'';
	static ReadImpPlur = 'Read';
	static UserPublicPasswordChangeMessage = 'You can specify your new password on this page. Your username was included in the email that contains link to this page.';
	static DefaultEventUrgencyClassMustBeDefinedBeforeAddingEvents = 'Default urgency class must be defined before adding incidents!';
	static MovingRiskParameterToTrashBinWasNotSuccessfulErrorParameter = 'Failed to move risk \'{0}\' to trash bin! Error: \'{1}\'';
	static RecordUserPartnerIsAlreadyDefined = 'Resource partner is already defined!';
	static UserEventsNotApproved = 'User events not approved';
	static TaskStates = 'Form States';
	static EventModuleInfoUnits = 'A unit is a channel where incidents can be saved. A unit can represent, for example, a process, location, device, etc. Create the necessary number of observation channels, for example, based on different functions.';
	static WhistleBlowChannelParameterNotFound = 'Whistle blow channel \'{0}\' not found!';
	static DesignArea = 'Design Area';
	static AddPartnersByClickingPlusButton = 'Add partners by clicking the plus button.';
	static DateMustBeDefined = 'Date must be defined!';
	static RiskControlsMustBeDefined = 'Controls must be defined!';
	static AccessRightWrite_Event = 'Create, handle all and view all';
	static DeletingTaskTypesParameterWasNotSuccessfulErrorParameter = 'Failed to remove form templates \'{0}\'! Error: \'{1}\'';
	static RestoringOpportunityParameterFromTrashBinWasNotSuccessfulConcurrencyError = 'Failed to restore opportunity \'{0}\' from trash bin, because the data has been modified concurrently by another user!';
	static Permission = 'Permission';
	static AddChildEventType = 'Add Subcategory 1';
	static FormTitle4 = 'Title 4';
	static RiskLevelMedium = 'Medium';
	static RemoveUserAndRecordUserArchive = 'Remove User Account and Archive User Record';
	static ResolutionDescription = 'Resolution Description';
	static AddFamiliarization = 'Add Further Familiarization';
	static PermissionsForSystems = 'System Permissions';
	static RemoveUser = 'Remove User Account';
	static BusinessIdentityCode = 'Business Identity Code';
	static WhistleBlowApplicationName = 'Whistle Blow Channel';
	static RestoringOpportunityParameterFromTrashBinWasNotSuccessfulErrorParameter = 'Failed to restore opportunity \'{0}\' from trash bin! Error: \'{1}\'';
	static SavingRiskTemplateParameterWasSuccessful = 'Risk template \'{0}\' saved successfully!';
	static AccessRightNone_MessageDescription = 'No access to messages in the unit’s Current topics';
	static RecordUserLogEntryTypePrint = 'Printing';
	static LogModuleProperties = 'Logs Properties';
	static AddingTaskTypeUnitsWasSuccessful = 'Units added successfully!';
	static AddingRecordUserSalaryRowsWasSuccessful = 'Salary rows added successfully!';
	static WhistleBlowEventTypeCreated = 'Created';
	static DeletingUserParametersWasSuccessful = 'User parameters removed successfully!';
	static JobTypeMessageNotification = 'Message Notification';
	static Today = 'Today';
	static SearchTasks = 'Search Forms';
	static ParameterResults = '({0} results)';
	static ExcelFile = 'Excel File';
	static UserCodeMustBeDefined = 'Username must be defined!';
	static WhistleBlowCategoryParameterIsInUseInParameterWhistleBlowsAndCannotBeDeleted = 'Whistle blow category \'{0}\' is used in {1} whistle blow records and cannot be removed!';
	static Voluntary = 'Voluntary';
	static PostalCode = 'Postal Code';
	static NewRecordUserMustBeSavedBeforeAttachmentsCanBeAdded = 'New user record must be saved before attachments can be added!';
	static AddingTaskTypeUnitsWasNotSuccessfulErrorParameter = 'Failed to add units! Error: \'{0}\'';
	static TimeSpanMonth = 'Month';
	static SavingTaskParameterWasNotSuccessfulErrorParameter = 'Failed to save form \'{0}\'! Error: \'{1}\'';
	static FieldParameterValueCanOnlyContainNumbers = 'Value of the field \'{0}\' can only contain numbers!';
	static AddReportTemplate = 'Add Report Template';
	static TaskDataRowTotalTypeColSum = 'Row sum';
	static NoTasksToShow = 'No forms to show!';
	static NoModifications = 'No modifications';
	static EventTypeCostsReportTableIndirectCostsByTimeName = 'Table - Indirect Costs';
	static ImageOrPdfUpToParameterMb = 'Image or PDF formats, up to {0} MB';
	static Communication = 'Communication';
	static AddPrint = 'Add Print';
	static ChangeToEditMode = 'Change to Edit Mode';
	static DoYouReallyWantToRemoveMessageParameter = 'Do you really want to remove message \'{0}\'?';
	static WhistleBlowEventTypeHandlersRemoved = 'Handlers removed';
	static VersionInformation = 'Version Information';
	static RecordUserModuleInfoFurtherEducations = 'Courses, training days, coaching sessions, and webinars are recorded under Education / Competencies. They can be grouped by topic if needed.#Groups can be added using the # button, and trainings using the # button.';
	static SaveToTemplate = 'Save as Template';
	static LikelihoodMustBeDefined = 'Likelihood must be defined!';
	static MovingFilesAndDocumentsToFolderParameterWasNotSuccessfulConcurrencyError = 'Failed to move files/documents into folder \'{0}\',  because data in the folder has been modified concurrently by another user!';
	static SavingEventPartnerParameterWasNotSuccessfulErrorParameter = 'Failed to save incident partner \'{0}\'! Error: \'{1}\'';
	static Resolution = 'Resolution';
	static EditLogisticVoucherCustomer = 'Edit Customer';
	static DeletingRiskStakeholdersParameterWasNotSuccessfulErrorParameter = 'Failed to remove stakeholders \'{0}\'! Error: \'{1}\'';
	static QrCodeAuthenticationTimeoutWeek = '7 days';
	static InstantMessage = 'Instant Message';
	static AddCompaniesParameterWasSuccessful = 'Companies \'{0}\' added successfully!';
	static SaveTask = 'Save Form';
	static LockedTaskParameterCannotBeSaved = 'The form \'{0}\' has been locked to another user and it cannot be saved!';
	static DeletingDefaultEventHandlerParameterWasNotSuccessfulErrorParameter = 'Failed to remove default incident handler \'{0}\'! Error: \'{1}\'';
	static UpdatingGroupCodeWasNotSuccessfulErrorParameter = 'Failed to update group code! Error: \'{0}\'';
	static AdditionalPermissions = 'Additional Permissions';
	static SendInvitationEmailToImportedUsers = 'Send Invitation Email to Imported Users';
	static DoYouReallyWantToRemoveSelectedMessageTypes = 'Do you really want to remove selected message types?';
	static NoNotificationsToSend = 'No notifications to be sent!';
	static RemoveDocument = 'Remove Selected Files/Documents';
	static Modified = 'Last Modified By';
	static DoYouReallyWantToRemoveSelectedRiskStandards = 'Do you really want to remove selected standards?';
	static DocumentsParameterOverwriteConfirmation = 'Files \'{0}\' already exist in folder. Do you want to overwrite these files?';
	static MovingTaskParameterToTrashBinWasSuccessful = 'Form \'{0}\' has been moved to trash bin!';
	static AddingAddRecordUserTransferredPropertiesWasNotSuccessfulErrorParameter = 'Failed to add transferred properties! Error: \'{0}\'';
	static NoReports = 'No Reports!';
	static PermissionsOtherCompanies = 'Permissions (other companies)';
	static ValidityEndDateExpirationTime = 'Validity Expiration Time';
	static UpdateUserParameterExternalSystemsWasSuccessful = 'User \'{0}\' linked to external systems successfully!';
	static ChangeSystemLanguageToEnglish = 'Change Language to English';
	static WhistleBlowCategory = 'Whistle Blow Category';
	static AttachmentImageSize = 'Attachment Image Thumbnail Size';
	static PrivateAndPublic = 'Private and Public';
	static UserGroupCodeIsAlreadyInUse = 'User group code is already in use!';
	static UnpublishingReportParameterWasNotSuccessfulErrorParameter = 'Failed to unpublish report \'{0}\'! Error: \'{1}\'';
	static BasicEducations = 'Basic Educations';
	static RecordUserExcelQualification = 'Qualifications';
	static RiskApproval = 'Risk Approval';
	static AddCompanyGroupParameterWasNotSuccessfulErrorParameter = 'Failed to add company group \'{0}\'! Error: \'{1}\'';
	static Add = 'Add';
	static Shared = 'Shared';
	static SavingRiskStakeholderParameterWasSuccessful = 'Stakeholder \'{0}\' saved successfully!';
	static DeletingRecordQualificationParameterWasSuccessful = 'Qualification \'{0}\' removed successfully!';
	static DeletingCompanyGroupParameterWasSuccessful = 'Company group \'{0}\' removed successfully!';
	static UnitCodeIsAlreadyInUse = 'Unit name is already in use!';
	static RecordUserEmploymentParameterNotFound = 'User record employment record \'{0}\' not found!';
	static RemoveFromFavorites = 'Remove from Favorites';
	static Next = 'Next';
	static DeletingAttachmentsParameterWasSuccessful = 'Attachments \'{0}\' removed successfully!';
	static AddPartnerParameterWasNotSuccessfulErrorParameter = 'Failed to add partner \'{0}\'! Error: \'{1}\'';
	static Handling = 'Handling';
	static NotEvaluated = 'Not Evaluated';
	static FamiliarizationsHistory = 'Registered Familiarizations';
	static PanelSize6 = '3 x 2';
	static TaskChartValueFieldCalculationTypeAverage = 'Average';
	static AddKeyword = 'Add Keyword';
	static SavingFilterWasSuccessful = 'Filter saved successfully!';
	static WhistleBlowInformantDateAndTime = 'When did this happen?';
	static FurtherEducationParameterNotFound = 'Education \'{0}\' not found!';
	static EmployeeType = 'Employee Type';
	static CompanyNumber = 'Company Number';
	static TreatmentTargetDateMustBeDefined = 'Target date must be defined!';
	static EventTypeCCodeIsAlreadyInUse = 'Category 3 name is already in use!';
	static DeletingFileFiltersParameterWasSuccessful = 'File filters \'{0}\' removed successfully!';
	static DeletingEventUrgencyClassesParameterWasNotSuccessfulErrorParameter = 'Failed to remove urgency classes \'{0}\'! Error: \'{1}\'!';
	static LockedRiskParameterCannotBeArchived = 'Locked risk \'{0}\' cannot be archived!';
	static PublishVersionHistorySize = 'Publish Version History Size';
	static SelectMonth = 'Select Month';
	static RemoveDefaultTaskPriority = 'Remove Default Form Priority';
	static WhistleBlowSourceMail = 'Mail';
	static Move = 'Move';
	static SelectableWhenCreatingAnEvent = 'Selectable When Creating an Event';
	static Unit = 'Unit';
	static InstantMessageChannelUserParameterIsNotAllowedToUseChannelParameter = 'User \'{0}\' does not have permission to use chat \'{1}\'!';
	static UserGroupNameMustBeDefined = 'User group name must be defined!';
	static UserTypeClaimNotFound = 'User claim \'user type\' not found!';
	static Risk = 'Risk';
	static Value = 'Value';
	static Course = 'Course';
	static ApprovalDateMustBeDefined = 'Approval date must be defined!';
	static DoYouWantToEraseOpportunityBenefitAndDescription = 'Do you  want to erase opportunity benefit and description?';
	static FormRadioOptionsDialog = 'Radio Button Options';
	static Table = 'Table';
	static DocumentTemplate = 'Document Template';
	static AddCompanyGroup = 'Add Company Group';
	static GroupByHalfYear = 'Group by Half Year';
	static FamiliarizationIsNotApprovedByUser = 'User has not approved the familiarization';
	static WhistleBlowStateNew = 'New';
	static EmptyingRiskManagementTrashBinWasSuccessful = 'Risk management trash bin is now empty!';
	static FormulaRound = 'Rounded';
	static SavingOneTimePasswordParameterWasSuccessful = 'One time password saved successfully!';
	static LoggedInUser = 'Logged in User';
	static RiskRegisterSummary = 'Risk Register Summary';
	static RiskTreatmentStateTreatmentsSpecified = 'Treatments specified';
	static Employee = 'Employee';
	static FormTaskReferenceWarning = 'Set form reference required data ({0}) in Properties panel!';
	static RemoveDefaultTaskType = 'Remove Default Form Template';
	static PositionErrorUnavailable = 'Location information unavailable.';
	static EventTypes = 'Category 1';
	static SelectedDocument = 'Selected Document';
	static OthersLastModifications = 'Last Modifications by Company';
	static ExternalsSystemParameterNotFound = 'External system \'{0}\' not found!';
	static Priority = 'Priority';
	static SavingEventDefaultHandlerParameterWasNotSuccessfulConcurrencyError = 'Failed to save default incident handler \'{0}\', because data in the default incident handler has been modified concurrently by another user!';
	static RemoveOpportunityPermanently = 'Remove Opportunity Permanently';
	static DeletingRecordFurtherEducationParameterWasNotSuccessfulConcurrencyError = 'Failed to remove education \'{0}\',  because data in the education has been modified concurrently by another user!';
	static CalendarTasks = 'Events';
	static RemoveRecordUser = 'Remove User Record';
	static UserModuleProperties = 'User Accounts Properties';
	static AddRiskTemplateFromTemplate = 'Add Risk Template from Template';
	static FormModifyDate = 'Modify Date';
	static RiskModuleInfoRiskStakeholders = 'Enable this if you want to link risks and opportunities to stakeholders. Stakeholder information is used in filters and reports.';
	static SavingCompanyGroupParameterWasNotSuccessfulConcurrencyError = 'Failed to save company group \'{0}\', because data in the company group has been modified concurrently by another user!';
	static PositionErrorPermissionDenied = 'Application does not have permission to read location.';
	static DeletingMessageParameterWasNotSuccessfulConcurrencyError = 'Failed to remove message \'{0}\', because data in the message has been modified concurrently by another user!';
	static TitleMustBeDefined = 'Title must be defined!';
	static FormulaAddition = 'Addition';
	static UserLastNameMustBeDefined = 'User surname must be defined!';
	static SavingWhistleBlowCategoryParameterWasNotSuccessfulConcurrencyError = 'Failed to save whistle blow category \'{0}\', because data in the whistle blow category has been modified concurrently by another user!';
	static RiskParameterNotFound = 'Risk \'{0}\' not found!';
	static RemovingWhistleBlowHandlersWasSuccessful = 'Handlers removed successfully!';
	static ArchivingRiskParameterWasSuccessful = 'Risk \'{0}\' archived successfully!';
	static Restore = 'Restore';
	static DeletingPartnersParameterWasSuccessful = 'Partners \'{0}\' removed successfully!';
	static No = 'No';
	static AdminMustBeDefinedForSectionParameter = 'Administrator must be defined for section \'{0}\'!';
	static Header = 'Header';
	static CompanyModuleProperties = 'Companies Properties';
	static Go = 'Go';
	static RiskImpact1 = 'Insignificant';
	static SavingCompanyParameterWasSuccessful = 'Company \'{0}\' saved successfully!';
	static RiskImpact3 = 'Moderate';
	static RiskImpact2 = 'Minor';
	static RiskImpact5 = 'Catastrophic';
	static AddPartnersParameterWasNotSuccessfulConcurrencyError = 'Failed to add partners \'{0}\', because the data has been modified concurrently by another user!';
	static FurtherEducationGroup = 'Education Group';
	static SavingMessageParameterWasNotSuccessfulErrorParameter = 'Failed to save message \'{0}\'! Error: \'{1}\'';
	static AddingWhistleBlowHandlerWasNotSuccessfulErrorParameter = 'Failed to add handlers! Error: \'{0}\'';
	static DeletingEventUrgencyClassParameterWasSuccessful = 'Urgency class \'{0}\' removed successfully!';
	static TaskTypeParameterIsInUseInParameterTasksAndCannotBeDeleted = 'Form template \'{0}\' is used in {1} forms and cannot be removed!';
	static SavingReportWasNotSuccessfulErrorParameter = 'Failed to save report! Error: \'{0}\'';
	static Partners = 'Partners';
	static AddRecordUserWithoutUserAccount = 'Add user record without user account';
	static VoucherPrefix = 'Voucher Prefix';
	static EmptyTaskTrashBin = 'Empty Form Trash Bin';
	static PreviewPanel = 'Preview';
	static FirstListRow = 'First List Row';
	static SomeWhistleBlowHandlersHaveReadMessage = 'Some whistle blow report handlers have read your message';
	static SelectEventTypeB = 'Select Category 2';
	static UnpublishingReportParameterWasSuccessful = 'Report \'{0}\' unpublished successfully!';
	static EditReport = 'Edit Report';
	static PanelSize4 = '2 x 2';
	static AddEventHandler = 'Add Handler';
	static Theme = 'Theme';
	static UpdatingDatabase = 'Updating database...';
	static EditRiskAssessment = 'Edit Assessment';
	static CompanyCodeIsAlreadyInUse = 'Code of the company is already in use!';
	static FileParameterIsEmpty = 'File \'{0}\' is empty!';
}
// ReSharper restore InconsistentNaming
